import { FaGavel , FaCalculator ,FaUniversity, FaServer, FaUsers, FaTruck, FaShoppingCart,FaTshirt, FaCar, FaHeartbeat, 
           FaGraduationCap, FaHandsHelping,FaIndustry,  FaConciergeBell, FaSuitcaseRolling,  FaBuilding} from "react-icons/fa";
import {FaLaptopCode,FaTooth, FaDumbbell,FaTools, FaSeedling,FaPalette, FaFilm, FaUtensils,} from "react-icons/fa";

const industries = [
 {
  id: 1,
  title: "Legal",
  slug: "legal",
  segment: "Professional Services",
  summary:
    "We help law firms and solo attorneys build credibility, attract high-intent clients, and streamline intake with conversion-focused websites, local SEO, compliant lead gen, and secure client portals.",
  icon: {
    
    reactIcons: FaGavel,
    lucide: "Scale"
  },
  brand: {
    color: "#1F4E79",
    accent: "#E0B356",
    gradient: "linear-gradient(135deg, #1F4E79 0%, #102A43 100%)"
    
  },

  hero: {
    headline: "Build Trust. Win Cases. Grow Your Law Firm.",
    subheadline:
      "Conversion-ready legal websites, local SEO, and secure intake systems designed to bring qualified clients to your practice.",
    highlights: [
      { label: "Avg. Lead Uplift", value: "2.4x" },
      { label: "PageSpeed", value: "90+ Lighthouse" },
      { label: "Intake Automations", value: "12+" }
    ],
    primaryButton: { label: "Get a Free Strategy Call", href: "/contact?src=legal" },
    secondaryButton: { label: "See Work & Results", href: "/case-studies?industry=legal" },
    badge: "For Law Firms & Solo Practitioners"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1521790361543-f645cf042ec4?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Courtroom bench with scales of justice and law books",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1555375771-14b2f1df4e86?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Attorney consulting a client in office"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1528747045269-390fe33c19d8?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Law library shelves with leather-bound books"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Team of legal professionals planning strategy"
  //     }
  //   ]
  // },

  painPoints: [
    "High competition on local search for practice-area keywords.",
    "Inefficient client intake and missed inquiries after hours.",
    "Low trust signals (few reviews, thin attorney bios, lack of case results).",
    "Slow, outdated sites that underperform on mobile.",
    "Compliance and data-privacy concerns for forms and documents.",
    "Difficulty tracking ROI across calls, forms, and chats."
  ],

  solutions: {
    websiteExperience: [
      "Authority-focused site architecture by practice area (e.g., Family, Corporate, Criminal, IP).",
      "Attorney & team profiles with credentials, bar numbers, awards, and associations.",
      "Case results, testimonials, and FAQs to reduce friction and boost trust.",
      "Fast, accessible, mobile-first UX with 90+ Lighthouse and Core Web Vitals."
    ],
    marketingGrowth: [
      "Local SEO: Google Business Profile optimization, map pack strategy, reviews engine.",
      "High-intent PPC for practice-area keywords with call-only variants and ad extensions.",
      "Content marketing: topical clusters (FAQs, statutes, processes) and E-E-A-T signals.",
      "Retargeting via display and social to recapture comparison shoppers."
    ],
    operations: [
      "Secure intake forms with file uploads, e-sign triggers, and calendar booking.",
      "Call tracking, form attribution, and CRM pipelines by practice area.",
      "Automated follow-ups: SMS/email sequences for missed calls and new inquiries.",
      "Role-based dashboards for partners, associates, and intake staff."
    ],
    compliancePrivacy: [
      "HTTPS, TLS, WAF, DDoS protection, spam filtering, and encrypted at-rest storage.",
      "Cookie consent + privacy policy, data-retention controls.",
      "Least-privilege access and audit logs for intake data.",
      "Backups and disaster recovery playbooks."
    ]
  },

  services: [
    {
      title: "Legal Website Design & Development",
      description:
        "Authority-driven, conversion-optimized websites crafted for legal credibility and lead generation.",
      deliverables: [
        "Practice-area landing pages",
        "Attorney bios & credentials",
        "Case results & testimonials",
        "Secure intake forms & booking",
        "Blog/Insights hub",
        "Accessibility (WCAG 2.2 AA)"
      ],
      icon: "FaBalanceScale",
      duration: "4–8 weeks",
      startingPriceINR: 150000
    },
    {
      title: "Local SEO for Law Firms",
      description:
        "Rank in the map pack and organic results for your practice areas and service locations.",
      deliverables: [
        "Google Business Profile optimization",
        "Citation management & NAP consistency",
        "Review generation system",
        "On-page & internal linking",
        "Schema markup (LegalService, FAQ, HowTo)"
      ],
      icon: "FaSearchLocation",
      duration: "Ongoing (3–6 months to compounding)",
      startingPriceINR: 40000
    },
    {
      title: "Legal PPC (Search & Call-Only)",
      description:
        "High-intent ads for keywords like 'divorce lawyer near me' with call-tracking and ROI visibility.",
      deliverables: [
        "Keyword & negative list strategy",
        "Ad copy & extensions",
        "Conversion tracking (calls/forms/chats)",
        "Landing pages & A/B testing",
        "Weekly performance reports"
      ],
      icon: "FaBullseye",
      duration: "Ongoing (monthly)",
      startingPriceINR: 35000
    },
    {
      title: "Content & Thought Leadership",
      description:
        "Demonstrate expertise with FAQs, guides, and jurisdiction-specific explainers that build E-E-A-T.",
      deliverables: [
        "Topic clusters & content calendar",
        "Attorney-bylined articles",
        "Case study and result pages",
        "Internal linking & schema",
        "Repurposing for social & email"
      ],
      icon: "FaPenFancy",
      duration: "Ongoing (monthly)",
      startingPriceINR: 30000
    },
    {
      title: "Secure Intake & CRM Automation",
      description:
        "Never miss a lead: unified intake with alerts, automated follow-ups, and pipeline tracking.",
      deliverables: [
        "Secure forms with file upload",
        "Calendar & e-sign triggers",
        "SMS/email sequences for no-shows",
        "Pipeline & stage automations",
        "Attribution dashboards"
      ],
      icon: "FaUserShield",
      duration: "2–4 weeks",
      startingPriceINR: 60000
    }
  ],

  features: {
    mustHave: [
      "Practice-area pages with FAQs and trust badges",
      "Attorney/team profiles with credentials",
      "Map, directions, service areas, and hours",
      "Click-to-call, WhatsApp, and instant callback",
      "Secure intake with document upload"
    ],
    niceToHave: [
      "Live chat or chatbot with screening",
      "Client portal for document sharing",
      "Multilingual content (EN/BN/HI as needed)",
      "Video explainers and walkthroughs",
      "Knowledge base with filters and search"
    ]
  },

  integrations: [
    { name: "Google Business Profile", category: "Local SEO" },
    { name: "CallRail / PhonPe Trackers", category: "Call Tracking" },
    { name: "HubSpot / Zoho CRM / Clio Manage", category: "CRM" },
    { name: "Calendly / Cal.com", category: "Scheduling" },
    { name: "Razorpay / Stripe", category: "Payments & Retainers" },
    { name: "SendGrid / Brevo", category: "Email & SMTP" },
    { name: "Twilio / WhatsApp Business API", category: "SMS/WhatsApp" },
    { name: "Google Analytics 4 + Consent Mode", category: "Analytics" },
    { name: "Cloudflare", category: "Security & CDN" }
  ],

  techStack: {
    frontend: ["Next.js (React)", "Tailwind CSS", "Framer Motion"],
    backend: ["Node.js", "Express or NestJS"],
    cms: ["Sanity", "Strapi"],
    database: ["PostgreSQL", "MongoDB"],
    search: ["Algolia (optional)"],
    hosting: ["Vercel", "AWS"],
    analytics: ["GA4", "GTM", "PostHog (optional)"],
    testing: ["Playwright", "Lighthouse CI"],
    formsSecurity: ["reCAPTCHA v3", "Honeypots", "WAF rules"]
  },

  process: [
    {
      step: 1,
      title: "Discovery & Positioning",
      duration: "3–5 days",
      outputs: ["Practice taxonomy", "Value proposition", "KPI plan"]
    },
    {
      step: 2,
      title: "Information Architecture & Wireframes",
      duration: "1–2 weeks",
      outputs: ["Sitemap", "Wireframes", "Content outline"]
    },
    {
      step: 3,
      title: "Design System & UI",
      duration: "1–2 weeks",
      outputs: ["UI kit", "Component library", "Mobile-first screens"]
    },
    {
      step: 4,
      title: "Development & Integrations",
      duration: "2–3 weeks",
      outputs: ["Responsive pages", "CMS & CRM", "Automations"]
    },
    {
      step: 5,
      title: "SEO, Content & Launch",
      duration: "1 week",
      outputs: ["On-page SEO", "Schema", "QA & Lighthouse >90"]
    },
    {
      step: 6,
      title: "Growth & Optimization",
      duration: "Ongoing",
      outputs: ["A/B tests", "Content cadence", "Monthly reports"]
    }
  ],

  kpis: [
    "Qualified lead volume (calls/forms/chats) per practice area",
    "Cost per qualified lead (PPC + organic blended)",
    "First response time and booking rate",
    "Local rankings (map pack, organic) for target queries",
    "PageSpeed/Core Web Vitals and mobile UX scores"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Solo or small practice",
      priceINR: 120000,
      timeline: "3–4 weeks",
      includes: [
        "5–7 pages (Home, About, 3 Practice Areas, Contact)",
        "Secure intake form + WhatsApp",
        "On-page SEO & basic schema",
        "Google Business Profile setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Small–Mid Law Firm",
      priceINR: 220000,
      timeline: "5–7 weeks",
      includes: [
        "10–15 pages + Blog",
        "Local SEO + review engine",
        "CRM pipeline + call tracking",
        "Monthly performance report (3 months)"
      ]
    },
    {
      tier: "Scale",
      audience: "Multi-location firm",
      priceINR: 380000,
      timeline: "7–10 weeks",
      includes: [
        "20+ pages with multilingual support",
        "Advanced PPC & landing pages",
        "Client portal + e-sign triggers",
        "Content program & monthly CRO"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Raj & Associates (Family Law)",
      location: "Kolkata",
      goals: ["Increase consult bookings", "Reduce no-shows"],
      outcomes: [
        "Leads up 2.8× in 90 days",
        "Map pack Top-3 for 7 core terms",
        "No-shows down 34% via SMS reminders"
      ],
      stack: ["Next.js", "Sanity", "HubSpot", "Call tracking"]
    }
  ],

  testimonials: [
    {
      author: "Adv. Priya Mehta",
      role: "Partner, PM Legal",
      quote:
        "They transformed our intake. We respond faster, rank locally, and our bookings have doubled without adding staff."
    }
  ],

  faqs: [
    {
      q: "How long does a legal website project take?",
      a: "Most firms launch in 4–8 weeks depending on scope, content readiness, and integrations."
    },
    {
      q: "Can you migrate my existing content and preserve SEO?",
      a: "Yes. We redirect legacy URLs, map keywords, carry over schema, and protect rankings during the move."
    },
    {
      q: "Do you support multilingual sites?",
      a: "Yes. We can deliver multilingual setups (e.g., English, Bengali, Hindi) with proper hreflang and localized SEO."
    },
    {
      q: "Is my client data secure?",
      a: "We use HTTPS/TLS, hardened servers, role-based access, encrypted storage, and audit logs. Forms use anti-spam and WAF rules."
    },
    {
      q: "How do you measure success?",
      a: "We track qualified leads (calls, forms, chats), booking rates, local rankings, cost per lead, and site performance."
    },
    {
      q: "Do you provide content writing for legal topics?",
      a: "Yes. We produce attorney-reviewed content aligned with jurisdictional nuances and practice-area search intent."
    },
    {
      q: "What budgets should we plan for ads?",
      a: "For competitive metros, many firms start ₹40k–₹1.2L/month on PPC and scale once cost-per-lead targets are met."
    },
    {
      q: "Will you manage reviews and Google Business Profile?",
      a: "Yes. We implement a compliant review engine, monitor GBP, and optimize to win the map pack."
    }
  ],

  cta: {
    title: "Ready to attract more qualified clients?",
    text:
      "Let’s craft a legal marketing engine that combines trust, speed, and measurable growth.",
    primaryButton: { label: "Book Your Strategy Call", href: "/contact?plan=strategy" },
    secondaryButton: { label: "Download Legal Website Checklist", href: "/resources/legal-website-checklist.pdf" }
  },

  seo: {
    metaTitle: "Legal Marketing & Law Firm Websites | High-Intent Leads & Secure Intake",
    metaDescription:
      "Law firm websites, local SEO, PPC, and secure intake systems. Faster sites, more consults, measurable ROI. For solo attorneys and multi-location firms.",
    keywords: [
      "law firm website design",
      "legal marketing",
      "local SEO for lawyers",
      "attorney lead generation",
      "secure client intake"
    ],
    canonical: "https://merndigital.com/industries/legal",
    og: {
      title: "Grow Your Law Firm with High-Intent Leads",
      description:
        "Conversion-ready legal websites, local SEO, and secure intake to win more cases.",
      // image:
      //   "https://images.unsplash.com/photo-1521790361543-f645cf042ec4?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    // you can JSON.stringify() this for <script type="application/ld+json">
    organization: {
      "@context": "https://schema.org",
      "@type": "LegalService",
      name: "Mern Digital — Legal Marketing",
      url: "https://merndigital.com/industries/legal",
      areaServed: "IN",
      // image:"https://images.unsplash.com/photo-1521790361543-f645cf042ec4?q=80&w=1200&auto=format&fit=crop",
      sameAs: ["https://www.google.com/maps", "https://www.linkedin.com/company/merndigital"]
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long does a legal website project take?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Most firms launch in 4–8 weeks depending on scope, content readiness, and integrations."
          }
        },
        {
          "@type": "Question",
          name: "Do you support multilingual sites?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes. We can deliver multilingual setups with proper hreflang and localized SEO."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/legal",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Legal",
        "item":"https://merndigital.com/industries/legal"
      }]
    }
  },

  localization: {
    languages: ["en", "bn", "hi"],
    default: "en"
  }
 }  ,
 {
  id: 2,
  title: "Consulting & Accounting",
  slug: "consulting-accounting",
  segment: "Professional Services",
  summary:
    "We help consulting and accounting firms build authority, streamline client acquisition, and modernize operations with credibility-focused websites, lead generation, and client portals.",
  icon: {
    reactIcons: FaCalculator, // you can swap with FaChartPie or similar
    lucide: "LineChart"
  },
  brand: {
    color: "#0B3D2E",
    accent: "#F5B041",
    gradient: "linear-gradient(135deg, #0B3D2E 0%, #052219 100%)",
   
  },

  hero: {
    headline: "Build Trust. Win Clients. Scale Your Firm.",
    subheadline:
      "High-performing websites, local SEO, and client management systems that help consulting and accounting firms attract and retain more clients.",
    highlights: [
      { label: "Avg. Client Growth", value: "2.1x" },
      { label: "PageSpeed", value: "95+ Lighthouse" },
      { label: "Automations", value: "15+" }
    ],
    primaryButton: { label: "Get a Free Consultation", href: "/contact?src=consulting-accounting" },
    secondaryButton: { label: "See Client Success Stories", href: "/case-studies?industry=consulting-accounting" },
    badge: "For Consulting & Accounting Firms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1554224154-22dec7ec8818?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Team analyzing financial reports and business charts",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1556742400-b5e8c9f2a9dd?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Accountants reviewing tax documents"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521791055366-0d553872125f?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Consultants brainstorming strategies"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Financial advisor presenting charts to clients"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty standing out in a crowded advisory market.",
    "Low visibility in local searches for accounting and consulting services.",
    "Manual, outdated processes for client onboarding and billing.",
    "Lack of client trust due to poor online presence.",
    "Difficulty tracking ROI and client acquisition sources.",
    "Compliance and data security concerns with financial information."
  ],

  solutions: {
    websiteExperience: [
      "Professional firm websites highlighting services like tax, audit, advisory, and consulting.",
      "Team bios with certifications (CA, CPA, CFA, MBA).",
      "Case studies, testimonials, and success metrics for credibility.",
      "Fast, mobile-first UX optimized for conversions."
    ],
    marketingGrowth: [
      "Local SEO for consulting & accounting services with Google Business Profile optimization.",
      "Targeted PPC campaigns for services like 'tax consultant near me' or 'business advisory'.",
      "Content marketing: tax guides, compliance FAQs, business growth blogs.",
      "Email newsletters and LinkedIn campaigns for thought leadership."
    ],
    operations: [
      "Client intake and onboarding portals with secure document upload.",
      "Automated billing and payment reminders.",
      "CRM integration for client management and renewals.",
      "Analytics dashboards for client acquisition and retention."
    ],
    compliancePrivacy: [
      "Secure hosting with encryption, TLS, and GDPR compliance.",
      "Encrypted document storage and role-based access.",
      "Regular backups and disaster recovery.",
      "Cookie consent, audit logs, and compliance certifications."
    ]
  },

  services: [
    {
      title: "Consulting & Accounting Website Design",
      description:
        "Build trust with authority-driven, conversion-ready websites tailored for advisory and accounting firms.",
      deliverables: [
        "Service landing pages (Tax, Audit, Advisory, Consulting)",
        "Team bios with certifications",
        "Case studies & testimonials",
        "Secure intake & document portals",
        "Blog & resources hub",
        "Accessibility compliance"
      ],
      icon: "FaChartLine",
      duration: "4–6 weeks",
      startingPriceINR: 130000
    },
    {
      title: "Local SEO & Review Management",
      description:
        "Get discovered by local businesses and individuals searching for consulting and accounting services.",
      deliverables: [
        "Google Business Profile optimization",
        "Citation and directory management",
        "Review request engine",
        "On-page SEO and schema markup"
      ],
      icon: "FaSearchDollar",
      duration: "Ongoing (3–6 months to compounding)",
      startingPriceINR: 35000
    },
    {
      title: "Consulting PPC & LinkedIn Ads",
      description:
        "Target decision-makers with high-intent keywords and LinkedIn campaigns designed to generate leads.",
      deliverables: [
        "Keyword and audience targeting",
        "Ad copy & creative",
        "Conversion-focused landing pages",
        "Call & form tracking",
        "Performance dashboards"
      ],
      icon: "FaBullhorn",
      duration: "Ongoing (monthly)",
      startingPriceINR: 40000
    },
    {
      title: "Content & Thought Leadership",
      description:
        "Showcase expertise through tax guides, whitepapers, and financial advisory content aligned with client needs.",
      deliverables: [
        "Content strategy & topic clusters",
        "Articles & compliance guides",
        "Client case studies",
        "Repurposed content for LinkedIn & email"
      ],
      icon: "FaBookOpen",
      duration: "Ongoing (monthly)",
      startingPriceINR: 30000
    },
    {
      title: "Client Portal & Automation",
      description:
        "Modernize client experience with secure portals, automated reminders, and integrated payments.",
      deliverables: [
        "Secure document upload & storage",
        "Automated invoicing & reminders",
        "E-signature integrations",
        "CRM & pipeline tracking",
        "Performance reporting"
      ],
      icon: "FaLock",
      duration: "2–4 weeks",
      startingPriceINR: 70000
    }
  ],

  features: {
    mustHave: [
      "Service landing pages with trust signals",
      "Team profiles with certifications",
      "Secure client document portal",
      "Click-to-call & WhatsApp integration",
      "Tax & compliance guides for lead capture"
    ],
    niceToHave: [
      "Client dashboards with KPIs",
      "Chatbot for appointment booking",
      "Multilingual support (EN/BN/HI)",
      "Video explainers for tax & audit",
      "Knowledge base & whitepapers"
    ]
  },

  integrations: [
    { name: "Google Business Profile", category: "Local SEO" },
    { name: "QuickBooks / Zoho Books / Tally", category: "Accounting" },
    { name: "HubSpot / Zoho CRM / Salesforce", category: "CRM" },
    { name: "Calendly / MS Bookings", category: "Scheduling" },
    { name: "Razorpay / Stripe", category: "Payments" },
    { name: "SendGrid / Brevo", category: "Email Marketing" },
    { name: "Twilio / WhatsApp Business API", category: "Client Communication" },
    { name: "Google Analytics 4 + Consent Mode", category: "Analytics" },
    { name: "Cloudflare", category: "Security & CDN" }
  ],

  techStack: {
    frontend: ["Next.js (React)", "Tailwind CSS", "Framer Motion"],
    backend: ["Node.js", "Express or NestJS"],
    cms: ["Sanity", "Strapi"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["Vercel", "AWS"],
    analytics: ["GA4", "GTM", "PostHog"],
    formsSecurity: ["reCAPTCHA v3", "Honeypots", "WAF rules"]
  },

  process: [
    { step: 1, title: "Discovery & Planning", duration: "3–5 days", outputs: ["Service taxonomy", "Value proposition", "KPI plan"] },
    { step: 2, title: "Information Architecture", duration: "1–2 weeks", outputs: ["Sitemap", "Wireframes", "Content outline"] },
    { step: 3, title: "Design & Branding", duration: "1–2 weeks", outputs: ["UI kit", "Component library", "Responsive screens"] },
    { step: 4, title: "Development & Integrations", duration: "2–3 weeks", outputs: ["Pages", "CRM & Portal", "Automations"] },
    { step: 5, title: "SEO & Launch", duration: "1 week", outputs: ["SEO", "Schema", "QA & Lighthouse >90"] },
    { step: 6, title: "Growth & Optimization", duration: "Ongoing", outputs: ["Monthly reports", "A/B testing", "Content scaling"] }
  ],

  kpis: [
    "Qualified lead volume (calls/forms/portal signups)",
    "Cost per qualified lead (SEO + PPC blended)",
    "First response time & booking rate",
    "Local rankings for accounting & consulting terms",
    "Client portal adoption & usage metrics"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small practice or solo consultant",
      priceINR: 110000,
      timeline: "3–4 weeks",
      includes: [
        "5–7 pages (Home, About, Services, Team, Contact)",
        "Basic SEO setup",
        "Secure client intake form",
        "Google Business Profile setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized consulting/accounting firm",
      priceINR: 210000,
      timeline: "5–7 weeks",
      includes: [
        "10–15 pages + Blog",
        "Local SEO + review engine",
        "CRM integration + call tracking",
        "Monthly performance reporting (3 months)"
      ]
    },
    {
      tier: "Scale",
      audience: "Multi-location or enterprise firm",
      priceINR: 360000,
      timeline: "7–10 weeks",
      includes: [
        "20+ pages with multilingual support",
        "Advanced PPC & LinkedIn ads",
        "Client portal & e-sign integrations",
        "Content program & CRO optimization"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Veritas Advisory (Business Consulting)",
      location: "Mumbai",
      goals: ["Increase SME client acquisition", "Improve portal adoption"],
      outcomes: [
        "2.4× lead growth in 6 months",
        "Top 3 local ranking for 8 core services",
        "Client onboarding time reduced by 45%"
      ],
      stack: ["Next.js", "Zoho Books", "HubSpot", "GA4"]
    }
  ],

  testimonials: [
    {
      author: "CA Rohan Sharma",
      role: "Partner, RS & Co.",
      quote:
        "Our website now reflects the professionalism of our practice. The client portal and automation saved us countless hours and doubled our leads."
    }
  ],

  faqs: [
    {
      q: "How long does it take to launch a consulting/accounting website?",
      a: "Most firms go live in 4–6 weeks, depending on content readiness and integrations."
    },
    {
      q: "Do you support secure client portals?",
      a: "Yes. We provide encrypted client portals for document sharing, billing, and collaboration."
    },
    {
      q: "Will you handle SEO and review management?",
      a: "Yes. We implement local SEO, structured schema, and review systems to boost visibility."
    },
    {
      q: "Is client data safe?",
      a: "We use HTTPS/TLS, encrypted storage, WAF protection, and audit logs to ensure compliance and security."
    },
    {
      q: "Do you provide content creation?",
      a: "Yes. We create tax guides, business advisory content, and thought-leadership blogs tailored for your services."
    }
  ],

  cta: {
    title: "Ready to grow your consulting or accounting firm?",
    text:
      "Let’s build a modern digital presence that attracts clients, streamlines operations, and builds long-term trust.",
    primaryButton: { label: "Book a Free Strategy Session", href: "/contact?plan=consulting" },
    secondaryButton: { label: "Download Accounting Website Checklist", href: "/resources/accounting-website-checklist.pdf" }
  },

  seo: {
    metaTitle: "Consulting & Accounting Websites | Digital Growth & Client Portals",
    metaDescription:
      "Websites, SEO, PPC, and client portals for consulting and accounting firms. Attract more clients, secure data, and streamline operations.",
    keywords: [
      "accounting firm website design",
      "consulting websites",
      "local SEO for accountants",
      "client portal for consulting firms",
      "digital marketing for accountants"
    ],
    canonical: "https://merndigital.com/industries/consulting-accounting",
    og: {
      title: "Grow Your Consulting & Accounting Firm",
      description:
        "Websites, SEO, PPC, and client portals to win clients and streamline operations.",
      // image:"https://images.unsplash.com/photo-1554224154-22dec7ec8818?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "AccountingService",
      name: "Mern Digital — Consulting & Accounting Solutions",
      url: "https://merndigital.com/industries/consulting-accounting",
      areaServed: "IN",
      // image:"https://images.unsplash.com/photo-1554224154-22dec7ec8818?q=80&w=1200&auto=format&fit=crop",
      sameAs: ["https://www.google.com/maps", "https://www.linkedin.com/company/merndigital"]
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "How long does it take to launch a consulting/accounting website?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Most firms launch in 4–6 weeks depending on content readiness and integrations."
          }
        },
        {
          "@type": "Question",
          name: "Do you support secure client portals?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes. We provide encrypted client portals for document sharing, billing, and collaboration."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/consulting-accounting",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Consulting & Accounting",
        "item":"https://merndigital.com/industries/consulting-accounting"
      }]
    }
  },

  localization: {
    languages: ["en", "bn", "hi"],
    default: "en"
  }
},
{
  id: 3,
  title: "Financial Services",
  slug: "financial-services",
  segment: "Professional Services",
  summary:
    "We empower financial advisors, wealth managers, and fintech providers with secure, conversion-focused websites, client portals, and digital marketing strategies to build trust and scale growth.",
  icon: {
    reactIcons: FaUniversity, // can swap with FaPiggyBank or FaMoneyCheckAlt
    lucide: "Banknote"
  },
  brand: {
    color: "#002244",
    accent: "#FFD700",
    gradient: "linear-gradient(135deg, #002244 0%, #001122 100%)",
    
  },

  hero: {
    headline: "Build Trust. Grow Assets. Win Clients.",
    subheadline:
      "High-performing websites, secure portals, and marketing strategies that help financial service providers attract investors, clients, and long-term partnerships.",
    highlights: [
      { label: "Avg. Lead Growth", value: "2.5x" },
      { label: "Data Security", value: "Bank-Grade" },
      { label: "Automation Savings", value: "30+ hrs/month" }
    ],
    primaryButton: { label: "Get a Free Strategy Call", href: "/contact?src=financial-services" },
    secondaryButton: { label: "See Client Success Stories", href: "/case-studies?industry=financial-services" },
    badge: "For Financial Advisors, Wealth Managers & Fintechs"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1523289333742-be1143f6b766?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Financial advisor analyzing market performance with clients",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1522205161898-98b6f10c7c97?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Investor meeting with financial planner"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521791136064-7986c2920216?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Wealth manager presenting growth charts"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1556742400-b5e8c9f2a9dd?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Financial services team reviewing portfolios"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty earning client trust without a strong digital presence.",
    "Low visibility for high-value financial keywords in search results.",
    "Complex client onboarding and compliance-heavy processes.",
    "Manual portfolio updates and client reporting.",
    "High acquisition costs due to ineffective digital campaigns.",
    "Security and compliance risks around sensitive financial data."
  ],

  solutions: {
    websiteExperience: [
      "Premium websites tailored for financial advisors, investment firms, and fintechs.",
      "Trust-building elements: certifications, licenses, and regulatory disclosures.",
      "Case studies, client testimonials, and market insights hub.",
      "Mobile-first, conversion-optimized designs."
    ],
    marketingGrowth: [
      "SEO for high-value terms like 'wealth manager near me' or 'retirement planning services'.",
      "PPC campaigns targeting investment and financial planning keywords.",
      "Content marketing: market insights, investment guides, and whitepapers.",
      "LinkedIn campaigns to attract HNIs and corporate clients."
    ],
    operations: [
      "Secure client portals for portfolio access and reporting.",
      "Automated client onboarding and KYC workflows.",
      "CRM integrations for client lifecycle management.",
      "Performance dashboards for ROI and retention tracking."
    ],
    compliancePrivacy: [
      "Bank-grade hosting with encryption, TLS, and SOC 2 compliance.",
      "Secure document storage with role-based access.",
      "Audit-ready logs and data residency controls.",
      "Cookie consent, GDPR/SEBI/FINRA aligned policies."
    ]
  },

  services: [
    {
      title: "Financial Services Website Design",
      description:
        "Build authority with credibility-driven websites optimized for lead generation and regulatory compliance.",
      deliverables: [
        "Service & solution landing pages",
        "Team bios with licenses & certifications",
        "Case studies & testimonials",
        "Investor education hub",
        "Secure client portals",
        "Regulatory compliance pages"
      ],
      icon: "FaGlobe",
      duration: "5–7 weeks",
      startingPriceINR: 150000
    },
    {
      title: "SEO for Financial Advisors",
      description:
        "Rank for competitive wealth management and investment terms with advanced on-page and local SEO.",
      deliverables: [
        "High-value keyword targeting",
        "Local & national SEO optimization",
        "Review and reputation management",
        "Schema & structured data implementation"
      ],
      icon: "FaSearch",
      duration: "Ongoing (4–6 months to compounding)",
      startingPriceINR: 40000
    },
    {
      title: "Financial PPC & LinkedIn Campaigns",
      description:
        "Reach high-net-worth clients and investors through targeted ad campaigns with optimized funnels.",
      deliverables: [
        "Keyword/audience targeting",
        "Ad creatives and copywriting",
        "Landing page design",
        "Conversion tracking dashboards"
      ],
      icon: "FaBullhorn",
      duration: "Ongoing (monthly)",
      startingPriceINR: 50000
    },
    {
      title: "Thought Leadership Content",
      description:
        "Establish authority with market insights, investment reports, and client-focused educational content.",
      deliverables: [
        "Content strategy",
        "Whitepapers & investment guides",
        "Client case studies",
        "Repurposed content for email & LinkedIn"
      ],
      icon: "FaBook",
      duration: "Ongoing (monthly)",
      startingPriceINR: 35000
    },
    {
      title: "Client Portal & Compliance Solutions",
      description:
        "Modernize financial operations with secure portals, automation, and compliance-ready systems.",
      deliverables: [
        "Secure investor portal",
        "Automated KYC & onboarding",
        "E-signature integrations",
        "Portfolio performance dashboards"
      ],
      icon: "FaLock",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    }
  ],

  features: {
    mustHave: [
      "Regulatory-compliant service pages",
      "Team credentials & licenses",
      "Secure investor/client portal",
      "Market insights/blog hub",
      "WhatsApp/Click-to-call integration"
    ],
    niceToHave: [
      "Investment calculators",
      "Chatbot for lead qualification",
      "Multilingual support",
      "Video explainers on investment strategies",
      "Downloadable research reports"
    ]
  },

  integrations: [
    { name: "Google Business Profile", category: "Local SEO" },
    { name: "Salesforce / Zoho CRM / HubSpot", category: "CRM" },
    { name: "QuickBooks / Zoho Books", category: "Finance" },
    { name: "DocuSign / Adobe Sign", category: "E-signatures" },
    { name: "Stripe / Razorpay", category: "Payments" },
    { name: "Brevo / Mailchimp", category: "Email Marketing" },
    { name: "Twilio / WhatsApp Business", category: "Client Communication" },
    { name: "GA4 + Consent Mode", category: "Analytics" },
    { name: "Cloudflare", category: "Security" }
  ],

  techStack: {
    frontend: ["Next.js (React)", "Tailwind CSS", "Framer Motion"],
    backend: ["Node.js", "NestJS"],
    cms: ["Sanity", "Strapi"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["Vercel", "AWS"],
    analytics: ["GA4", "PostHog", "GTM"],
    formsSecurity: ["reCAPTCHA v3", "WAF", "Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Compliance Review", duration: "1 week", outputs: ["Compliance requirements", "Service taxonomy", "KPI roadmap"] },
    { step: 2, title: "Information Architecture", duration: "1–2 weeks", outputs: ["Sitemap", "Wireframes", "Compliance pages"] },
    { step: 3, title: "Design & Branding", duration: "1–2 weeks", outputs: ["UI Kit", "Responsive layouts", "Investor trust signals"] },
    { step: 4, title: "Development & Integrations", duration: "2–3 weeks", outputs: ["Pages", "CRM & Portal", "Automation"] },
    { step: 5, title: "SEO & Launch", duration: "1 week", outputs: ["SEO setup", "Schema", "QA & Lighthouse >90"] },
    { step: 6, title: "Growth & Optimization", duration: "Ongoing", outputs: ["Reports", "A/B tests", "Content scaling"] }
  ],

  kpis: [
    "Qualified investor/lead volume",
    "Conversion rate from campaigns",
    "Client onboarding time reduction",
    "SEO rankings for wealth/investment terms",
    "Client portal adoption & usage"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Independent financial advisor",
      priceINR: 120000,
      timeline: "4–5 weeks",
      includes: [
        "5–7 pages (Home, About, Services, Contact)",
        "Basic SEO setup",
        "Compliance-ready disclosures",
        "Google Business Profile setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Small to mid-sized financial firm",
      priceINR: 230000,
      timeline: "6–8 weeks",
      includes: [
        "10–15 pages + Blog",
        "Local SEO & review management",
        "Client portal integration",
        "3 months reporting & optimization"
      ]
    },
    {
      tier: "Scale",
      audience: "Wealth management or fintech enterprise",
      priceINR: 380000,
      timeline: "8–10 weeks",
      includes: [
        "20+ pages with calculators & reports",
        "Advanced PPC & LinkedIn campaigns",
        "Secure investor portal & automation",
        "Multilingual support & CRO program"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Shakti Wealth Advisory",
      location: "Delhi",
      goals: ["Boost HNI acquisition", "Enhance digital trust"],
      outcomes: [
        "3× inbound leads in 6 months",
        "Top 5 ranking for 'wealth manager Delhi'",
        "Client onboarding time reduced by 60%"
      ],
      stack: ["Next.js", "Salesforce", "GA4", "DocuSign"]
    }
  ],

  testimonials: [
    {
      author: "Anita Verma",
      role: "Founder, Verma Wealth",
      quote:
        "The secure client portal and professional website gave our firm the credibility it needed. Our lead flow doubled within 4 months."
    }
  ],

  faqs: [
    {
      q: "Do you build compliance-ready financial websites?",
      a: "Yes. We design websites with disclosures, disclaimers, and regulatory compliance for financial services."
    },
    {
      q: "Can you integrate secure investor portals?",
      a: "Absolutely. We provide encrypted, role-based client/investor portals for reporting and communication."
    },
    {
      q: "How do you help attract high-net-worth clients?",
      a: "Through SEO, PPC, and LinkedIn campaigns targeting relevant financial and wealth management search terms."
    },
    {
      q: "Do you support ongoing marketing?",
      a: "Yes. We provide SEO, PPC, content, and thought leadership programs for continuous growth."
    },
    {
      q: "Is client financial data secure?",
      a: "We use encryption, TLS, WAF protection, and compliance frameworks like SOC 2 and GDPR to ensure security."
    }
  ],

  cta: {
    title: "Ready to grow your financial services firm?",
    text:
      "Let’s build a secure, compliant, and growth-focused digital presence that builds trust and attracts investors.",
    primaryButton: { label: "Book a Free Strategy Session", href: "/contact?plan=financial" },
    secondaryButton: { label: "Download Financial Website Checklist", href: "/resources/financial-website-checklist.pdf" }
  },

  seo: {
    metaTitle: "Financial Services Websites | Secure Growth & Client Portals",
    metaDescription:
      "Websites, SEO, PPC, and secure portals for financial advisors and wealth managers. Build trust, attract investors, and streamline operations.",
    keywords: [
      "financial advisor website design",
      "wealth management websites",
      "SEO for financial services",
      "client portal for wealth managers",
      "digital marketing for financial advisors"
    ],
    canonical: "https://merndigital.com/industries/financial-services",
    og: {
      title: "Grow Your Financial Services Firm",
      description:
        "Websites, SEO, PPC, and secure client portals designed to build trust and attract investors.",
      // image:"https://images.unsplash.com/photo-1523289333742-be1143f6b766?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "FinancialService",
      name: "Mern Digital — Financial Services Solutions",
      url: "https://merndigital.com/industries/financial-services",
      areaServed: "IN",
      // image:"https://images.unsplash.com/photo-1523289333742-be1143f6b766?q=80&w=1200&auto=format&fit=crop",
      sameAs: ["https://www.google.com/maps", "https://www.linkedin.com/company/merndigital"]
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you build compliance-ready financial websites?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes. We design websites with disclosures, disclaimers, and regulatory compliance for financial services."
          }
        },
        {
          "@type": "Question",
          name: "Can you integrate secure investor portals?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. We provide encrypted, role-based client/investor portals for reporting and communication."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/financial-services",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Financial Services",
        "item":"https://merndigital.com/industries/financial-services"
      }]
    }
  },

  localization: {
    languages: ["en", "bn", "hi"],
    default: "en"
  }
},
{
  id: 4,
  title: "B2B Software & SaaS",
  slug: "b2b-software-saas",
  segment: "Technology",
  summary:
    "We help SaaS startups and enterprise B2B software providers build conversion-driven websites, onboarding flows, and marketing campaigns that accelerate user acquisition and revenue growth.",
  icon: {
    reactIcons: FaServer, // can swap with FaServer or FaCode
    lucide: "Boxes"
  },
  brand: {
    color: "#2E5CFF",
    accent: "#00D4FF",
    gradient: "linear-gradient(135deg, #2E5CFF 0%, #001F99 100%)",
    
  },

  hero: {
    headline: "Accelerate SaaS Growth with Digital Experiences That Convert",
    subheadline:
      "From high-converting websites to onboarding flows and marketing automation, we empower B2B SaaS and software companies to scale faster.",
    highlights: [
      { label: "Avg. Conversion Uplift", value: "3.2x" },
      { label: "Faster Deployments", value: "40%+" },
      { label: "Marketing ROI", value: "2.8x" }
    ],
    primaryButton: { label: "Schedule a SaaS Growth Audit", href: "/contact?src=b2b-software-saas" },
    secondaryButton: { label: "See SaaS Case Studies", href: "/case-studies?industry=b2b-software-saas" },
    badge: "For SaaS Startups, B2B Platforms & Enterprise Software"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop",
  //   alt: "SaaS team brainstorming user acquisition strategy",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1581090700227-4c4f50a69d83?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Product team working on software UI"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1557804506-669a67965ba0?q=80&w=1600&auto=format&fit=crop",
  //       alt: "SaaS dashboard with analytics and reporting"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1535223289827-42f1e9919769?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Developers discussing cloud infrastructure"
  //     }
  //   ]
  // },

  painPoints: [
    "High churn rates due to poor onboarding experiences.",
    "Difficulty communicating complex B2B value propositions.",
    "Low website conversion rates despite traffic.",
    "Fragmented marketing and sales systems with no clear ROI tracking.",
    "High customer acquisition costs (CAC) with poor retention.",
    "Limited trust and credibility compared to bigger competitors."
  ],

  solutions: {
    websiteExperience: [
      "Conversion-focused websites optimized for B2B SaaS and software sales.",
      "Clear product demos, feature breakdowns, and ROI calculators.",
      "Landing pages for product-led growth campaigns.",
      "Pricing pages designed with tiered comparison and CTA optimization."
    ],
    marketingGrowth: [
      "SEO strategies for high-intent SaaS keywords.",
      "PPC & LinkedIn campaigns targeting decision-makers.",
      "Content marketing: playbooks, case studies, comparison guides.",
      "ABM (Account-Based Marketing) for enterprise SaaS sales."
    ],
    operations: [
      "Marketing automation with HubSpot or Marketo.",
      "CRM and product analytics integrations.",
      "Lead scoring and lifecycle automation.",
      "Subscription and billing integrations."
    ],
    productSuccess: [
      "Onboarding flows that reduce churn.",
      "In-app messaging and walkthroughs.",
      "Customer portals and self-service knowledge bases.",
      "Usage analytics for retention optimization."
    ]
  },

  services: [
    {
      title: "SaaS Website Design & Development",
      description:
        "High-performing websites tailored for software companies to boost lead generation and sign-ups.",
      deliverables: [
        "Landing pages & pricing pages",
        "Product demo sections",
        "Case studies & testimonials",
        "Feature comparison tables",
        "Multi-language support"
      ],
      icon: "FaLaptopCode",
      duration: "5–7 weeks",
      startingPriceINR: 180000
    },
    {
      title: "SEO for SaaS & B2B Software",
      description:
        "Increase visibility and rank for high-intent B2B keywords that drive demos and sign-ups.",
      deliverables: [
        "Keyword research & competitor mapping",
        "Content hub setup (blogs, resources)",
        "Technical SEO optimization",
        "Link building & outreach"
      ],
      icon: "FaSearch",
      duration: "Ongoing (4–6 months to compounding)",
      startingPriceINR: 50000
    },
    {
      title: "SaaS PPC & LinkedIn Campaigns",
      description:
        "Hyper-targeted campaigns to attract B2B buyers and enterprise clients.",
      deliverables: [
        "Google Ads & LinkedIn targeting",
        "Ad copywriting & creatives",
        "Custom landing pages",
        "Conversion optimization"
      ],
      icon: "FaBullhorn",
      duration: "Ongoing (monthly)",
      startingPriceINR: 60000
    },
    {
      title: "Product Onboarding & Retention UX",
      description:
        "Design onboarding flows that reduce churn and boost product adoption.",
      deliverables: [
        "Onboarding checklists",
        "In-app walkthroughs",
        "Email drip sequences",
        "Churn reduction dashboards"
      ],
      icon: "FaRocket",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "ABM & Growth Enablement",
      description:
        "Enterprise-focused campaigns with ABM strategy and marketing automation.",
      deliverables: [
        "Account-based marketing setup",
        "HubSpot/Marketo automation",
        "Lead scoring & segmentation",
        "Sales enablement dashboards"
      ],
      icon: "FaChartLine",
      duration: "Ongoing (quarterly programs)",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Conversion-optimized pricing pages",
      "Feature showcase & comparison",
      "Case studies & social proof",
      "CRM & analytics integration",
      "Chatbots/live chat"
    ],
    niceToHave: [
      "Interactive product demos",
      "ROI calculators",
      "Custom dashboards",
      "Video explainers",
      "AI-powered lead scoring"
    ]
  },

  integrations: [
    { name: "HubSpot / Marketo / Pardot", category: "Marketing Automation" },
    { name: "Salesforce / Zoho CRM", category: "CRM" },
    { name: "Stripe / Chargebee", category: "Billing" },
    { name: "Intercom / Drift", category: "Customer Engagement" },
    { name: "Amplitude / Mixpanel", category: "Analytics" },
    { name: "PostHog", category: "Product Analytics" },
    { name: "Slack / Teams", category: "Collaboration" },
    { name: "GA4 + GTM", category: "Tracking" }
  ],

  techStack: {
    frontend: ["Next.js", "Tailwind CSS", "Framer Motion"],
    backend: ["Node.js", "NestJS"],
    cms: ["Sanity", "Contentful"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["Vercel", "AWS"],
    analytics: ["GA4", "PostHog", "Mixpanel"],
    formsSecurity: ["reCAPTCHA v3", "Encryption", "WAF"]
  },

  process: [
    { step: 1, title: "Discovery & ICP Research", duration: "1 week", outputs: ["ICP profiles", "User journey mapping", "Growth KPIs"] },
    { step: 2, title: "Information Architecture", duration: "1–2 weeks", outputs: ["Sitemap", "Wireframes", "User flows"] },
    { step: 3, title: "Design & UX", duration: "1–2 weeks", outputs: ["UI Kit", "Landing page designs", "Pricing page layouts"] },
    { step: 4, title: "Development & Integrations", duration: "2–3 weeks", outputs: ["Pages", "CRM & Automation", "Product analytics"] },
    { step: 5, title: "SEO & Launch", duration: "1 week", outputs: ["SEO setup", "Schema", "QA & Launch"] },
    { step: 6, title: "Growth Optimization", duration: "Ongoing", outputs: ["A/B testing", "Content scaling", "ROI reports"] }
  ],

  kpis: [
    "Demo requests / sign-ups",
    "Website conversion rate",
    "CAC vs LTV ratio",
    "Retention & churn metrics",
    "Pipeline velocity"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Early-stage SaaS startup",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "5–7 core pages (Home, Features, Pricing, About, Contact)",
        "Basic SEO setup",
        "CRM integration",
        "Analytics setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Scaling SaaS company",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "10–15 pages + Blog",
        "SEO & PPC setup",
        "Lead scoring automation",
        "Customer onboarding flows"
      ]
    },
    {
      tier: "Scale",
      audience: "Enterprise B2B SaaS",
      priceINR: 450000,
      timeline: "8–10 weeks",
      includes: [
        "20+ pages + multi-language",
        "ABM campaigns & LinkedIn ads",
        "Advanced automation & integrations",
        "Custom dashboards & analytics"
      ]
    }
  ],

  caseStudies: [
    {
      name: "CloudSync SaaS",
      location: "Bangalore",
      goals: ["Increase sign-ups", "Reduce churn"],
      outcomes: [
        "Sign-ups grew 2.8× in 6 months",
        "Churn reduced by 35% with new onboarding",
        "Ranked top 3 for 'cloud backup SaaS India'"
      ],
      stack: ["Next.js", "HubSpot", "Stripe", "Mixpanel"]
    }
  ],

  testimonials: [
    {
      author: "Rahul Mehta",
      role: "Founder, CloudSync",
      quote:
        "Our SaaS sign-ups doubled within 5 months after the new website and marketing automation. The onboarding flows cut churn dramatically."
    }
  ],

  faqs: [
    {
      q: "Do you specialize in SaaS website design?",
      a: "Yes, we build SaaS-specific websites with conversion-focused design, product showcases, and optimized pricing pages."
    },
    {
      q: "Can you help reduce churn?",
      a: "Absolutely. We design onboarding flows, in-app UX, and retention campaigns that directly reduce churn."
    },
    {
      q: "Do you provide ABM and enterprise SaaS campaigns?",
      a: "Yes. We set up ABM strategies, LinkedIn campaigns, and multi-touch funnels for enterprise SaaS."
    },
    {
      q: "What CRMs and tools do you integrate?",
      a: "We integrate HubSpot, Salesforce, Zoho, Marketo, Chargebee, Stripe, and product analytics tools like Mixpanel or PostHog."
    },
    {
      q: "How fast can you launch a SaaS website?",
      a: "Most SaaS projects launch in 4–6 weeks for Starter tier, with faster sprints possible for MVP launches."
    }
  ],

  cta: {
    title: "Ready to scale your SaaS or B2B software?",
    text:
      "Let’s build a website, onboarding, and marketing engine that accelerates your growth.",
    primaryButton: { label: "Book a Free SaaS Strategy Call", href: "/contact?plan=saas" },
    secondaryButton: { label: "Download SaaS Growth Checklist", href: "/resources/saas-growth-checklist.pdf" }
  },

  seo: {
    metaTitle: "B2B SaaS Websites & Marketing | Drive Sign-ups & Growth",
    metaDescription:
      "We build SaaS websites, onboarding flows, and growth campaigns for B2B software companies. Reduce churn, boost conversions, and scale faster.",
    keywords: [
      "SaaS website design",
      "B2B software marketing",
      "SaaS onboarding UX",
      "SEO for SaaS companies",
      "ABM for B2B SaaS"
    ],
    canonical: "https://merndigital.com/industries/b2b-software-saas",
    og: {
      title: "Grow Your SaaS with Conversion-Focused Design",
      description:
        "Websites, onboarding, and growth marketing for SaaS startups and B2B software.",
      // image:"https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "SoftwareApplication",
      name: "Mern Digital — SaaS & B2B Software Solutions",
      url: "https://merndigital.com/industries/b2b-software-saas",
      applicationCategory: "BusinessApplication",
      operatingSystem: "Web",
      areaServed: "IN",
      // image:"https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1200&auto=format&fit=crop",
      sameAs: ["https://www.linkedin.com/company/merndigital"]
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you specialize in SaaS website design?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, we build SaaS-specific websites with conversion-focused design, product showcases, and optimized pricing pages."
          }
        },
        {
          "@type": "Question",
          name: "Can you help reduce churn?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. We design onboarding flows, in-app UX, and retention campaigns that directly reduce churn."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/b2b-software-saas",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "B2B Software & SaaS",
        "item":"https://merndigital.com/industries/b2b-software-saas"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 5,
  title: "CRM Development",
  slug: "crm-development",
  segment: "Technology",
  summary:
    "We design and develop custom CRM solutions that streamline sales, automate workflows, and centralize customer data—empowering businesses to boost productivity and customer retention.",
  icon: {
    reactIcons: FaUsers, // CRM / operations icon
    lucide: "Database"
  },
  brand: {
    color: "#1E88E5",
    accent: "#00C853",
    gradient: "linear-gradient(135deg, #1E88E5 0%, #004D40 100%)",
    
  },

  hero: {
    headline: "Custom CRM Solutions that Drive Sales & Retention",
    subheadline:
      "From Salesforce integrations to custom-built CRMs, we help businesses manage leads, streamline pipelines, and scale customer success.",
    highlights: [
      { label: "Faster Sales Cycles", value: "2.5x" },
      { label: "Manual Work Reduced", value: "60%" },
      { label: "Customer Retention", value: "+35%" }
    ],
    primaryButton: { label: "Book a CRM Strategy Call", href: "/contact?src=crm-development" },
    secondaryButton: { label: "See CRM Case Studies", href: "/case-studies?industry=crm-development" },
    badge: "For SMEs, Enterprises & Growing Startups"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1600&auto=format&fit=crop",
  //   alt: "CRM dashboard interface with analytics",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1605902711622-cfb43c4437d9?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Sales team using CRM dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1522075469751-3a6694fb2f61?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Customer service team with CRM integrations"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1556740738-b6a63e27c4df?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Custom CRM data visualization"
  //     }
  //   ]
  // },

  painPoints: [
    "Leads slipping through cracks due to disorganized pipelines.",
    "Fragmented customer data across multiple tools.",
    "Manual sales tracking causing inefficiency.",
    "Lack of visibility into customer interactions and support history.",
    "Inability to forecast sales accurately.",
    "Difficulty integrating CRM with marketing, billing, and support systems."
  ],

  solutions: {
    crmStrategy: [
      "CRM audits and workflow mapping.",
      "Sales pipeline design for better visibility.",
      "Custom CRM dashboards for analytics.",
      "Automation of repetitive tasks."
    ],
    integrations: [
      "Seamless integration with ERP, billing, and marketing systems.",
      "Custom APIs for third-party apps.",
      "Email, WhatsApp, and SMS automation within CRM.",
      "Customer portals with role-based access."
    ],
    operations: [
      "Lead scoring and nurturing automation.",
      "Customer support ticketing integration.",
      "Sales forecasting with AI-powered insights.",
      "Omnichannel communication logs."
    ],
    retention: [
      "360° customer view with purchase history.",
      "Automated follow-ups and reminders.",
      "Customer success dashboards.",
      "Loyalty program integrations."
    ]
  },

  services: [
    {
      title: "Custom CRM Development",
      description:
        "Tailored CRM systems built to your unique sales processes and customer journeys.",
      deliverables: [
        "Requirement gathering & workflow mapping",
        "Custom modules & fields",
        "Dashboard & reporting",
        "Mobile-friendly CRM"
      ],
      icon: "FaUsersCog",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "CRM Integrations",
      description:
        "Connect your CRM with marketing, billing, and collaboration platforms.",
      deliverables: [
        "Email & calendar sync",
        "ERP & accounting integration",
        "Marketing automation setup",
        "API & third-party tools"
      ],
      icon: "FaPlug",
      duration: "2–4 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Salesforce & Zoho Customization",
      description:
        "Optimize existing CRM platforms like Salesforce, Zoho, or HubSpot with custom workflows.",
      deliverables: [
        "Custom fields & layouts",
        "Automated workflows",
        "Reports & dashboards",
        "Third-party app integrations"
      ],
      icon: "FaCloud",
      duration: "3–6 weeks",
      startingPriceINR: 150000
    },
    {
      title: "CRM Migration",
      description:
        "Seamless migration of data from spreadsheets or legacy systems to modern CRM platforms.",
      deliverables: [
        "Data mapping & cleaning",
        "Migration execution",
        "Validation & testing",
        "Post-migration support"
      ],
      icon: "FaExchangeAlt",
      duration: "2–3 weeks",
      startingPriceINR: 80000
    }
  ],

  features: {
    mustHave: [
      "Lead & deal management",
      "Contact & account tracking",
      "Email integration",
      "Task & activity tracking",
      "Custom reports & dashboards"
    ],
    niceToHave: [
      "AI-powered lead scoring",
      "Mobile CRM app",
      "Omnichannel support integration",
      "Predictive sales analytics",
      "Gamified sales leaderboards"
    ]
  },

  integrations: [
    { name: "Salesforce / Zoho / HubSpot", category: "CRM Platforms" },
    { name: "Slack / MS Teams", category: "Collaboration" },
    { name: "Stripe / Razorpay", category: "Billing" },
    { name: "Mailchimp / ActiveCampaign", category: "Email Marketing" },
    { name: "WhatsApp Business API", category: "Messaging" },
    { name: "Google Workspace / Office 365", category: "Productivity" },
    { name: "Power BI / Tableau", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    crmPlatforms: ["Salesforce", "Zoho CRM", "HubSpot"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Workflow diagrams", "User roles", "Feature list"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Custom modules", "APIs", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Lead-to-deal conversion rate",
    "Average sales cycle length",
    "Revenue per sales rep",
    "Customer retention rate",
    "CRM adoption rate"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small business with simple CRM needs",
      priceINR: 120000,
      timeline: "3–4 weeks",
      includes: [
        "Basic lead & contact management",
        "Pipeline dashboard",
        "Email integration",
        "Analytics setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized business scaling sales",
      priceINR: 250000,
      timeline: "6–8 weeks",
      includes: [
        "Custom CRM modules",
        "Multi-user roles & permissions",
        "Automation workflows",
        "3rd-party integrations"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large organizations needing advanced CRM",
      priceINR: 450000,
      timeline: "8–12 weeks",
      includes: [
        "Enterprise-grade CRM platform",
        "Advanced analytics & forecasting",
        "Omnichannel communication",
        "Custom dashboards & API integrations"
      ]
    }
  ],

  caseStudies: [
    {
      name: "RetailCRM Solutions",
      location: "Mumbai",
      goals: ["Streamline sales pipeline", "Centralize customer data"],
      outcomes: [
        "Sales cycle shortened by 40%",
        "Lead conversion rate improved by 2.3×",
        "Customer retention up by 28%"
      ],
      stack: ["React", "Node.js", "Zoho CRM", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Anita Kapoor",
      role: "Head of Sales, RetailCRM Solutions",
      quote:
        "The custom CRM transformed our sales process. We can now track every lead, forecast sales accurately, and our team productivity has skyrocketed."
    }
  ],

  faqs: [
    {
      q: "Can you build a CRM from scratch?",
      a: "Yes, we design and develop fully custom CRMs tailored to your business workflows."
    },
    {
      q: "Do you work with Salesforce and Zoho?",
      a: "Absolutely. We provide customization, integration, and workflow automation for Salesforce, Zoho, and HubSpot."
    },
    {
      q: "How do you ensure data security?",
      a: "We implement best practices like encryption, role-based access, and GDPR-compliant data policies."
    },
    {
      q: "Can you migrate our old CRM data?",
      a: "Yes, we handle complete data migration from legacy systems, spreadsheets, or other CRMs."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, we offer long-term CRM support, updates, and optimization services."
    }
  ],

  cta: {
    title: "Ready to transform your customer management?",
    text:
      "Let’s build or optimize a CRM that streamlines your sales, improves retention, and scales with your business.",
    primaryButton: { label: "Book a Free CRM Consultation", href: "/contact?plan=crm" },
    secondaryButton: { label: "Download CRM Strategy Guide", href: "/resources/crm-strategy-guide.pdf" }
  },

  seo: {
    metaTitle: "Custom CRM Development Services | Boost Sales & Retention",
    metaDescription:
      "We build and integrate custom CRM systems for businesses to manage sales pipelines, automate workflows, and improve customer retention.",
    keywords: [
      "CRM development",
      "Custom CRM solutions",
      "Salesforce integration",
      "Zoho CRM customization",
      "Customer retention software"
    ],
    canonical: "https://merndigital.com/industries/crm-development",
    og: {
      title: "CRM Development & Integration Services",
      description:
        "Custom CRM development, Salesforce/Zoho customization, and integrations that streamline sales and customer success.",
      // image:"https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — CRM Development Services",
      url: "https://merndigital.com/industries/crm-development",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you build a CRM from scratch?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, we design and develop fully custom CRMs tailored to your business workflows."
          }
        },
        {
          "@type": "Question",
          name: "Do you work with Salesforce and Zoho?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. We provide customization, integration, and workflow automation for Salesforce, Zoho, and HubSpot."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/crm-development",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "CRM Development",
       "item":"https://merndigital.com/industries/crm-development"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 6,
  title: "Logistics & Supply Chain",
  slug: "logistics-supply-chain",
  segment: "Technology",
  summary:
    "We provide digital solutions for logistics and supply chain companies, helping manage fleet, track shipments, and optimize operations to improve efficiency and customer satisfaction.",
  icon: {
    reactIcons: FaTruck, // logistics / transportation icon
    lucide: "Truck"
  },
  brand: {
    color: "#FF6F00",
    accent: "#FFC107",
    gradient: "linear-gradient(135deg, #FF6F00 0%, #FFB300 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Logistics & Supply Chain",
    subheadline:
      "From fleet management to shipment tracking and warehouse optimization, we help logistics companies streamline operations and deliver on time, every time.",
    highlights: [
      { label: "Operational Efficiency", value: "2.5x" },
      { label: "Delivery Accuracy", value: "99%" },
      { label: "Cost Reduction", value: "30%" }
    ],
    primaryButton: { label: "Book a Logistics Consultation", href: "/contact?src=logistics-supply-chain" },
    secondaryButton: { label: "See Logistics Case Studies", href: "/case-studies?industry=logistics-supply-chain" },
    badge: "For Logistics Companies, Transport Providers & Supply Chain Firms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1581091012184-5f6e5db7eade?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Logistics operations with trucks and fleet management",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1607746882042-944635dfe10e?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Warehouse inventory management"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581091012184-5f6e5db7eade?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Fleet tracking dashboard on a tablet"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581093458412-2d8d0dfd26d3?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Supply chain management team analyzing data"
  //     }
  //   ]
  // },

  painPoints: [
    "Inefficient fleet and route management.",
    "Lack of real-time shipment tracking.",
    "High operational costs and fuel wastage.",
    "Limited visibility into inventory and warehouse processes.",
    "Difficulty coordinating with multiple carriers and vendors.",
    "Delayed deliveries and customer dissatisfaction."
  ],

  solutions: {
    operations: [
      "Fleet tracking and route optimization software.",
      "Warehouse management systems (WMS).",
      "Automated inventory tracking and replenishment.",
      "Real-time delivery updates for customers."
    ],
    integrations: [
      "Integration with ERP, billing, and shipping platforms.",
      "IoT sensors for asset and vehicle monitoring.",
      "GPS tracking and telematics data sync.",
      "API integrations with carriers and marketplaces."
    ],
    analytics: [
      "Predictive demand and inventory analytics.",
      "Operational KPIs dashboard.",
      "Delivery performance tracking.",
      "Fuel and maintenance cost optimization reports."
    ],
    customerExperience: [
      "Shipment tracking portals and mobile apps.",
      "Automated notifications via email/SMS/WhatsApp.",
      "Customer support ticketing integration.",
      "Proof-of-delivery and electronic documentation."
    ]
  },

  services: [
    {
      title: "Custom Logistics Software",
      description:
        "Tailored solutions for fleet management, shipment tracking, and warehouse operations.",
      deliverables: [
        "Fleet & route optimization",
        "Warehouse & inventory modules",
        "Real-time dashboards",
        "Mobile apps for field teams"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Logistics Integrations",
      description:
        "Connect your operations with ERP, billing, and third-party shipping platforms.",
      deliverables: [
        "API integrations with carriers",
        "ERP & accounting sync",
        "IoT sensor data integration",
        "Real-time tracking setup"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Warehouse Management Systems",
      description:
        "Optimize storage, inventory, and picking processes with advanced WMS.",
      deliverables: [
        "Inventory tracking",
        "Order processing automation",
        "Multi-warehouse support",
        "Analytics & reporting"
      ],
      icon: "FaWarehouse",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Delivery Tracking & Customer Portal",
      description:
        "Provide real-time shipment updates and improve customer communication.",
      deliverables: [
        "Tracking dashboards",
        "Automated notifications",
        "Proof-of-delivery capture",
        "Support ticketing integration"
      ],
      icon: "FaTruck",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Fleet tracking & route optimization",
      "Inventory & warehouse management",
      "Real-time shipment tracking",
      "Automated notifications",
      "Custom reports & dashboards"
    ],
    niceToHave: [
      "AI-based demand forecasting",
      "Telematics & IoT integration",
      "Mobile driver apps",
      "Predictive maintenance alerts",
      "Dynamic pricing & load optimization"
    ]
  },

  integrations: [
    { name: "ERP Systems (SAP, Oracle, Tally)", category: "ERP" },
    { name: "GPS & Telematics Devices", category: "Fleet Management" },
    { name: "Google Maps / Mapbox", category: "Routing & Navigation" },
    { name: "Payment Gateways (Razorpay, Stripe)", category: "Billing" },
    { name: "SMS / WhatsApp APIs", category: "Customer Notifications" },
    { name: "Power BI / Tableau", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Workflow diagrams", "User roles", "Feature list"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Modules for fleet, inventory, and tracking", "APIs", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Delivery accuracy rate",
    "On-time delivery %", 
    "Fleet utilization",
    "Inventory turnover ratio",
    "Operational cost reduction"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small logistics operators",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic fleet tracking",
        "Shipment dashboard",
        "Inventory overview",
        "Email/SMS notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized logistics & supply chain companies",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom modules",
        "Multi-warehouse support",
        "Advanced reporting",
        "API integrations"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large logistics enterprises",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full logistics platform",
        "Predictive analytics & AI optimization",
        "IoT & telematics integration",
        "Custom dashboards & enterprise reporting"
      ]
    }
  ],

  caseStudies: [
    {
      name: "SpeedyTrans Logistics",
      location: "Delhi",
      goals: ["Reduce delivery delays", "Optimize fleet utilization"],
      outcomes: [
        "Delivery time reduced by 35%",
        "Fleet utilization improved by 40%",
        "Operational costs decreased by 25%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "IoT sensors", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Ravi Sharma",
      role: "Operations Head, SpeedyTrans Logistics",
      quote:
        "The logistics software transformed our operations. We now track every vehicle in real-time, optimize routes, and reduce delays significantly."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with GPS and telematics devices?",
      a: "Yes, we can integrate your fleet with GPS devices, IoT sensors, and telematics systems for real-time tracking."
    },
    {
      q: "Do you provide warehouse management solutions?",
      a: "Absolutely. We provide inventory and warehouse management modules tailored to your operations."
    },
    {
      q: "Can this system handle multiple warehouses and fleets?",
      a: "Yes, our platform supports multi-warehouse and multi-fleet setups with central dashboards."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide maintenance, monitoring, and optimization services long-term."
    }
  ],

  cta: {
    title: "Ready to optimize your logistics operations?",
    text:
      "Let’s build a platform that improves delivery efficiency, reduces costs, and enhances customer satisfaction.",
    primaryButton: { label: "Book a Free Logistics Consultation", href: "/contact?plan=logistics" },
    secondaryButton: { label: "Download Logistics Optimization Guide", href: "/resources/logistics-guide.pdf" }
  },

  seo: {
    metaTitle: "Logistics Software & Supply Chain Solutions | Optimize Operations",
    metaDescription:
      "We develop logistics and supply chain software for fleet management, inventory tracking, and operational optimization.",
    keywords: [
      "Logistics software",
      "Supply chain management",
      "Fleet tracking",
      "Warehouse management",
      "Delivery optimization"
    ],
    canonical: "https://merndigital.com/industries/logistics-supply-chain",
    og: {
      title: "Logistics & Supply Chain Software Solutions",
      description: "Custom logistics platforms for fleet, warehouse, and delivery optimization.",
      // image:"https://images.unsplash.com/photo-1581091012184-5f6e5db7eade?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Logistics & Supply Chain Solutions",
      url: "https://merndigital.com/industries/logistics-supply-chain",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with GPS and telematics devices?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, we can integrate your fleet with GPS devices, IoT sensors, and telematics systems for real-time tracking."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide warehouse management solutions?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. We provide inventory and warehouse management modules tailored to your operations."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/logistics-supply-chain",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Logistics & Supply Chain",
       "item":"https://merndigital.com/industries/logistics-supply-chain"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 7,
  title: "Travel & Tourism",
  slug: "travel-tourism",
  segment: "Technology",
  summary:
    "We create digital solutions for travel agencies, tour operators, and online booking platforms—helping manage bookings, automate workflows, and enhance customer experiences across all touchpoints.",
  icon: {
    reactIcons: FaSuitcaseRolling, // travel / tourism icon
    lucide: "Globe"
  },
  brand: {
    color: "#00ACC1",
    accent: "#26C6DA",
    gradient: "linear-gradient(135deg, #00ACC1 0%, #26C6DA 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Travel & Tourism",
    subheadline:
      "From online booking platforms to itinerary management, we help travel agencies streamline operations, increase bookings, and delight customers worldwide.",
    highlights: [
      { label: "Booking Efficiency", value: "3x" },
      { label: "Customer Satisfaction", value: "95%" },
      { label: "Operational Automation", value: "60%" }
    ],
    primaryButton: { label: "Book a Travel Tech Consultation", href: "/contact?src=travel-tourism" },
    secondaryButton: { label: "See Travel Case Studies", href: "/case-studies?industry=travel-tourism" },
    badge: "For Travel Agencies, Tour Operators & Online Booking Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Travel agency dashboard with booking interface",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1526778548025-fa2f459cd5c1?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Tour operator planning itineraries"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1519817650390-64a93db511c6?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Online travel booking dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521295121783-8a321d551ad2?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Travel agency team interacting with clients"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual booking and reservation management.",
    "Difficulty tracking customer preferences and itineraries.",
    "High operational costs due to redundant tasks.",
    "Limited visibility into sales and commissions.",
    "Slow response to customer inquiries.",
    "Difficulty integrating multiple booking and payment platforms."
  ],

  solutions: {
    operations: [
      "Centralized booking and reservation management.",
      "Automated itinerary generation and updates.",
      "CRM for customer preferences and travel history.",
      "Online payment and invoicing automation."
    ],
    integrations: [
      "Integrate with flight, hotel, and tour providers.",
      "API integration with payment gateways.",
      "Email and SMS notifications for bookings and reminders.",
      "Integration with travel review platforms and loyalty programs."
    ],
    analytics: [
      "Booking trends and revenue dashboards.",
      "Customer segmentation and personalization analytics.",
      "Performance tracking for agents and teams.",
      "Forecasting demand and seasonal trends."
    ],
    customerExperience: [
      "Online booking portals and mobile apps.",
      "Automated confirmations and reminders.",
      "Customer support chatbots and ticketing.",
      "Custom travel recommendations based on preferences."
    ]
  },

  services: [
    {
      title: "Custom Travel Booking Platform",
      description:
        "Build a platform for flights, hotels, tours, and holiday packages with real-time availability and automated pricing.",
      deliverables: [
        "Booking engine",
        "Payment gateway integration",
        "Admin dashboard & reporting",
        "Mobile app for customers"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Travel CRM & Customer Portal",
      description:
        "Manage customer profiles, preferences, and travel history with a dedicated CRM system.",
      deliverables: [
        "Customer profiles & segmentation",
        "Itinerary tracking",
        "Loyalty & rewards integration",
        "Automated communication workflows"
      ],
      icon: "FaUsersCog",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Travel Integrations",
      description:
        "Connect your system with flight, hotel, and tour APIs, along with payment gateways and review platforms.",
      deliverables: [
        "Booking APIs integration",
        "Payment & invoicing setup",
        "Third-party review & rating systems",
        "Automated email/SMS alerts"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Advanced dashboards for booking trends, revenue, and agent performance.",
      deliverables: [
        "Revenue & sales analytics",
        "Agent performance reports",
        "Customer trends analysis",
        "Forecasting & demand insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Booking & reservation management",
      "Customer profile tracking",
      "Payment & invoicing automation",
      "Itinerary management",
      "Custom reports & dashboards"
    ],
    niceToHave: [
      "AI-based travel recommendations",
      "Mobile app for customers",
      "Loyalty program integration",
      "Chatbot support",
      "Dynamic pricing & offers"
    ]
  },

  integrations: [
    { name: "Flight & Hotel APIs (Amadeus, Sabre, Expedia)", category: "Travel Providers" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "CRM Platforms (Salesforce, Zoho)", category: "Customer Management" },
    { name: "Travel Review Platforms (TripAdvisor, Google Reviews)", category: "Customer Feedback" },
    { name: "Power BI / Tableau", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Booking flow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Booking modules", "Payment APIs", "Admin dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Booking conversion rate",
    "Customer satisfaction score",
    "Average booking value",
    "Agent performance",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small travel agencies",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic booking engine",
        "Customer profiles",
        "Payment gateway integration",
        "Basic reporting"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized travel agencies & tour operators",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom booking modules",
        "Itinerary management",
        "Multi-agent roles",
        "Advanced reporting & analytics"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large travel platforms",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full booking platform",
        "AI-based recommendations",
        "Loyalty & rewards integration",
        "Custom dashboards & API integrations"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Wanderlust Travels",
      location: "Bangalore",
      goals: ["Automate bookings", "Increase customer retention"],
      outcomes: [
        "Booking process automated by 70%",
        "Customer satisfaction increased to 95%",
        "Revenue per agent increased by 2x"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Stripe API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Priya Menon",
      role: "Founder, Wanderlust Travels",
      quote:
        "The travel platform transformed our agency operations. Bookings are faster, customers are happier, and our team productivity has skyrocketed."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with flight and hotel booking APIs?",
      a: "Yes, we integrate with popular travel APIs like Amadeus, Sabre, and Expedia for real-time booking."
    },
    {
      q: "Do you provide CRM for customer management?",
      a: "Absolutely. Our platform manages customer profiles, preferences, travel history, and loyalty programs."
    },
    {
      q: "Can this system handle multiple agents and offices?",
      a: "Yes, the platform supports multi-agent roles, permissions, and multi-office setups."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide long-term support, updates, and optimization services."
    }
  ],

  cta: {
    title: "Ready to digitize your travel agency?",
    text:
      "Let’s build a platform that automates bookings, improves customer experience, and scales your travel business.",
    primaryButton: { label: "Book a Free Travel Consultation", href: "/contact?plan=travel" },
    secondaryButton: { label: "Download Travel Agency Tech Guide", href: "/resources/travel-guide.pdf" }
  },

  seo: {
    metaTitle: "Travel Agency Software & Booking Platform Solutions | Optimize Operations",
    metaDescription:
      "We build custom software for travel agencies and tour operators—online booking, itinerary management, CRM, and analytics.",
    keywords: [
      "Travel software",
      "Tour operator platform",
      "Online booking system",
      "Travel CRM",
      "Itinerary management"
    ],
    canonical: "https://merndigital.com/industries/travel-tourism",
    og: {
      title: "Travel & Tourism Software Solutions",
      description: "Custom platforms for travel agencies and tour operators.",
      // image:"https://images.unsplash.com/photo-1507525428034-b723cf961d3e?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Travel & Tourism Solutions",
      url: "https://merndigital.com/industries/travel-tourism",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with flight and hotel booking APIs?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, we integrate with popular travel APIs like Amadeus, Sabre, and Expedia for real-time booking."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide CRM for customer management?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. Our platform manages customer profiles, preferences, travel history, and loyalty programs."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/travel-tourism",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Travel & Tourism",
       "item":"https://merndigital.com/industries/travel-tourism"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 8,
  title: "Real Estate & Property Management",
  slug: "real-estate",
  segment: "Technology",
  summary:
    "We deliver digital solutions for real estate agencies, property developers, and rental platforms—helping manage listings, automate property workflows, and enhance client engagement.",
  icon: {
    reactIcons: FaBuilding, // real estate icon
    lucide: "Home"
  },
  brand: {
    color: "#4CAF50",
    accent: "#81C784",
    gradient: "linear-gradient(135deg, #4CAF50 0%, #81C784 100%)",
   
  },

  hero: {
    headline: "Digital Solutions for Smarter Real Estate Management",
    subheadline:
      "From property listings to client management and automated workflows, we help real estate businesses streamline operations, attract clients, and close deals faster.",
    highlights: [
      { label: "Listing Efficiency", value: "3x" },
      { label: "Lead Conversion", value: "90%" },
      { label: "Operational Automation", value: "50%" }
    ],
    primaryButton: { label: "Book a Real Estate Tech Consultation", href: "/contact?src=real-estate" },
    secondaryButton: { label: "See Real Estate Case Studies", href: "/case-studies?industry=real-estate" },
    badge: "For Real Estate Agencies, Property Developers & Rental Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1560184897-6c3e4a126332?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Real estate management dashboard with property listings",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1572120360610-d971b9a4f53c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Property listings on a web portal"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1599423300746-b62533397364?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Real estate agents analyzing market data"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Property management team coordinating tasks"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual property listing management.",
    "Difficulty tracking leads and client communication.",
    "High administrative costs and redundant workflows.",
    "Limited visibility into sales performance.",
    "Slow response to property inquiries.",
    "Difficulty integrating multiple platforms for listings and CRM."
  ],

  solutions: {
    operations: [
      "Centralized property listing and management.",
      "CRM for lead tracking and client communication.",
      "Automated workflows for property approvals and rentals.",
      "Payment, invoicing, and rent collection automation."
    ],
    integrations: [
      "Integration with MLS, listing portals, and rental platforms.",
      "API integration with payment gateways.",
      "Email and SMS notifications for clients and tenants.",
      "Integration with analytics platforms for market insights."
    ],
    analytics: [
      "Sales and lead tracking dashboards.",
      "Client segmentation and conversion analytics.",
      "Property performance and occupancy reports.",
      "Market trend and price forecasting."
    ],
    customerExperience: [
      "Client portal for property search and booking.",
      "Automated confirmations and notifications.",
      "Virtual tours and property galleries.",
      "Custom property recommendations based on preferences."
    ]
  },

  services: [
    {
      title: "Custom Property Management Platform",
      description:
        "Build a platform for property listings, rental management, and real-time availability tracking.",
      deliverables: [
        "Property listing & search engine",
        "Admin dashboard & reporting",
        "Tenant & client portals",
        "Mobile apps for agents and clients"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Real Estate CRM & Client Portal",
      description:
        "Manage leads, client interactions, and property preferences with a dedicated CRM system.",
      deliverables: [
        "Lead tracking & management",
        "Client communication automation",
        "Property preference matching",
        "Automated notifications & reminders"
      ],
      icon: "FaUsersCog",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your platform with listing portals, MLS systems, and payment gateways for seamless operations.",
      deliverables: [
        "API integrations with listing services",
        "Payment gateway & invoicing setup",
        "Automated notifications",
        "Analytics and reporting integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Advanced dashboards to track sales, lead conversion, occupancy, and property performance.",
      deliverables: [
        "Sales & revenue analytics",
        "Lead conversion tracking",
        "Property performance reports",
        "Market trend forecasting"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Property listing & search",
      "Lead tracking & CRM",
      "Automated notifications & workflows",
      "Payment & rent collection",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Virtual tours & 3D galleries",
      "AI-based property recommendations",
      "Mobile apps for agents & clients",
      "Tenant portal & communication",
      "Dynamic pricing & occupancy optimization"
    ]
  },

  integrations: [
    { name: "MLS & Listing Portals (99acres, MagicBricks)", category: "Property Platforms" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "CRM Platforms (Salesforce, Zoho)", category: "Client Management" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Property modules", "CRM APIs", "Admin dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Lead conversion rate",
    "Client satisfaction score",
    "Average deal value",
    "Property occupancy rate",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small real estate agencies",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic property listing module",
        "Lead tracking",
        "Payment gateway integration",
        "Basic reporting"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized agencies & property managers",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom listing modules",
        "CRM & lead automation",
        "Multi-agent access",
        "Advanced analytics & reporting"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large real estate platforms",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full real estate platform",
        "AI-based recommendations",
        "Virtual tours & 3D galleries",
        "Custom dashboards & API integrations"
      ]
    }
  ],

  caseStudies: [
    {
      name: "UrbanNest Realtors",
      location: "Mumbai",
      goals: ["Automate property management", "Increase lead conversion"],
      outcomes: [
        "Property listing updates automated by 80%",
        "Lead conversion improved to 90%",
        "Operational efficiency increased by 50%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Stripe API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Rahul Mehta",
      role: "Founder, UrbanNest Realtors",
      quote:
        "The property management platform transformed our agency. Lead tracking and client engagement are seamless, and our team productivity has improved drastically."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with listing portals and MLS systems?",
      a: "Yes, our platform integrates with major listing portals and MLS systems for real-time property updates."
    },
    {
      q: "Do you provide CRM for client and lead management?",
      a: "Absolutely. Our platform manages client profiles, lead tracking, and automated follow-ups."
    },
    {
      q: "Can this system handle multiple agents and offices?",
      a: "Yes, the platform supports multi-agent roles, permissions, and multi-office setups."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide long-term maintenance, updates, and optimization services."
    }
  ],

  cta: {
    title: "Ready to digitize your real estate business?",
    text:
      "Let’s build a platform that automates listings, manages leads, and scales your real estate operations efficiently.",
    primaryButton: { label: "Book a Free Real Estate Consultation", href: "/contact?plan=real-estate" },
    secondaryButton: { label: "Download Real Estate Tech Guide", href: "/resources/real-estate-guide.pdf" }
  },

  seo: {
    metaTitle: "Real Estate Software & Property Management Solutions | Optimize Operations",
    metaDescription:
      "We build custom software for real estate agencies and property managers—listing management, CRM, and analytics.",
    keywords: [
      "Real estate software",
      "Property management platform",
      "Listing management system",
      "Real estate CRM",
      "Property analytics"
    ],
    canonical: "https://merndigital.com/industries/real-estate",
    og: {
      title: "Real Estate & Property Management Software Solutions",
      description: "Custom platforms for real estate agencies, property developers, and rental platforms.",
      // image:"https://images.unsplash.com/photo-1560184897-6c3e4a126332?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Real Estate & Property Solutions",
      url: "https://merndigital.com/industries/real-estate",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with listing portals and MLS systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Yes, our platform integrates with major listing portals and MLS systems for real-time property updates."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide CRM for client and lead management?",
          acceptedAnswer: {
            "@type": "Answer",
            text:
              "Absolutely. Our platform manages client profiles, lead tracking, and automated follow-ups."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/real-estate",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Real Estate & Property Management",
       "item":"https://merndigital.com/industries/real-estate"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 9,
  title: "Hotel & Restaurant Management",
  slug: "hotel-restaurant",
  segment: "Technology",
  summary:
    "We provide digital solutions for hotels, resorts, and restaurants—streamlining bookings, reservations, orders, inventory, and guest experiences with powerful software.",
  icon: {
    reactIcons: FaConciergeBell, // hotel/restaurant icon
    lucide: "Coffee"
  },
  brand: {
    color: "#FF7043",
    accent: "#FFAB91",
    gradient: "linear-gradient(135deg, #FF7043 0%, #FFAB91 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Hotel & Restaurant Management",
    subheadline:
      "From online reservations to order management and guest engagement, we help hospitality businesses enhance efficiency, customer satisfaction, and revenue.",
    highlights: [
      { label: "Reservation Efficiency", value: "3x" },
      { label: "Customer Satisfaction", value: "95%" },
      { label: "Operational Automation", value: "60%" }
    ],
    primaryButton: { label: "Book a Hospitality Tech Consultation", href: "/contact?src=hotel-restaurant" },
    secondaryButton: { label: "See Hospitality Case Studies", href: "/case-studies?industry=hotel-restaurant" },
    badge: "For Hotels, Resorts, and Restaurants"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Hotel and restaurant management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1555992336-03a23c7875c5?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Restaurant table reservation system"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1565299624946-b28f40a0ae38?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Hotel front desk dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1541542684-6e3a7a87bfb1?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Restaurant order management and kitchen display"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual booking and reservation management.",
    "Difficulty managing table orders or room availability.",
    "High operational costs due to repetitive tasks.",
    "Limited visibility into guest preferences and feedback.",
    "Slow response to customer requests.",
    "Challenges integrating multiple booking, POS, and payment systems."
  ],

  solutions: {
    operations: [
      "Centralized reservation and booking management.",
      "POS and order management for restaurants.",
      "Inventory and menu management automation.",
      "CRM for guest profiles and preferences."
    ],
    integrations: [
      "Integration with hotel booking engines and OTAs.",
      "API integration with POS systems and payment gateways.",
      "Email and SMS notifications for reservations and confirmations.",
      "Integration with review platforms and loyalty programs."
    ],
    analytics: [
      "Reservation and occupancy dashboards.",
      "Guest behavior and preference analytics.",
      "Revenue and sales reports.",
      "Forecasting demand for rooms and menu items."
    ],
    customerExperience: [
      "Online reservation portals and mobile apps.",
      "Automated booking confirmations and reminders.",
      "Custom offers and loyalty rewards.",
      "Guest feedback collection and analysis."
    ]
  },

  services: [
    {
      title: "Hotel & Restaurant Management Platform",
      description:
        "A platform to manage bookings, orders, inventory, and guest interactions with real-time updates.",
      deliverables: [
        "Reservation & booking engine",
        "POS & order management system",
        "Inventory and menu tracking",
        "Admin dashboards and reporting"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "CRM & Guest Management Portal",
      description:
        "Manage guest profiles, preferences, feedback, and loyalty programs efficiently.",
      deliverables: [
        "Guest profile management",
        "Reservation and order history tracking",
        "Loyalty & rewards program integration",
        "Automated notifications and reminders"
      ],
      icon: "FaUsersCog",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your platform with OTAs, POS systems, payment gateways, and review platforms.",
      deliverables: [
        "Booking & POS APIs integration",
        "Payment and invoicing setup",
        "Automated email/SMS alerts",
        "Reporting & analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for reservations, revenue, guest feedback, and staff performance.",
      deliverables: [
        "Occupancy & reservation analytics",
        "Revenue & sales reports",
        "Guest feedback analysis",
        "Demand forecasting & insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Reservation & booking management",
      "POS & order tracking",
      "Guest profile & CRM",
      "Inventory & menu automation",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Mobile app for guests and staff",
      "Loyalty & rewards program",
      "Automated notifications & reminders",
      "AI-based recommendations & upselling",
      "Dynamic pricing & occupancy optimization"
    ]
  },

  integrations: [
    { name: "Hotel Booking Engines & OTAs (Booking.com, Expedia)", category: "Booking Platforms" },
    { name: "POS & Order Management Systems", category: "Restaurant Operations" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "Review & Loyalty Platforms", category: "Customer Engagement" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Booking & POS modules", "CRM APIs", "Admin dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Reservation conversion rate",
    "Customer satisfaction score",
    "Average order value",
    "Occupancy & table utilization",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small hotels & restaurants",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic reservation system",
        "Guest tracking & CRM",
        "Payment integration",
        "Basic reporting"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized hotels & restaurant chains",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom booking & order modules",
        "Multi-agent/staff roles",
        "Advanced reporting & analytics",
        "Loyalty & feedback integrations"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large hotels, resorts, and chains",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full hospitality platform",
        "AI-based recommendations & upselling",
        "Mobile apps for guests & staff",
        "Custom dashboards & API integrations"
      ]
    }
  ],

  caseStudies: [
    {
      name: "TasteStay Hotels",
      location: "Delhi",
      goals: ["Automate reservations", "Improve guest experience"],
      outcomes: [
        "Reservation process automated by 70%",
        "Guest satisfaction increased to 95%",
        "Operational efficiency improved by 50%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Stripe API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Anjali Sharma",
      role: "Manager, TasteStay Hotels",
      quote:
        "The hospitality platform made our booking and order management seamless. Guests love the experience, and our staff can work efficiently."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with hotel booking engines and OTAs?",
      a: "Yes, our platform integrates with major OTAs and hotel booking engines for real-time updates."
    },
    {
      q: "Do you provide CRM for guest management?",
      a: "Absolutely. Our system manages guest profiles, preferences, and loyalty programs."
    },
    {
      q: "Can this system handle multiple staff and branches?",
      a: "Yes, multi-role access and multi-branch setups are fully supported."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide long-term support, updates, and optimization services."
    }
  ],

  cta: {
    title: "Ready to digitize your hospitality business?",
    text:
      "Let’s build a platform that automates reservations, manages orders, and enhances guest satisfaction.",
    primaryButton: { label: "Book a Free Hospitality Consultation", href: "/contact?plan=hotel-restaurant" },
    secondaryButton: { label: "Download Hospitality Tech Guide", href: "/resources/hospitality-guide.pdf" }
  },

  seo: {
    metaTitle: "Hotel & Restaurant Software Solutions | Optimize Operations & Guest Experience",
    metaDescription:
      "We build custom software for hotels and restaurants—reservation systems, POS management, CRM, and analytics.",
    keywords: [
      "Hotel software",
      "Restaurant management platform",
      "Reservation system",
      "Hospitality CRM",
      "POS management"
    ],
    canonical: "https://merndigital.com/industries/hotel-restaurant",
    og: {
      title: "Hotel & Restaurant Management Software Solutions",
      description: "Custom platforms for hotels, resorts, and restaurants.",
      // image:"https://images.unsplash.com/photo-1504674900247-0877df9cc836?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Hotel & Restaurant Solutions",
      url: "https://merndigital.com/industries/hotel-restaurant",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with hotel booking engines and OTAs?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our platform integrates with major OTAs and hotel booking engines for real-time updates."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide CRM for guest management?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Our system manages guest profiles, preferences, and loyalty programs."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/hotel-restaurant",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Hotel & Restaurant Management",
       "item":"https://merndigital.com/industries/hotel-restaurant"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 10,
  title: "Manufacturing & Industrial Automation",
  slug: "manufacturing",
  segment: "Technology",
  summary:
    "We provide digital solutions for manufacturing companies—streamlining production workflows, supply chain management, inventory, and operational efficiency with smart software.",
  icon: {
    reactIcons: FaIndustry, // manufacturing icon
    lucide: "Factory"
  },
  brand: {
    color: "#1976D2",
    accent: "#64B5F6",
    gradient: "linear-gradient(135deg, #1976D2 0%, #64B5F6 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Manufacturing Operations",
    subheadline:
      "From production tracking to supply chain management, we help manufacturers optimize operations, reduce downtime, and increase productivity.",
    highlights: [
      { label: "Production Efficiency", value: "2.5x" },
      { label: "Operational Uptime", value: "98%" },
      { label: "Process Automation", value: "55%" }
    ],
    primaryButton: { label: "Book a Manufacturing Tech Consultation", href: "/contact?src=manufacturing" },
    secondaryButton: { label: "See Manufacturing Case Studies", href: "/case-studies?industry=manufacturing" },
    badge: "For Manufacturers, Industrial Plants & Production Units"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1581090700227-7c7f7c6b2a4e?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Manufacturing plant with machinery dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1581091215361-1e8678f08b70?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Automated production line"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581092914770-9b9d6e64f434?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Factory inventory management system"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581092923190-3a0b9c2d7c0c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Industrial control and monitoring dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual tracking of production and inventory.",
    "Difficulty managing supply chains and procurement.",
    "High operational and labor costs.",
    "Limited visibility into machine utilization and downtime.",
    "Slow decision-making due to lack of real-time insights.",
    "Challenges integrating multiple ERP and production systems."
  ],

  solutions: {
    operations: [
      "Centralized production tracking and monitoring.",
      "Inventory and warehouse management automation.",
      "Supply chain and procurement management.",
      "Quality control and compliance monitoring."
    ],
    integrations: [
      "Integration with ERP, MES, and CRM systems.",
      "IoT sensors for real-time machine data.",
      "API integration with logistics and procurement platforms.",
      "Automated alerts via email/SMS for critical events."
    ],
    analytics: [
      "Production efficiency and downtime dashboards.",
      "Inventory turnover and procurement analysis.",
      "Supply chain and supplier performance reports.",
      "Predictive maintenance and demand forecasting."
    ],
    customerExperience: [
      "Customer portal for order tracking and support.",
      "Automated production status updates.",
      "Custom reporting for clients and stakeholders.",
      "Supplier and partner collaboration portals."
    ]
  },

  services: [
    {
      title: "Manufacturing Management Platform",
      description:
        "A platform to monitor production, manage inventory, and streamline workflows across multiple factories.",
      deliverables: [
        "Production tracking & reporting",
        "Inventory & warehouse management",
        "Quality control dashboards",
        "Admin & operations dashboards"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 300000
    },
    {
      title: "Supply Chain & Vendor Portal",
      description:
        "Manage procurement, suppliers, and logistics with centralized control and real-time tracking.",
      deliverables: [
        "Supplier & vendor management",
        "Procurement automation",
        "Shipment & logistics tracking",
        "Alerts & notifications"
      ],
      icon: "FaTruck",
      duration: "4–6 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Integrations & IoT Automation",
      description:
        "Connect your production lines, ERP, and logistics systems for seamless data flow and process automation.",
      deliverables: [
        "ERP & MES integrations",
        "IoT sensor data collection",
        "Automated alerts & notifications",
        "Analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards to track production efficiency, supply chain KPIs, and predictive maintenance insights.",
      deliverables: [
        "Production & efficiency analytics",
        "Inventory & supply chain reports",
        "Downtime & maintenance dashboards",
        "Predictive analytics & insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 150000
    }
  ],

  features: {
    mustHave: [
      "Production & workflow management",
      "Inventory & warehouse automation",
      "Supply chain & procurement tracking",
      "Quality control & compliance monitoring",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "IoT integration for machines",
      "Predictive maintenance alerts",
      "Supplier & partner portal",
      "Mobile apps for operations staff",
      "AI-based production optimization"
    ]
  },

  integrations: [
    { name: "ERP Systems (SAP, Oracle, Odoo)", category: "Enterprise Systems" },
    { name: "MES & Production Systems", category: "Manufacturing Operations" },
    { name: "IoT Sensors & Automation", category: "IoT & Machine Data" },
    { name: "Payment & Procurement Gateways", category: "Finance & Procurement" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Production & inventory modules", "ERP APIs", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Production efficiency",
    "Machine uptime",
    "Supply chain reliability",
    "Inventory turnover",
    "Operational cost reduction"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small manufacturing units",
      priceINR: 200000,
      timeline: "4–6 weeks",
      includes: [
        "Basic production tracking",
        "Inventory management",
        "Simple reporting dashboards",
        "Alerts & notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-sized factories",
      priceINR: 350000,
      timeline: "6–8 weeks",
      includes: [
        "Custom production & supply modules",
        "Multi-factory access",
        "Advanced analytics & reporting",
        "Supplier management"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large industrial plants",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Full manufacturing platform",
        "IoT & predictive maintenance",
        "Multi-location dashboards",
        "API integrations with ERP & MES systems"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Ace Manufacturing Co.",
      location: "Pune",
      goals: ["Automate production tracking", "Optimize supply chain"],
      outcomes: [
        "Production visibility improved by 80%",
        "Downtime reduced by 40%",
        "Inventory management automated by 60%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "IoT Sensors", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Ramesh Gupta",
      role: "Operations Head, Ace Manufacturing Co.",
      quote:
        "The digital platform streamlined our production and supply chain. Real-time insights and automation improved efficiency and reduced downtime drastically."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with ERP and MES systems?",
      a: "Yes, our platform integrates with major ERP and MES systems for seamless operations."
    },
    {
      q: "Does the system support multiple factories and warehouses?",
      a: "Absolutely. You can manage multiple locations with role-based access and centralized control."
    },
    {
      q: "Do you offer predictive maintenance features?",
      a: "Yes, IoT-based sensors provide alerts and predictive insights to minimize machine downtime."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, we provide long-term maintenance, feature upgrades, and performance optimization."
    }
  ],

  cta: {
    title: "Ready to digitize your manufacturing operations?",
    text:
      "Let’s build a platform that optimizes production, supply chain, and operations across your factories.",
    primaryButton: { label: "Book a Free Manufacturing Consultation", href: "/contact?plan=manufacturing" },
    secondaryButton: { label: "Download Manufacturing Tech Guide", href: "/resources/manufacturing-guide.pdf" }
  },

  seo: {
    metaTitle: "Manufacturing Software & Industrial Automation Solutions | Optimize Operations",
    metaDescription:
      "We build custom software for manufacturing companies—production tracking, inventory management, ERP integration, and analytics.",
    keywords: [
      "Manufacturing software",
      "Industrial automation platform",
      "Production management system",
      "Inventory & warehouse software",
      "ERP integration"
    ],
    canonical: "https://merndigital.com/industries/manufacturing",
    og: {
      title: "Manufacturing & Industrial Automation Software Solutions",
      description: "Custom platforms for factories, plants, and manufacturing units.",
      // image:"https://images.unsplash.com/photo-1581090700227-7c7f7c6b2a4e?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Manufacturing & Industrial Solutions",
      url: "https://merndigital.com/industries/manufacturing",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you integrate with ERP and MES systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our platform integrates with major ERP and MES systems for seamless operations."
          }
        },
        {
          "@type": "Question",
          name: "Does the system support multiple factories and warehouses?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. You can manage multiple locations with role-based access and centralized control."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/manufacturing",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Manufacturing & Industrial Automation",
       "item":"https://merndigital.com/industries/manufacturing"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 11,
  title: "Education & EdTech Solutions",
  slug: "education",
  segment: "Technology",
  summary:
    "We provide digital solutions for schools, colleges, coaching centers, and online learning platforms—streamlining administration, learning management, student engagement, and analytics with smart software.",
  icon: {
    reactIcons: FaGraduationCap, // education icon
    lucide: "BookOpen"
  },
  brand: {
    color: "#8E24AA",
    accent: "#CE93D8",
    gradient: "linear-gradient(135deg, #8E24AA 0%, #CE93D8 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Education Management",
    subheadline:
      "From school administration to online learning, we help educational institutions optimize operations, engage students, and enhance learning outcomes.",
    highlights: [
      { label: "Student Engagement", value: "90%" },
      { label: "Administrative Efficiency", value: "3x" },
      { label: "Learning Outcome Improvement", value: "60%" }
    ],
    primaryButton: { label: "Book an EdTech Consultation", href: "/contact?src=education" },
    secondaryButton: { label: "See Education Case Studies", href: "/case-studies?industry=education" },
    badge: "For Schools, Colleges, and Online Learning Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1596495577886-d920f1fb2d11?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Education management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1588072432836-e10032774350?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Online classroom interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588072433157-1ecce1c2b9b5?q=80&w=1600&auto=format&fit=crop",
  //       alt: "School administration software"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588072433131-6b0d2d9e4cf3?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Learning analytics and progress dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual student records and attendance tracking.",
    "Difficulty managing online and offline courses simultaneously.",
    "Limited insights into student performance and engagement.",
    "High administrative workload for staff and teachers.",
    "Challenges integrating multiple learning platforms and tools.",
    "Slow communication with parents and students."
  ],

  solutions: {
    operations: [
      "Centralized student information system (SIS).",
      "Course and curriculum management.",
      "Automated attendance and grading.",
      "Teacher and staff workflow automation."
    ],
    integrations: [
      "Integration with LMS, video conferencing, and exam platforms.",
      "API integration with payment gateways for fees.",
      "Email and SMS notifications for students and parents.",
      "Integration with analytics and reporting tools."
    ],
    analytics: [
      "Student performance and engagement dashboards.",
      "Attendance and participation analytics.",
      "Course completion and learning outcome reports.",
      "Predictive insights for intervention and support."
    ],
    customerExperience: [
      "Parent and student portals.",
      "Online enrollment and course registration.",
      "Automated notifications and reminders.",
      "Interactive learning and collaboration tools."
    ]
  },

  services: [
    {
      title: "School & College Management Platform",
      description:
        "A platform to manage students, courses, attendance, grading, and administration efficiently.",
      deliverables: [
        "Student information system (SIS)",
        "Attendance & grading modules",
        "Teacher & staff dashboards",
        "Parent & student portals"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Learning Management System (LMS)",
      description:
        "Manage online courses, assignments, and learning resources for students and teachers.",
      deliverables: [
        "Course & curriculum management",
        "Assignment & exam modules",
        "Interactive learning tools",
        "Progress tracking & analytics"
      ],
      icon: "FaChalkboardTeacher",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your platform with LMS, payment systems, video conferencing, and analytics for seamless operations.",
      deliverables: [
        "LMS & exam platform integration",
        "Payment and invoicing setup",
        "Automated alerts & notifications",
        "Analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for student performance, course progress, engagement, and administrative efficiency.",
      deliverables: [
        "Student performance dashboards",
        "Course completion & attendance reports",
        "Teacher & staff productivity analytics",
        "Predictive insights for interventions"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Student information system (SIS)",
      "Attendance & grading automation",
      "Course & curriculum management",
      "Parent & student portals",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Mobile app for students and staff",
      "Interactive learning tools",
      "Automated notifications & reminders",
      "AI-based learning recommendations",
      "Integration with third-party learning platforms"
    ]
  },

  integrations: [
    { name: "LMS & Online Learning Platforms", category: "Learning Management" },
    { name: "Video Conferencing Tools (Zoom, Teams)", category: "Communication" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS APIs", category: "Notifications" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Student & course modules", "LMS integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Student engagement rate",
    "Course completion rate",
    "Administrative efficiency",
    "Learning outcome improvement",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small schools & coaching centers",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic student management",
        "Course & attendance tracking",
        "Payment integration",
        "Simple dashboards"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium schools & colleges",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom student & course modules",
        "Multi-class & multi-teacher access",
        "Advanced reporting & analytics",
        "Parent & student portal integration"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large institutions & EdTech platforms",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full education management platform",
        "AI-based learning recommendations",
        "Mobile apps for students & staff",
        "Integration with LMS & exam platforms"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Bright Future School",
      location: "Bangalore",
      goals: ["Automate administration", "Enhance student engagement"],
      outcomes: [
        "Attendance automation improved by 80%",
        "Student engagement increased to 90%",
        "Administrative tasks reduced by 50%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Zoom API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Sunita Rao",
      role: "Principal, Bright Future School",
      quote:
        "The EdTech platform streamlined our school operations and significantly improved student engagement. Teachers and staff love the automated workflows."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with LMS and video tools?",
      a: "Yes, our system integrates with major LMS platforms, video conferencing, and exam tools."
    },
    {
      q: "Does it support multiple classes and teachers?",
      a: "Absolutely. Multi-class and multi-teacher access with role-based permissions is fully supported."
    },
    {
      q: "Can parents track student progress?",
      a: "Yes, parent portals provide attendance, grades, and learning progress reports."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, we provide long-term maintenance, feature updates, and performance optimization."
    }
  ],

  cta: {
    title: "Ready to digitize your educational institution?",
    text:
      "Let’s build a platform that automates administration, engages students, and enhances learning outcomes.",
    primaryButton: { label: "Book a Free EdTech Consultation", href: "/contact?plan=education" },
    secondaryButton: { label: "Download Education Tech Guide", href: "/resources/education-guide.pdf" }
  },

  seo: {
    metaTitle: "Education Software & EdTech Solutions | Optimize Learning & Administration",
    metaDescription:
      "We build custom software for schools, colleges, coaching centers, and EdTech platforms—student management, LMS, analytics, and reporting.",
    keywords: [
      "Education software",
      "EdTech platform",
      "School management system",
      "Learning management system",
      "Student analytics"
    ],
    canonical: "https://merndigital.com/industries/education",
    og: {
      title: "Education & EdTech Software Solutions",
      description: "Custom platforms for schools, colleges, and online learning platforms.",
      // image:"https://images.unsplash.com/photo-1596495577886-d920f1fb2d11?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Education & EdTech Solutions",
      url: "https://merndigital.com/industries/education",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with LMS and video tools?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our system integrates with major LMS platforms, video conferencing, and exam tools."
          }
        },
        {
          "@type": "Question",
          name: "Does it support multiple classes and teachers?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Multi-class and multi-teacher access with role-based permissions is fully supported."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/education",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Education & EdTech Solutions",
       "item":"https://merndigital.com/industries/education"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 12,
  title: "Healthcare & MedTech Solutions",
  slug: "healthcare",
  segment: "Technology",
  summary:
    "We provide digital solutions for hospitals, clinics, diagnostic centers, and healthcare platforms—streamlining patient management, telemedicine, electronic health records, and analytics with smart software.",
  icon: {
    reactIcons: FaHeartbeat, // healthcare icon
    lucide: "Heart"
  },
  brand: {
    color: "#D32F2F",
    accent: "#FFCDD2",
    gradient: "linear-gradient(135deg, #D32F2F 0%, #FFCDD2 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Smarter Healthcare Management",
    subheadline:
      "From patient management to telemedicine, we help healthcare providers improve operations, patient care, and clinical outcomes.",
    highlights: [
      { label: "Patient Engagement", value: "95%" },
      { label: "Operational Efficiency", value: "3x" },
      { label: "Clinical Outcome Improvement", value: "50%" }
    ],
    primaryButton: { label: "Book a Healthcare Tech Consultation", href: "/contact?src=healthcare" },
    secondaryButton: { label: "See Healthcare Case Studies", href: "/case-studies?industry=healthcare" },
    badge: "For Hospitals, Clinics, and Healthcare Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1588776814546-47c40e48cde1?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Healthcare management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1588776814553-7fc6761f6310?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Telemedicine interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588776814543-8ffb0712e5e2?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Hospital administration software"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1588776814557-3b7c4c81c872?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Patient health analytics dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual patient records and appointment tracking.",
    "Difficulty managing multiple departments and staff schedules.",
    "Limited visibility into patient outcomes and clinical data.",
    "High administrative workload for healthcare staff.",
    "Challenges integrating multiple hospital and diagnostic systems.",
    "Slow communication with patients and families."
  ],

  solutions: {
    operations: [
      "Centralized patient information system (PIS).",
      "Appointment and scheduling management.",
      "Electronic health record (EHR) automation.",
      "Staff workflow and task management."
    ],
    integrations: [
      "Integration with telemedicine and diagnostic platforms.",
      "API integration with payment and insurance systems.",
      "Email and SMS notifications for patients and staff.",
      "Integration with analytics and reporting tools."
    ],
    analytics: [
      "Patient outcome and engagement dashboards.",
      "Resource and bed utilization analytics.",
      "Clinical KPI and treatment effectiveness reports.",
      "Predictive insights for preventive care."
    ],
    customerExperience: [
      "Patient portals for appointments and reports.",
      "Telemedicine and virtual consultations.",
      "Automated reminders and notifications.",
      "Interactive care and wellness tools."
    ]
  },

  services: [
    {
      title: "Hospital & Clinic Management Platform",
      description:
        "A platform to manage patients, appointments, staff, and clinical operations efficiently.",
      deliverables: [
        "Patient information system (PIS)",
        "Appointment & scheduling modules",
        "Staff dashboards",
        "Patient portals & telemedicine integration"
      ],
      icon: "FaLaptopCode",
      duration: "6–10 weeks",
      startingPriceINR: 300000
    },
    {
      title: "Telemedicine & Patient Engagement System",
      description:
        "Manage virtual consultations, patient communications, and remote monitoring seamlessly.",
      deliverables: [
        "Telemedicine module",
        "Patient notifications & reminders",
        "Online reports & prescriptions",
        "Engagement analytics dashboards"
      ],
      icon: "FaStethoscope",
      duration: "4–6 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your hospital systems, labs, insurance, and analytics for seamless operations.",
      deliverables: [
        "EHR & lab system integration",
        "Payment & insurance gateway setup",
        "Automated alerts & notifications",
        "Analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for patient outcomes, hospital performance, and clinical insights.",
      deliverables: [
        "Patient engagement & outcome dashboards",
        "Staff productivity reports",
        "Resource utilization analytics",
        "Predictive healthcare insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 150000
    }
  ],

  features: {
    mustHave: [
      "Patient information system (PIS)",
      "Appointment & scheduling automation",
      "Electronic health records (EHR)",
      "Staff & department management",
      "Custom dashboards & reporting"
    ],
    niceToHave: [
      "Telemedicine integration",
      "Predictive care and alerts",
      "Mobile apps for staff and patients",
      "AI-based clinical decision support",
      "Integration with diagnostic and insurance platforms"
    ]
  },

  integrations: [
    { name: "EHR & Hospital Systems", category: "Clinical Operations" },
    { name: "Telemedicine & Virtual Care", category: "Patient Care" },
    { name: "Payment & Insurance Gateways", category: "Finance" },
    { name: "Lab & Diagnostic Platforms", category: "Healthcare Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["HIPAA-compliant encryption", "JWT Auth", "OAuth2"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Patient & staff modules", "Telemedicine integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Patient engagement rate",
    "Appointment adherence",
    "Operational efficiency",
    "Clinical outcome improvement",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small clinics & diagnostic centers",
      priceINR: 200000,
      timeline: "4–6 weeks",
      includes: [
        "Basic patient management",
        "Appointment scheduling",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium hospitals & healthcare networks",
      priceINR: 350000,
      timeline: "6–8 weeks",
      includes: [
        "Custom patient & appointment modules",
        "Multi-department access",
        "Advanced reporting & analytics",
        "Telemedicine integration"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large hospitals & healthcare platforms",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Full healthcare management platform",
        "AI-based predictive care",
        "Mobile apps for patients & staff",
        "Integration with EHR & lab systems"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Healthy Life Hospital",
      location: "Delhi",
      goals: ["Digitize patient management", "Enable telemedicine"],
      outcomes: [
        "Patient engagement increased to 95%",
        "Appointment adherence improved by 80%",
        "Administrative workload reduced by 40%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Telemedicine API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Dr. Anil Sharma",
      role: "Chief Medical Officer, Healthy Life Hospital",
      quote:
        "The MedTech platform transformed our hospital operations and patient engagement. Staff productivity improved, and patients love the telemedicine features."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with EHR and lab systems?",
      a: "Yes, our platform integrates with major EHR and diagnostic systems for seamless operations."
    },
    {
      q: "Does it support multiple departments and staff roles?",
      a: "Absolutely. Role-based access for multiple departments is fully supported."
    },
    {
      q: "Can patients access their reports online?",
      a: "Yes, patient portals provide secure access to reports, prescriptions, and appointments."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, we provide long-term maintenance, feature updates, and performance optimization."
    }
  ],

  cta: {
    title: "Ready to digitize your healthcare operations?",
    text:
      "Let’s build a platform that optimizes patient management, telemedicine, and hospital operations.",
    primaryButton: { label: "Book a Free Healthcare Consultation", href: "/contact?plan=healthcare" },
    secondaryButton: { label: "Download Healthcare Tech Guide", href: "/resources/healthcare-guide.pdf" }
  },

  seo: {
    metaTitle: "Healthcare Software & MedTech Solutions | Optimize Patient Care",
    metaDescription:
      "We build custom software for hospitals, clinics, and healthcare platforms—patient management, telemedicine, EHR, and analytics.",
    keywords: [
      "Healthcare software",
      "MedTech platform",
      "Hospital management system",
      "Patient management software",
      "Telemedicine solution"
    ],
    canonical: "https://merndigital.com/industries/healthcare",
    og: {
      title: "Healthcare & MedTech Software Solutions",
      description: "Custom platforms for hospitals, clinics, and healthcare providers.",
      // image:"https://images.unsplash.com/photo-1588776814546-47c40e48cde1?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Healthcare & MedTech Solutions",
      url: "https://merndigital.com/industries/healthcare",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with EHR and lab systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, our platform integrates with major EHR and diagnostic systems for seamless operations."
          }
        },
        {
          "@type": "Question",
          name: "Does it support multiple departments and staff roles?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. Role-based access for multiple departments is fully supported."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/healthcare",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Healthcare & MedTech Solutions",
       "item":"https://merndigital.com/industries/healthcare"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 13,
  title: "Fashion & Apparel Solutions",
  slug: "fashion-apparel",
  segment: "Lifestyle & Retail",
  summary:
    "We provide digital solutions for fashion brands, retailers, and e-commerce platforms—streamlining inventory management, online stores, design workflows, and customer engagement with smart software.",
  icon: {
    reactIcons: FaTshirt, // fashion icon
    lucide: "ShoppingBag"
  },
  brand: {
    color: "#FF5722",
    accent: "#FFCCBC",
    gradient: "linear-gradient(135deg, #FF5722 0%, #FFCCBC 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Fashion & Apparel Businesses",
    subheadline:
      "From inventory management to e-commerce, we help fashion brands and retailers optimize operations, boost sales, and engage customers.",
    highlights: [
      { label: "Customer Engagement", value: "85%" },
      { label: "Operational Efficiency", value: "2.5x" },
      { label: "Sales Growth", value: "60%" }
    ],
    primaryButton: { label: "Book a Fashion Tech Consultation", href: "/contact?src=fashion-apparel" },
    secondaryButton: { label: "See Fashion Case Studies", href: "/case-studies?industry=fashion-apparel" },
    badge: "For Fashion Brands, Retailers, and E-commerce Platforms"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1521335629791-ce4aec67dd45?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Fashion e-commerce dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1512436991641-6745cdb1723f?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Online fashion store interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1521334884684-d80222895322?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Inventory management dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1503342217505-b0a15ec3261c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Customer engagement analytics"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual inventory tracking and stock management.",
    "Difficulty managing multiple sales channels.",
    "Limited insights into customer behavior and preferences.",
    "High administrative workload for order fulfillment and logistics.",
    "Challenges integrating e-commerce, POS, and warehouse systems.",
    "Slow marketing campaigns and customer engagement."
  ],

  solutions: {
    operations: [
      "Centralized inventory and order management system.",
      "Automated stock tracking and reordering.",
      "Sales and warehouse workflow automation.",
      "Multi-store and multi-channel management."
    ],
    integrations: [
      "Integration with e-commerce platforms (Shopify, WooCommerce).",
      "POS system integration for offline stores.",
      "Payment gateway and logistics APIs.",
      "Email, SMS, and social media marketing integration."
    ],
    analytics: [
      "Customer behavior and engagement dashboards.",
      "Sales and inventory analytics.",
      "Order fulfillment and delivery performance reports.",
      "Predictive insights for demand and trend forecasting."
    ],
    customerExperience: [
      "Online and mobile store interfaces.",
      "Personalized recommendations and promotions.",
      "Loyalty programs and automated notifications.",
      "Interactive fashion lookbooks and virtual try-ons."
    ]
  },

  services: [
    {
      title: "Fashion E-commerce Platform",
      description:
        "A platform to manage online sales, product catalogs, and customer engagement efficiently.",
      deliverables: [
        "Product catalog & inventory management",
        "Online store setup & customization",
        "Customer dashboards & personalization",
        "Order management & payment integration"
      ],
      icon: "FaShoppingBag",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Inventory & Operations Management",
      description:
        "Manage stock, warehouses, and supply chain operations seamlessly.",
      deliverables: [
        "Inventory tracking & alerts",
        "Warehouse & logistics integration",
        "Multi-store operations dashboards",
        "Automated reordering & stock alerts"
      ],
      icon: "FaWarehouse",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect your fashion business with e-commerce platforms, POS, payments, and marketing systems.",
      deliverables: [
        "E-commerce & POS integration",
        "Payment gateway setup",
        "Automated customer notifications",
        "Marketing & analytics integrations"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 100000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for sales, inventory, customer insights, and operational efficiency.",
      deliverables: [
        "Sales & inventory dashboards",
        "Customer behavior analytics",
        "Order fulfillment reports",
        "Trend and demand forecasting"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Product catalog & inventory management",
      "Order & fulfillment automation",
      "Sales analytics & dashboards",
      "Multi-store & multi-channel management",
      "Customer engagement tools"
    ],
    niceToHave: [
      "Mobile app for customers and staff",
      "AI-based product recommendations",
      "Automated marketing & notifications",
      "Virtual try-on & lookbooks",
      "Integration with logistics and POS systems"
    ]
  },

  integrations: [
    { name: "E-commerce Platforms (Shopify, WooCommerce)", category: "Sales Channels" },
    { name: "POS Systems", category: "Offline Retail" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Logistics & Delivery APIs", category: "Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Product & inventory modules", "E-commerce integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Online sales growth",
    "Customer engagement rate",
    "Inventory turnover",
    "Operational efficiency",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small boutiques & fashion stores",
      priceINR: 180000,
      timeline: "4–6 weeks",
      includes: [
        "Basic online store",
        "Inventory tracking",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium fashion brands & retail chains",
      priceINR: 320000,
      timeline: "6–8 weeks",
      includes: [
        "Custom product & inventory modules",
        "Multi-store & channel integration",
        "Advanced reporting & analytics",
        "Customer engagement tools"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large fashion brands & e-commerce platforms",
      priceINR: 550000,
      timeline: "8–12 weeks",
      includes: [
        "Full fashion & retail management platform",
        "AI-based product recommendations",
        "Mobile apps for customers & staff",
        "Integration with POS, e-commerce & logistics"
      ]
    }
  ],

  caseStudies: [
    {
      name: "StyleHub Retail",
      location: "Mumbai",
      goals: ["Digitize inventory", "Boost online sales"],
      outcomes: [
        "Online sales increased by 70%",
        "Inventory accuracy improved to 95%",
        "Customer engagement increased by 85%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Shopify API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Riya Kapoor",
      role: "Founder, StyleHub Retail",
      quote:
        "The fashion platform streamlined our operations and boosted online sales. Inventory management and customer engagement tools are a game-changer."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with multiple e-commerce platforms?",
      a: "Yes, we integrate with Shopify, WooCommerce, and other major platforms."
    },
    {
      q: "Does it support multi-store inventory management?",
      a: "Absolutely. You can manage multiple stores, warehouses, and channels from a single dashboard."
    },
    {
      q: "Can customers access personalized recommendations?",
      a: "Yes, AI-based recommendations and promotions can be displayed on your store."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, long-term maintenance, feature updates, and performance optimization are included."
    }
  ],

  cta: {
    title: "Ready to digitize your fashion business?",
    text:
      "Let’s build a platform that optimizes operations, boosts sales, and engages your customers.",
    primaryButton: { label: "Book a Free Fashion Tech Consultation", href: "/contact?plan=fashion-apparel" },
    secondaryButton: { label: "Download Fashion Tech Guide", href: "/resources/fashion-guide.pdf" }
  },

  seo: {
    metaTitle: "Fashion & Apparel Software Solutions | Optimize Retail & E-commerce",
    metaDescription:
      "We build custom software for fashion brands and retailers—inventory management, e-commerce, analytics, and customer engagement.",
    keywords: [
      "Fashion software",
      "Retail management system",
      "E-commerce platform",
      "Inventory management",
      "Customer engagement tools"
    ],
    canonical: "https://merndigital.com/industries/fashion-apparel",
    og: {
      title: "Fashion & Apparel Software Solutions",
      description: "Custom platforms for fashion brands, retailers, and e-commerce businesses.",
      // image:"https://images.unsplash.com/photo-1521335629791-ce4aec67dd45?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Fashion & Apparel Solutions",
      url: "https://merndigital.com/industries/fashion-apparel",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with multiple e-commerce platforms?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we integrate with Shopify, WooCommerce, and other major platforms."
          }
        },
        {
          "@type": "Question",
          name: "Does it support multi-store inventory management?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. You can manage multiple stores, warehouses, and channels from a single dashboard."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/fashion-apparel",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Fashion & Apparel Solutions",
       "item":"https://merndigital.com/industries/fashion-apparel"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 14,
  title: "Non-Profit & Social Impact Solutions",
  slug: "non-profit",
  segment: "Social Impact",
  summary:
    "We provide digital solutions for non-profit organizations, NGOs, and social enterprises—streamlining donor management, fundraising campaigns, volunteer coordination, and impact tracking with smart software.",
  icon: {
    reactIcons: FaHandsHelping, // non-profit icon
    lucide: "HeartHandshake"
  },
  brand: {
    color: "#4CAF50",
    accent: "#C8E6C9",
    gradient: "linear-gradient(135deg, #4CAF50 0%, #C8E6C9 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Non-Profit Organizations",
    subheadline:
      "From donor management to volunteer coordination, we help non-profits optimize operations, boost fundraising, and maximize social impact.",
    highlights: [
      { label: "Donor Engagement", value: "90%" },
      { label: "Operational Efficiency", value: "3x" },
      { label: "Campaign Reach", value: "50%" }
    ],
    primaryButton: { label: "Book a Non-Profit Tech Consultation", href: "/contact?src=non-profit" },
    secondaryButton: { label: "See Non-Profit Case Studies", href: "/case-studies?industry=non-profit" },
    badge: "For NGOs, Charities, and Social Enterprises"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1556740749-887f6717d7e4?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Non-profit management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1564767609342-620cb19b2357?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Volunteer coordination platform"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581093588401-6b6b9c258a5b?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Fundraising and donation tracking"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1599058917216-0a7e4e2f91c0?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Impact analytics dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual donor and volunteer management.",
    "Difficulty tracking fundraising campaigns and donations.",
    "Limited insights into program impact and performance.",
    "High administrative workload for staff and volunteers.",
    "Challenges integrating donation platforms and communication tools.",
    "Slow reporting and transparency for stakeholders."
  ],

  solutions: {
    operations: [
      "Centralized donor and volunteer management system.",
      "Automated campaign and event management.",
      "Program tracking and reporting dashboards.",
      "Staff and volunteer workflow management."
    ],
    integrations: [
      "Integration with donation and fundraising platforms.",
      "Payment gateway integration for donations.",
      "Email, SMS, and social media communication automation.",
      "Integration with analytics and reporting tools."
    ],
    analytics: [
      "Donor engagement and contribution dashboards.",
      "Campaign performance and fundraising reports.",
      "Volunteer activity and program impact analytics.",
      "Predictive insights for donor retention and fundraising."
    ],
    customerExperience: [
      "Online donation portals.",
      "Volunteer sign-up and management tools.",
      "Automated notifications and reminders.",
      "Interactive reporting and transparency dashboards."
    ]
  },

  services: [
    {
      title: "Donor & Volunteer Management Platform",
      description:
        "A platform to manage donors, volunteers, campaigns, and social programs efficiently.",
      deliverables: [
        "Donor and volunteer database",
        "Campaign and event modules",
        "Automated communications",
        "Impact dashboards"
      ],
      icon: "FaUsers",
      duration: "6–10 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Fundraising & Campaign System",
      description:
        "Manage donations, campaigns, and events seamlessly online.",
      deliverables: [
        "Online donation portal",
        "Fundraising campaign management",
        "Automated receipts and acknowledgments",
        "Donor engagement analytics"
      ],
      icon: "FaDonate",
      duration: "4–6 weeks",
      startingPriceINR: 150000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect donation platforms, payment gateways, communication tools, and reporting systems.",
      deliverables: [
        "Donation platform integration",
        "Payment gateway setup",
        "Automated notifications",
        "Analytics and reporting integrations"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 100000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for donor contributions, program impact, and operational efficiency.",
      deliverables: [
        "Donor and campaign dashboards",
        "Volunteer activity reports",
        "Program performance analytics",
        "Predictive impact insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 120000
    }
  ],

  features: {
    mustHave: [
      "Donor & volunteer management",
      "Campaign & event automation",
      "Impact analytics & dashboards",
      "Payment & donation tracking",
      "Communication tools for stakeholders"
    ],
    niceToHave: [
      "Mobile app for donors and volunteers",
      "AI-based donor retention insights",
      "Automated marketing & outreach",
      "Integration with CRM and fundraising tools",
      "Interactive program impact dashboards"
    ]
  },

  integrations: [
    { name: "Donation & Fundraising Platforms", category: "Donations" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Email & SMS Communication Tools", category: "Communication" },
    { name: "CRM & Volunteer Management Systems", category: "Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Donor & volunteer modules", "Campaign integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Donor engagement rate",
    "Volunteer activity & retention",
    "Fundraising target achievement",
    "Operational efficiency",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small NGOs & local non-profits",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic donor management",
        "Volunteer tracking",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium-sized NGOs & social enterprises",
      priceINR: 280000,
      timeline: "6–8 weeks",
      includes: [
        "Custom donor & campaign modules",
        "Volunteer management tools",
        "Advanced reporting & analytics",
        "Communication automation"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large NGOs & foundations",
      priceINR: 500000,
      timeline: "8–12 weeks",
      includes: [
        "Full non-profit management platform",
        "AI-based donor insights",
        "Mobile apps for volunteers and donors",
        "Integration with fundraising & CRM systems"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Hope Foundation",
      location: "Bangalore",
      goals: ["Digitize donor management", "Improve volunteer coordination"],
      outcomes: [
        "Donor engagement increased by 90%",
        "Volunteer retention improved by 70%",
        "Campaign reach expanded by 50%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Payment Gateway API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Anita Desai",
      role: "Director, Hope Foundation",
      quote:
        "The platform transformed how we manage donors, volunteers, and campaigns. Our operations are smoother and our impact more visible."
    }
  ],

  faqs: [
    {
      q: "Can this platform manage both donors and volunteers?",
      a: "Yes, it provides centralized management for donors, volunteers, campaigns, and events."
    },
    {
      q: "Does it support fundraising campaigns and donation tracking?",
      a: "Absolutely. You can track donations, campaign progress, and automate acknowledgments."
    },
    {
      q: "Can volunteers sign up online?",
      a: "Yes, volunteers can register and manage their activities through the platform."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, long-term maintenance, feature updates, and performance optimization are included."
    }
  ],

  cta: {
    title: "Ready to optimize your non-profit operations?",
    text:
      "Let’s build a platform that manages donors, volunteers, campaigns, and social impact efficiently.",
    primaryButton: { label: "Book a Free Non-Profit Tech Consultation", href: "/contact?plan=non-profit" },
    secondaryButton: { label: "Download Non-Profit Tech Guide", href: "/resources/non-profit-guide.pdf" }
  },

  seo: {
    metaTitle: "Non-Profit Software Solutions | Manage Donors & Volunteers",
    metaDescription:
      "We build custom software for NGOs and non-profits—donor management, volunteer coordination, fundraising, and impact analytics.",
    keywords: [
      "Non-profit software",
      "NGO management system",
      "Donor management platform",
      "Volunteer coordination software",
      "Fundraising solution"
    ],
    canonical: "https://merndigital.com/industries/non-profit",
    og: {
      title: "Non-Profit Software Solutions",
      description: "Custom platforms for NGOs, charities, and social enterprises.",
      // image:"https://images.unsplash.com/photo-1556740749-887f6717d7e4?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Non-Profit & Social Impact Solutions",
      url: "https://merndigital.com/industries/non-profit",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform manage both donors and volunteers?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, it provides centralized management for donors, volunteers, campaigns, and events."
          }
        },
        {
          "@type": "Question",
          name: "Does it support fundraising campaigns and donation tracking?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely. You can track donations, campaign progress, and automate acknowledgments."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/non-profit",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Non-Profit & Social Impact Solutions",
       "item":"https://merndigital.com/industries/non-profit"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 15,
  title: "Automotive Solutions",
  slug: "automotive",
  segment: "Transportation & Mobility",
  summary:
    "We provide digital solutions for automotive manufacturers, dealerships, and mobility services—streamlining vehicle inventory, sales, service management, and connected vehicle analytics with smart software.",
  icon: {
    reactIcons: FaCar, // automotive icon
    lucide: "Car"
  },
  brand: {
    color: "#1976D2",
    accent: "#BBDEFB",
    gradient: "linear-gradient(135deg, #1976D2 0%, #BBDEFB 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for Automotive Businesses",
    subheadline:
      "From dealership management to connected vehicle analytics, we help automotive brands and service providers optimize operations, enhance customer experiences, and boost sales.",
    highlights: [
      { label: "Inventory Accuracy", value: "95%" },
      { label: "Operational Efficiency", value: "2.5x" },
      { label: "Sales Growth", value: "40%" }
    ],
    primaryButton: { label: "Book an Automotive Tech Consultation", href: "/contact?src=automotive" },
    secondaryButton: { label: "See Automotive Case Studies", href: "/case-studies?industry=automotive" },
    badge: "For Automotive Manufacturers, Dealerships, and Mobility Services"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Automotive management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1517423440428-a5a00ad493e8?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Vehicle inventory dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1549921296-3a03c18d99c3?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Dealer sales and service management"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1571607388905-d6f3cbf693e5?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Connected car analytics dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual tracking of vehicle inventory and sales.",
    "Difficulty managing multiple dealerships or branches.",
    "Limited insights into customer preferences and buying behavior.",
    "High administrative workload for service scheduling and parts management.",
    "Challenges integrating CRM, sales, and service systems.",
    "Slow reporting on sales, inventory, and service performance."
  ],

  solutions: {
    operations: [
      "Centralized vehicle inventory and sales management.",
      "Automated service scheduling and parts tracking.",
      "Workflow automation for dealerships and service centers.",
      "Multi-branch and multi-dealer management."
    ],
    integrations: [
      "Integration with CRM and ERP systems.",
      "Payment gateway integration for vehicle purchases and service.",
      "Service and parts supplier APIs.",
      "Marketing automation for customer engagement."
    ],
    analytics: [
      "Sales and inventory dashboards.",
      "Customer and vehicle lifecycle analytics.",
      "Service and parts performance reports.",
      "Predictive insights for demand and maintenance scheduling."
    ],
    customerExperience: [
      "Online vehicle booking and test-drive scheduling.",
      "Personalized offers and promotions.",
      "Automated notifications for service and sales.",
      "Connected vehicle dashboards and mobile apps."
    ]
  },

  services: [
    {
      title: "Dealership & Inventory Management",
      description:
        "Manage vehicles, inventory, and sales efficiently across multiple branches.",
      deliverables: [
        "Vehicle database & inventory tracking",
        "Sales dashboards & reporting",
        "Multi-branch management",
        "Automated stock alerts & reordering"
      ],
      icon: "FaWarehouse",
      duration: "6–10 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Service & Maintenance Management",
      description:
        "Manage vehicle service scheduling, parts, and customer communications seamlessly.",
      deliverables: [
        "Service booking & scheduling system",
        "Parts inventory management",
        "Automated customer notifications",
        "Service analytics & reports"
      ],
      icon: "FaTools",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect dealership software with CRM, ERP, payment gateways, and analytics tools.",
      deliverables: [
        "CRM & ERP integration",
        "Payment gateway setup",
        "Automated notifications & reminders",
        "Reporting & analytics integration"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for sales, inventory, service, and customer insights.",
      deliverables: [
        "Sales & inventory dashboards",
        "Service and parts reports",
        "Customer behavior analytics",
        "Predictive maintenance insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 140000
    }
  ],

  features: {
    mustHave: [
      "Vehicle inventory management",
      "Sales & service dashboards",
      "Multi-branch dealership management",
      "Customer engagement & CRM integration",
      "Service scheduling & parts tracking"
    ],
    niceToHave: [
      "Connected vehicle dashboards",
      "Mobile app for customers & staff",
      "AI-based sales & service predictions",
      "Automated marketing & promotions",
      "Integration with third-party analytics & ERP"
    ]
  },

  integrations: [
    { name: "CRM Systems (Salesforce, Zoho)", category: "Sales & Customer Management" },
    { name: "ERP & Inventory Systems", category: "Operations" },
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "Service & Parts Supplier APIs", category: "Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Inventory modules", "Service & sales integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Vehicle inventory accuracy",
    "Sales growth & conversion rate",
    "Service efficiency & turnaround",
    "Customer satisfaction score",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small dealerships & garages",
      priceINR: 200000,
      timeline: "4–6 weeks",
      includes: [
        "Basic inventory & sales management",
        "Service scheduling",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium-sized dealerships & automotive businesses",
      priceINR: 350000,
      timeline: "6–8 weeks",
      includes: [
        "Advanced inventory & sales modules",
        "Multi-branch management",
        "Service & parts tracking",
        "Analytics & reporting dashboards"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large automotive chains & manufacturers",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Full automotive management platform",
        "Connected vehicle analytics",
        "Mobile apps for customers & staff",
        "Integration with ERP, CRM & analytics tools"
      ]
    }
  ],

  caseStudies: [
    {
      name: "AutoHub Dealership",
      location: "Pune",
      goals: ["Digitize inventory management", "Improve service operations"],
      outcomes: [
        "Inventory accuracy improved by 95%",
        "Service turnaround time reduced by 30%",
        "Sales conversion increased by 25%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "ERP API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Rajesh Verma",
      role: "Operations Manager, AutoHub Dealership",
      quote:
        "The platform streamlined our inventory, sales, and service operations. Our efficiency and customer satisfaction have greatly improved."
    }
  ],

  faqs: [
    {
      q: "Can this platform manage multiple dealership branches?",
      a: "Yes, you can manage inventory, sales, and service across multiple branches from a single dashboard."
    },
    {
      q: "Does it support connected vehicle analytics?",
      a: "Yes, the platform can integrate with connected vehicle systems to provide real-time insights."
    },
    {
      q: "Can we automate service scheduling and notifications?",
      a: "Absolutely, the system automates service bookings, reminders, and parts management."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, long-term maintenance, feature updates, and performance optimization are included."
    }
  ],

  cta: {
    title: "Ready to digitize your automotive operations?",
    text:
      "Let’s build a platform that manages inventory, sales, service, and connected vehicle analytics efficiently.",
    primaryButton: { label: "Book a Free Automotive Tech Consultation", href: "/contact?plan=automotive" },
    secondaryButton: { label: "Download Automotive Tech Guide", href: "/resources/automotive-guide.pdf" }
  },

  seo: {
    metaTitle: "Automotive Software Solutions | Dealership & Vehicle Management",
    metaDescription:
      "We build custom software for automotive businesses—inventory, sales, service management, connected vehicle analytics, and customer engagement.",
    keywords: [
      "Automotive software",
      "Dealership management system",
      "Vehicle inventory management",
      "Service & maintenance software",
      "Connected vehicle analytics"
    ],
    canonical: "https://merndigital.com/industries/automotive",
    og: {
      title: "Automotive Software Solutions",
      description: "Custom platforms for automotive manufacturers, dealerships, and mobility services.",
      // image:"https://images.unsplash.com/photo-1503376780353-7e6692767b70?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Automotive Solutions",
      url: "https://merndigital.com/industries/automotive",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform manage multiple dealership branches?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can manage inventory, sales, and service across multiple branches from a single dashboard."
          }
        },
        {
          "@type": "Question",
          name: "Does it support connected vehicle analytics?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, the platform can integrate with connected vehicle systems to provide real-time insights."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/automotive",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "Automotive Solutions",
       "item":"https://merndigital.com/industries/"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 16,
  title: "E-Commerce Solutions",
  slug: "e-commerce",
  segment: "Retail & Online Commerce",
  summary:
    "We provide digital solutions for e-commerce businesses, online marketplaces, and retail brands—streamlining product management, orders, payments, logistics, and customer experiences with smart software.",
  icon: {
    reactIcons: FaShoppingCart, // e-commerce icon
    lucide: "ShoppingCart"
  },
  brand: {
    color: "#FF5722",
    accent: "#FFCCBC",
    gradient: "linear-gradient(135deg, #FF5722 0%, #FFCCBC 100%)",
    
  },

  hero: {
    headline: "Digital Solutions for E-Commerce Businesses",
    subheadline:
      "From product management to customer experience, we help online retailers optimize operations, boost sales, and improve customer retention.",
    highlights: [
      { label: "Order Accuracy", value: "98%" },
      { label: "Operational Efficiency", value: "3x" },
      { label: "Revenue Growth", value: "45%" }
    ],
    primaryButton: { label: "Book an E-Commerce Tech Consultation", href: "/contact?src=e-commerce" },
    secondaryButton: { label: "See E-Commerce Case Studies", href: "/case-studies?industry=e-commerce" },
    badge: "For Online Retailers, Marketplaces, and Brands"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1581091012184-1f2d6ed9f0c1?q=80&w=1600&auto=format&fit=crop",
  //   alt: "E-commerce management dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1581090700221-7b29d0338f12?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Product catalog management"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581090753480-1c5ec8f9de2f?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Order and inventory dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581090782881-3b6aebf7f0ff?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Customer analytics and insights"
  //     }
  //   ]
  // },

  painPoints: [
    "Manual product and inventory management.",
    "Difficulty handling large order volumes and returns.",
    "Limited insights into customer behavior and sales trends.",
    "High operational workload for order fulfillment and logistics.",
    "Challenges integrating payment gateways, shipping, and marketing tools.",
    "Slow reporting on sales, revenue, and customer metrics."
  ],

  solutions: {
    operations: [
      "Centralized product and inventory management.",
      "Automated order processing and fulfillment.",
      "Workflow automation for warehouses and logistics.",
      "Multi-channel and marketplace management."
    ],
    integrations: [
      "Integration with payment gateways (Razorpay, Stripe, PayPal).",
      "Shipping & logistics provider integrations.",
      "Marketing automation & CRM tools.",
      "Analytics and reporting tool integrations."
    ],
    analytics: [
      "Sales and revenue dashboards.",
      "Customer behavior and purchase analytics.",
      "Order and fulfillment performance reports.",
      "Predictive insights for demand and inventory planning."
    ],
    customerExperience: [
      "Seamless online checkout and payment experience.",
      "Personalized recommendations and promotions.",
      "Automated notifications for order status and delivery.",
      "Loyalty programs and customer engagement tools."
    ]
  },

  services: [
    {
      title: "Product & Inventory Management",
      description:
        "Manage product catalog, stock, and multi-channel listings efficiently.",
      deliverables: [
        "Product database & SKU management",
        "Inventory tracking & alerts",
        "Multi-channel product publishing",
        "Reporting dashboards"
      ],
      icon: "FaBox",
      duration: "5–8 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Order & Logistics Management",
      description:
        "Automate order processing, shipping, and fulfillment workflows.",
      deliverables: [
        "Order management system",
        "Shipping & logistics integration",
        "Automated customer notifications",
        "Fulfillment and returns tracking"
      ],
      icon: "FaShippingFast",
      duration: "4–6 weeks",
      startingPriceINR: 180000
    },
    {
      title: "Integrations & Automation",
      description:
        "Connect payment gateways, CRM, marketing, and analytics systems.",
      deliverables: [
        "Payment gateway setup",
        "CRM & marketing automation integration",
        "Inventory & logistics system connections",
        "Analytics and reporting integrations"
      ],
      icon: "FaPlug",
      duration: "3–5 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Analytics & Reporting",
      description:
        "Dashboards for sales, revenue, inventory, and customer insights.",
      deliverables: [
        "Sales & revenue dashboards",
        "Customer behavior analytics",
        "Order & fulfillment performance reports",
        "Predictive sales and inventory insights"
      ],
      icon: "FaChartLine",
      duration: "3–4 weeks",
      startingPriceINR: 140000
    }
  ],

  features: {
    mustHave: [
      "Product & inventory management",
      "Order processing & fulfillment",
      "Multi-channel marketplace management",
      "Customer engagement & CRM integration",
      "Sales & revenue dashboards"
    ],
    niceToHave: [
      "Personalized product recommendations",
      "Mobile app for customers & staff",
      "AI-based sales forecasting",
      "Automated marketing & promotions",
      "Integration with third-party logistics & analytics tools"
    ]
  },

  integrations: [
    { name: "Payment Gateways (Razorpay, Stripe, PayPal)", category: "Payments" },
    { name: "CRM & Marketing Automation Tools", category: "Customer Engagement" },
    { name: "Shipping & Logistics Providers", category: "Operations" },
    { name: "ERP & Inventory Systems", category: "Operations" },
    { name: "Analytics Tools (Power BI, Tableau)", category: "Reporting" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "User roles", "Workflow diagrams"] },
    { step: 2, title: "Architecture & Design", duration: "1–2 weeks", outputs: ["Database schema", "Wireframes", "Integration plan"] },
    { step: 3, title: "Development", duration: "3–5 weeks", outputs: ["Product & order modules", "Payment & logistics integration", "Dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1 week", outputs: ["Functional testing", "UAT", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live system", "User training", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance reports"] }
  ],

  kpis: [
    "Order accuracy & fulfillment rate",
    "Sales growth & revenue",
    "Customer satisfaction & retention",
    "Inventory turnover",
    "System uptime & reliability"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small online stores & boutique retailers",
      priceINR: 180000,
      timeline: "4–6 weeks",
      includes: [
        "Basic product & inventory management",
        "Order processing",
        "Simple dashboards",
        "Automated notifications"
      ]
    },
    {
      tier: "Growth",
      audience: "Medium-sized e-commerce businesses",
      priceINR: 320000,
      timeline: "6–8 weeks",
      includes: [
        "Advanced product & order modules",
        "Multi-channel marketplace management",
        "Analytics & reporting dashboards",
        "Customer engagement automation"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large online retailers & marketplaces",
      priceINR: 550000,
      timeline: "8–12 weeks",
      includes: [
        "Full e-commerce management platform",
        "AI-based sales & inventory insights",
        "Mobile apps for customers & staff",
        "Integration with payment, logistics & analytics systems"
      ]
    }
  ],

  caseStudies: [
    {
      name: "ShopEase Online",
      location: "Bangalore",
      goals: ["Digitize product & order management", "Improve sales & customer retention"],
      outcomes: [
        "Order accuracy increased to 98%",
        "Revenue grew by 45%",
        "Customer retention improved by 35%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "Stripe API", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Neha Sharma",
      role: "Founder, ShopEase Online",
      quote:
        "The platform streamlined our e-commerce operations, making inventory, orders, and customer engagement seamless. Our revenue and efficiency skyrocketed."
    }
  ],

  faqs: [
    {
      q: "Can this platform manage multiple online marketplaces?",
      a: "Yes, you can manage products, orders, and inventory across multiple channels from a single dashboard."
    },
    {
      q: "Does it support payment gateway integration?",
      a: "Absolutely, the platform integrates with popular payment gateways like Razorpay, Stripe, and PayPal."
    },
    {
      q: "Can we automate order notifications and shipping updates?",
      a: "Yes, automated notifications for order confirmation, shipping, and delivery are included."
    },
    {
      q: "Do you provide ongoing support?",
      a: "Yes, long-term maintenance, feature updates, and performance optimization are included."
    }
  ],

  cta: {
    title: "Ready to scale your e-commerce business?",
    text:
      "Let’s build a platform that manages products, orders, payments, and customer experiences efficiently.",
    primaryButton: { label: "Book a Free E-Commerce Tech Consultation", href: "/contact?plan=e-commerce" },
    secondaryButton: { label: "Download E-Commerce Tech Guide", href: "/resources/e-commerce-guide.pdf" }
  },

  seo: {
    metaTitle: "E-Commerce Software Solutions | Online Store & Marketplace Management",
    metaDescription:
      "We build custom software for e-commerce businesses—product management, order fulfillment, payment integration, logistics, and analytics.",
    keywords: [
      "E-commerce software",
      "Online store management",
      "Order & inventory management",
      "Payment & shipping integration",
      "Customer engagement platform"
    ],
    canonical: "https://merndigital.com/industries/e-commerce",
    og: {
      title: "E-Commerce Software Solutions",
      description: "Custom platforms for online retailers, marketplaces, and e-commerce brands.",
      // image:"https://images.unsplash.com/photo-1581091012184-1f2d6ed9f0c1?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — E-Commerce Solutions",
      url: "https://merndigital.com/industries/e-commerce",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform manage multiple online marketplaces?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, you can manage products, orders, and inventory across multiple channels from a single dashboard."
          }
        },
        {
          "@type": "Question",
          name: "Does it support payment gateway integration?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely, the platform integrates with popular payment gateways like Razorpay, Stripe, and PayPal."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/e-commerce",
    breadcrumbs: {
     "@context": "https://schema.org",
     "@type": "BreadcrumbList",
     "itemListElement": [{
       "@type": "ListItem",
       "position": 1,
       "name": "Industry",
       "item": "https://merndigital.com/industries"
     },{
       "@type": "ListItem",
       "position": 2,
       "name": "E-Commerce Solutions",
       "item":"https://merndigital.com/industries/e-commerce"
     }]
   }

  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 17,
  title: "Agriculture Solutions",
  slug: "agriculture",
  segment: "AgriTech & Smart Farming",
  summary:
    "We provide digital solutions for agriculture—helping farmers, agribusinesses, and cooperatives streamline farm management, supply chains, analytics, and sustainability tracking with smart software.",
  icon: {
    reactIcons: FaSeedling, // agriculture icon
    lucide: "Sprout"
  },
  brand: {
    color: "#4CAF50",
    accent: "#C8E6C9",
    gradient: "linear-gradient(135deg, #4CAF50 0%, #C8E6C9 100%)",
    
  },

  hero: {
    headline: "Smart Digital Solutions for Agriculture",
    subheadline:
      "From precision farming to supply chain management, we help farmers and agri-enterprises increase yield, reduce waste, and improve profitability.",
    highlights: [
      { label: "Crop Yield Improvement", value: "30%" },
      { label: "Water Usage Efficiency", value: "40%" },
      { label: "Operational Cost Reduction", value: "25%" }
    ],
    primaryButton: { label: "Book an Agriculture Tech Consultation", href: "/contact?src=agriculture" },
    secondaryButton: { label: "See Agriculture Case Studies", href: "/case-studies?industry=agriculture" },
    badge: "For Farmers, Cooperatives, and Agri-Businesses"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1599058917212-d750089bc07b?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Smart farming and agriculture technology dashboard",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1560493676-04071c5f467b?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Farm management dashboard"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1559757175-5700dde675ed?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Drone and IoT monitoring in fields"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1549887534-3db1bd59dcca?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Supply chain and logistics for agriculture"
  //     }
  //   ]
  // },

  painPoints: [
    "Low crop yields due to lack of data-driven decisions.",
    "Manual farm and livestock management.",
    "Unpredictable weather and pest risks.",
    "Limited market access and supply chain inefficiencies.",
    "High water and resource wastage.",
    "Difficulty tracking sustainability and compliance."
  ],

  solutions: {
    operations: [
      "Farm management systems for crops and livestock.",
      "IoT & drone monitoring for soil, water, and pest control.",
      "Supply chain and logistics management.",
      "Digital marketplaces for farmers and buyers."
    ],
    integrations: [
      "Weather APIs for predictive analytics.",
      "IoT sensors for soil and crop monitoring.",
      "ERP integration for agribusiness operations.",
      "Blockchain for supply chain transparency."
    ],
    analytics: [
      "Yield prediction and crop analytics.",
      "Resource usage tracking (water, fertilizer).",
      "Supply chain performance dashboards.",
      "Sustainability and compliance reporting."
    ],
    customerExperience: [
      "Mobile apps for farmers and cooperatives.",
      "Market price notifications and insights.",
      "Automated alerts for irrigation and pest control.",
      "Digital wallets and payment integration."
    ]
  },

  services: [
    {
      title: "Farm Management Systems",
      description:
        "Centralized software for managing crops, livestock, and farm resources.",
      deliverables: [
        "Crop & livestock tracking",
        "Resource usage dashboards",
        "Farm workflow automation",
        "Mobile farmer portal"
      ],
      icon: "FaTractor",
      duration: "5–8 weeks",
      startingPriceINR: 220000
    },
    {
      title: "IoT & Smart Farming",
      description:
        "Integrate IoT sensors and drones for precision agriculture.",
      deliverables: [
        "IoT sensor integration",
        "Drone monitoring setup",
        "Soil & water analytics",
        "Real-time alerts"
      ],
      icon: "FaMicrochip",
      duration: "6–8 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Supply Chain & Marketplaces",
      description:
        "Digital platforms for farm-to-market supply chains and cooperative trading.",
      deliverables: [
        "Farmer-to-buyer platforms",
        "Logistics management",
        "Blockchain traceability",
        "Payment & wallet systems"
      ],
      icon: "FaNetworkWired",
      duration: "4–6 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Agriculture Analytics",
      description:
        "Data-driven insights for yield forecasting, sustainability, and profitability.",
      deliverables: [
        "Crop yield prediction",
        "Resource optimization analytics",
        "Market price dashboards",
        "Sustainability reports"
      ],
      icon: "FaChartArea",
      duration: "3–5 weeks",
      startingPriceINR: 150000
    }
  ],

  features: {
    mustHave: [
      "Farm management system",
      "IoT & drone integration",
      "Supply chain & logistics tracking",
      "Yield prediction dashboards",
      "Mobile farmer apps"
    ],
    niceToHave: [
      "Blockchain traceability",
      "AI-based pest & weather forecasting",
      "Digital marketplaces & e-wallets",
      "Satellite imaging integration",
      "Automated compliance reporting"
    ]
  },

  integrations: [
    { name: "IoT Sensors (Soil, Water, Climate)", category: "Smart Farming" },
    { name: "Weather APIs", category: "Predictive Analytics" },
    { name: "Blockchain Supply Chain", category: "Transparency" },
    { name: "ERP Systems", category: "Operations" },
    { name: "Mobile Payment Gateways", category: "Finance" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Tailwind CSS"],
    backend: ["Node.js", "Django", "Spring Boot"],
    database: ["PostgreSQL", "MongoDB"],
    hosting: ["AWS", "Azure"],
    analytics: ["Power BI", "Tableau"],
    security: ["JWT Auth", "OAuth2", "Blockchain Security"]
  },

  process: [
    { step: 1, title: "Discovery & Requirements", duration: "1–2 weeks", outputs: ["Feature list", "Farm workflow mapping", "Integration plan"] },
    { step: 2, title: "System Design & Architecture", duration: "1–2 weeks", outputs: ["Database schema", "IoT/ERP integration blueprint", "UI mockups"] },
    { step: 3, title: "Development", duration: "4–6 weeks", outputs: ["Farm management modules", "IoT integrations", "Analytics dashboards"] },
    { step: 4, title: "Testing & QA", duration: "1–2 weeks", outputs: ["Functional testing", "IoT data testing", "Security checks"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Live platform", "Farmer onboarding", "Documentation"] },
    { step: 6, title: "Support & Optimization", duration: "Ongoing", outputs: ["Bug fixes", "Feature upgrades", "Performance monitoring"] }
  ],

  kpis: [
    "Crop yield per hectare",
    "Resource efficiency (water, fertilizer)",
    "Supply chain turnaround time",
    "Farmer adoption rate",
    "Market access growth"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small farmers & cooperatives",
      priceINR: 150000,
      timeline: "4–6 weeks",
      includes: [
        "Basic farm management system",
        "Weather & market integration",
        "Mobile farmer app",
        "Simple dashboards"
      ]
    },
    {
      tier: "Growth",
      audience: "Agri-businesses & mid-sized farms",
      priceINR: 300000,
      timeline: "6–8 weeks",
      includes: [
        "IoT & drone integration",
        "Supply chain platform",
        "Analytics dashboards",
        "Mobile & web apps"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large agriculture enterprises",
      priceINR: 550000,
      timeline: "8–12 weeks",
      includes: [
        "Full agri-management platform",
        "Blockchain-enabled supply chain",
        "AI-based yield forecasting",
        "Integration with ERP & analytics systems"
      ]
    }
  ],

  caseStudies: [
    {
      name: "AgriGrow Cooperative",
      location: "Punjab",
      goals: ["Digitize farm management", "Improve yield & market access"],
      outcomes: [
        "Yield increased by 30%",
        "Water usage reduced by 40%",
        "Farmer profits grew by 25%"
      ],
      stack: ["React", "Node.js", "PostgreSQL", "IoT Sensors", "Power BI"]
    }
  ],

  testimonials: [
    {
      author: "Ravi Singh",
      role: "Director, AgriGrow Cooperative",
      quote:
        "The platform transformed our operations—farmers now use data for decisions, yields improved, and our supply chain runs seamlessly."
    }
  ],

  faqs: [
    {
      q: "Can this platform integrate with IoT sensors?",
      a: "Yes, it integrates with soil, water, and weather IoT sensors for precision farming."
    },
    {
      q: "Does it support supply chain management?",
      a: "Absolutely, it digitizes farm-to-market logistics with full traceability."
    },
    {
      q: "Can small farmers use it easily?",
      a: "Yes, we provide mobile apps with local language support for easy adoption."
    },
    {
      q: "Do you offer ongoing support?",
      a: "Yes, we provide continuous support, upgrades, and performance optimization."
    }
  ],

  cta: {
    title: "Ready to digitize your agriculture operations?",
    text:
      "Let’s build smart farming and agribusiness platforms that boost yield, efficiency, and profitability.",
    primaryButton: { label: "Book a Free Agriculture Tech Consultation", href: "/contact?plan=agriculture" },
    secondaryButton: { label: "Download Agriculture Tech Guide", href: "/resources/agriculture-guide.pdf" }
  },

  seo: {
    metaTitle: "Agriculture Software Solutions | Smart Farming & AgriTech Platforms",
    metaDescription:
      "We build AgriTech platforms—farm management, IoT, supply chain, and analytics to help farmers and agribusinesses grow smarter.",
    keywords: [
      "Agriculture software",
      "Farm management system",
      "AgriTech platform",
      "Smart farming IoT",
      "Agriculture supply chain"
    ],
    canonical: "https://merndigital.com/industries/agriculture",
    og: {
      title: "Agriculture Software Solutions",
      description: "Smart digital platforms for farmers, cooperatives, and agri-businesses.",
      // image:"https://images.unsplash.com/photo-1599058917212-d750089bc07b?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Agriculture Solutions",
      url: "https://merndigital.com/industries/agriculture",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can this platform integrate with IoT sensors?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, it integrates with soil, water, and weather IoT sensors for precision farming."
          }
        },
        {
          "@type": "Question",
          name: "Does it support supply chain management?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely, it digitizes farm-to-market logistics with full traceability."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/agriculture",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industry",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Agriculture Solutions",
        "item":"https://merndigital.com/industries/agriculture"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 18,
  title: "IT & Technology Consulting Solutions",
  slug: "it-consulting",
  segment: "Digital Transformation & Tech Advisory",
  summary:
    "We help businesses leverage IT and technology consulting to modernize operations, implement scalable solutions, and drive digital transformation with security and efficiency at the core.",
  icon: {
    reactIcons: FaLaptopCode, // IT consulting icon
    lucide: "MonitorSmartphone"
  },
  brand: {
    color: "#0D47A1",
    accent: "#BBDEFB",
    gradient: "linear-gradient(135deg, #0D47A1 0%, #BBDEFB 100%)",
    
  },

  hero: {
    headline: "Transform Your Business with IT & Technology Consulting",
    subheadline:
      "From IT strategy to cloud migration and cybersecurity, we help organizations modernize infrastructure, improve efficiency, and scale with confidence.",
    highlights: [
      { label: "Cloud Adoption Acceleration", value: "60%" },
      { label: "IT Cost Reduction", value: "35%" },
      { label: "Cybersecurity Risk Reduction", value: "50%" }
    ],
    primaryButton: { label: "Book a Free IT Consultation", href: "/contact?src=it-consulting" },
    secondaryButton: { label: "See Technology Case Studies", href: "/case-studies?industry=it-consulting" },
    badge: "For Enterprises, SMBs, and Startups"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1600&auto=format&fit=crop",
  //   alt: "IT consulting and digital transformation solutions",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Cloud migration consulting"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1519389950473-47ba0277781c?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Team discussing IT strategy"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1555949963-ff9fe0c870eb?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Cybersecurity monitoring dashboard"
  //     }
  //   ]
  // },

  painPoints: [
    "Legacy systems limiting scalability.",
    "High IT maintenance costs.",
    "Lack of cloud adoption strategy.",
    "Cybersecurity risks and compliance issues.",
    "Disconnected IT infrastructure and tools.",
    "Difficulty aligning IT with business goals."
  ],

  solutions: {
    operations: [
      "IT infrastructure modernization.",
      "Cloud migration and optimization.",
      "Business process automation.",
      "End-to-end IT strategy consulting."
    ],
    integrations: [
      "ERP and CRM system integrations.",
      "Cloud-native solutions (AWS, Azure, GCP).",
      "API and middleware integrations.",
      "Single Sign-On and IAM solutions."
    ],
    analytics: [
      "IT performance monitoring dashboards.",
      "Cloud usage and cost analytics.",
      "Cybersecurity threat detection analytics.",
      "IT project ROI measurement."
    ],
    customerExperience: [
      "Seamless user experience with optimized systems.",
      "Scalable cloud applications for business continuity.",
      "Remote collaboration tools.",
      "24/7 monitoring and support services."
    ]
  },

  services: [
    {
      title: "IT Strategy & Consulting",
      description:
        "Align IT with your business objectives to maximize ROI and scalability.",
      deliverables: [
        "Digital transformation roadmap",
        "Gap analysis and IT audits",
        "Technology adoption strategy",
        "Cost optimization plan"
      ],
      icon: "FaProjectDiagram",
      duration: "2–4 weeks",
      startingPriceINR: 150000
    },
    {
      title: "Cloud Migration & Management",
      description:
        "Migrate legacy systems to the cloud and optimize performance.",
      deliverables: [
        "Cloud readiness assessment",
        "Migration planning & execution",
        "Cloud monitoring & cost optimization",
        "Disaster recovery setup"
      ],
      icon: "FaCloudUploadAlt",
      duration: "4–8 weeks",
      startingPriceINR: 250000
    },
    {
      title: "Cybersecurity Consulting",
      description:
        "Protect your business with advanced cybersecurity strategies and monitoring.",
      deliverables: [
        "Vulnerability assessment",
        "Compliance (GDPR, HIPAA, ISO)",
        "Threat monitoring dashboards",
        "Incident response planning"
      ],
      icon: "FaShieldAlt",
      duration: "3–6 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Enterprise IT Integrations",
      description:
        "Seamless integration of ERP, CRM, and business tools for efficiency.",
      deliverables: [
        "ERP/CRM integration",
        "API & middleware setup",
        "Single Sign-On (SSO) implementation",
        "Workflow automation"
      ],
      icon: "FaConnectdevelop",
      duration: "3–5 weeks",
      startingPriceINR: 180000
    }
  ],

  features: {
    mustHave: [
      "Cloud migration strategy",
      "Cybersecurity monitoring",
      "IT infrastructure modernization",
      "Enterprise system integration",
      "Scalable IT roadmap"
    ],
    niceToHave: [
      "AI-powered IT analytics",
      "Zero-trust security model",
      "Blockchain for IT security",
      "Automation & RPA solutions",
      "24/7 managed IT services"
    ]
  },

  integrations: [
    { name: "AWS / Azure / GCP", category: "Cloud" },
    { name: "SAP / Oracle", category: "ERP" },
    { name: "Salesforce / HubSpot", category: "CRM" },
    { name: "Okta / Auth0", category: "Identity & Access" },
    { name: "Splunk / Datadog", category: "Monitoring & Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Angular"],
    backend: ["Node.js", "Spring Boot", "Django"],
    database: ["PostgreSQL", "MongoDB", "OracleDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Power BI", "Tableau", "Splunk"],
    security: ["OAuth2", "JWT", "Zero Trust Security"]
  },

  process: [
    { step: 1, title: "Discovery & Assessment", duration: "1–2 weeks", outputs: ["IT audit", "Business alignment plan", "Tech stack recommendation"] },
    { step: 2, title: "Strategy & Roadmap", duration: "1–2 weeks", outputs: ["Digital roadmap", "Cloud adoption strategy", "Security framework"] },
    { step: 3, title: "Implementation", duration: "4–6 weeks", outputs: ["Cloud migration", "System integration", "Security setup"] },
    { step: 4, title: "Testing & QA", duration: "1–2 weeks", outputs: ["System testing", "Integration testing", "Security audits"] },
    { step: 5, title: "Deployment & Training", duration: "1 week", outputs: ["Deployed systems", "Employee training", "Documentation"] },
    { step: 6, title: "Ongoing Support", duration: "Continuous", outputs: ["Monitoring", "Optimization", "Updates & patches"] }
  ],

  kpis: [
    "IT cost savings",
    "Cloud adoption rate",
    "System uptime & performance",
    "Cybersecurity incident reduction",
    "ROI on IT investments"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small Businesses",
      priceINR: 120000,
      timeline: "3–4 weeks",
      includes: [
        "IT audit & strategy",
        "Basic cloud migration",
        "Cybersecurity assessment",
        "Performance dashboard"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-size Businesses",
      priceINR: 300000,
      timeline: "6–8 weeks",
      includes: [
        "Full IT strategy",
        "Cloud migration & optimization",
        "Cybersecurity implementation",
        "Enterprise integrations"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large Enterprises",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Complete IT transformation",
        "Hybrid cloud setup",
        "Advanced security & compliance",
        "24/7 IT support & monitoring"
      ]
    }
  ],

  caseStudies: [
    {
      name: "TechNova Corp",
      location: "Bangalore",
      goals: ["Migrate to cloud", "Improve IT efficiency", "Enhance cybersecurity"],
      outcomes: [
        "Reduced IT costs by 40%",
        "Migrated 95% of workloads to cloud",
        "Zero security breaches post-implementation"
      ],
      stack: ["AWS", "React", "Node.js", "Splunk", "Okta"]
    }
  ],

  testimonials: [
    {
      author: "Anjali Mehra",
      role: "CTO, TechNova Corp",
      quote:
        "Mern Digital helped us modernize IT infrastructure, cut costs, and improve security. Their consulting made our cloud migration seamless."
    }
  ],

  faqs: [
    {
      q: "Can you help with both cloud and on-premise systems?",
      a: "Yes, we design hybrid IT strategies that fit your business requirements."
    },
    {
      q: "Do you provide ongoing IT support?",
      a: "Absolutely, we offer managed IT services with 24/7 monitoring."
    },
    {
      q: "Can you integrate ERP and CRM systems?",
      a: "Yes, we provide seamless integration across ERP, CRM, and third-party apps."
    },
    {
      q: "How do you ensure IT security?",
      a: "We use best practices including zero-trust models, encryption, and compliance frameworks."
    }
  ],

  cta: {
    title: "Ready to transform your IT infrastructure?",
    text:
      "Let’s build secure, scalable, and cost-effective IT systems that power your digital transformation.",
    primaryButton: { label: "Book Your Free IT Consultation", href: "/contact?plan=it-consulting" },
    secondaryButton: { label: "Download IT Consulting Guide", href: "/resources/it-consulting-guide.pdf" }
  },

  seo: {
    metaTitle: "IT & Technology Consulting | Cloud, Security & Digital Transformation",
    metaDescription:
      "We provide IT & technology consulting—cloud migration, cybersecurity, IT strategy, and enterprise integrations for scalable growth.",
    keywords: [
      "IT consulting",
      "Technology consulting",
      "Cloud migration services",
      "Cybersecurity consulting",
      "Enterprise IT strategy"
    ],
    canonical: "https://merndigital.com/industries/it-consulting",
    og: {
      title: "IT & Technology Consulting Solutions",
      description: "Modern IT strategies for cloud, cybersecurity, and digital transformation.",
      // image:"https://images.unsplash.com/photo-1558494949-ef010cbdcc31?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — IT Consulting Solutions",
      url: "https://merndigital.com/industries/it-consulting",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you handle hybrid IT systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we support on-premise, cloud, and hybrid infrastructures."
          }
        },
        {
          "@type": "Question",
          name: "Do you provide managed IT services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we offer 24/7 monitoring, optimization, and IT support."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/it-consulting",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "IT & Technology Consulting",
        "item":"https://merndigital.com/industries/it-consulting"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 19,
  title: "Entertainment Company Solutions",
  slug: "entertainment-companies",
  segment: "Digital Platforms & Marketing for Entertainment",
  summary:
    "We help entertainment companies promote movies, music, shows, and events with high-converting websites, digital campaigns, and audience engagement strategies.",
  icon: {
    reactIcons: FaFilm, // entertainment industry icon
    lucide: "Clapperboard"
  },
  brand: {
    color: "#6A1B9A",
    accent: "#E1BEE7",
    gradient: "linear-gradient(135deg, #6A1B9A 0%, #E1BEE7 100%)",
    
  },

  hero: {
    headline: "Boost Engagement for Movies, Shows & Events",
    subheadline:
      "From interactive websites to viral marketing campaigns, we help entertainment brands connect with audiences, drive ticket sales, and build loyal fanbases.",
    highlights: [
      { label: "Audience Engagement Boost", value: "80%" },
      { label: "Ticket Sales Growth", value: "50%" },
      { label: "Social Media Reach", value: "3x" }
    ],
    primaryButton: { label: "Launch Your Campaign", href: "/contact?src=entertainment-companies" },
    secondaryButton: { label: "See Entertainment Case Studies", href: "/case-studies?industry=entertainment" },
    badge: "For Movies, Events, and Media Brands"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Entertainment company digital marketing solutions",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1509228627152-72ae9ae6848d?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Movie premiere website design"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1524985069026-dd778a71c7b4?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Concert ticket booking platform"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1541339907198-e08756dedf3f?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Entertainment branding and social media promotion"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty attracting large audiences online.",
    "Limited brand awareness for new releases.",
    "Low ticket pre-sales and event attendance.",
    "Lack of centralized digital marketing strategy.",
    "Poor mobile experience for booking tickets.",
    "Inconsistent fan engagement across platforms."
  ],

  solutions: {
    operations: [
      "Custom promotional websites for movies/events.",
      "Scalable ticket booking platforms.",
      "Digital marketing & social media campaigns.",
      "Event management dashboards."
    ],
    integrations: [
      "Payment gateways for ticketing.",
      "Streaming platform integrations.",
      "Social media channel automation.",
      "CRM for fan management."
    ],
    analytics: [
      "Audience engagement analytics.",
      "Campaign ROI tracking.",
      "Ticket sales and conversion dashboards.",
      "Sentiment analysis for fan feedback."
    ],
    customerExperience: [
      "Seamless ticket booking experience.",
      "Mobile-first, responsive websites.",
      "Interactive media galleries and trailers.",
      "Personalized fan engagement campaigns."
    ]
  },

  services: [
    {
      title: "Promotional Website Development",
      description:
        "Launch high-converting websites for movies, shows, and events with trailers, schedules, and booking features.",
      deliverables: [
        "Custom design & branding",
        "Ticket booking integration",
        "Trailer & gallery setup",
        "SEO & mobile optimization"
      ],
      icon: "FaGlobe",
      duration: "2–4 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Digital Marketing Campaigns",
      description:
        "Drive awareness and audience engagement with targeted social media, PPC, and influencer campaigns.",
      deliverables: [
        "Paid ad campaigns (Google, Meta, YouTube)",
        "Influencer collaborations",
        "Fan engagement strategy",
        "Performance tracking dashboard"
      ],
      icon: "FaBullhorn",
      duration: "4–6 weeks",
      startingPriceINR: 150000
    },
    {
      title: "Event Ticketing Platforms",
      description:
        "Build secure, scalable ticket booking systems with real-time sales tracking and integrations.",
      deliverables: [
        "Custom booking engine",
        "Secure payment gateways",
        "Sales & inventory tracking",
        "QR-based ticket validation"
      ],
      icon: "FaTicketAlt",
      duration: "3–6 weeks",
      startingPriceINR: 200000
    },
    {
      title: "Fan Engagement Solutions",
      description:
        "Create loyalty programs, email marketing funnels, and community platforms for long-term engagement.",
      deliverables: [
        "Fan club portals",
        "Email campaigns",
        "Gamified engagement tools",
        "Community discussion forums"
      ],
      icon: "FaUsers",
      duration: "2–5 weeks",
      startingPriceINR: 100000
    }
  ],

  features: {
    mustHave: [
      "Promotional websites",
      "Ticket booking integration",
      "Social media marketing",
      "Analytics dashboards",
      "Mobile-first design"
    ],
    niceToHave: [
      "AR/VR experiences",
      "Gamified fan engagement",
      "AI-driven personalization",
      "NFT ticketing options",
      "Live streaming integrations"
    ]
  },

  integrations: [
    { name: "PayU / Razorpay / Stripe", category: "Payments" },
    { name: "YouTube / Vimeo", category: "Streaming" },
    { name: "Meta / TikTok / X", category: "Social Media" },
    { name: "Mailchimp / HubSpot", category: "Marketing Automation" },
    { name: "Google Analytics / Mixpanel", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MongoDB", "MySQL"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Mixpanel", "Hotjar"],
    security: ["SSL", "OAuth2", "Secure Payment APIs"]
  },

  process: [
    { step: 1, title: "Discovery & Planning", duration: "1–2 weeks", outputs: ["Campaign plan", "Website scope", "Marketing strategy"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Website design", "Ticketing system", "Brand creatives"] },
    { step: 3, title: "Marketing Launch", duration: "2–3 weeks", outputs: ["Paid campaigns", "Influencer content", "Email blasts"] },
    { step: 4, title: "Testing & Optimization", duration: "1–2 weeks", outputs: ["Bug fixes", "Campaign optimization", "Load testing"] },
    { step: 5, title: "Live Launch", duration: "Ongoing", outputs: ["Website launch", "Ticketing go-live", "Marketing execution"] },
    { step: 6, title: "Support & Analytics", duration: "Continuous", outputs: ["24/7 support", "Analytics dashboards", "Ongoing optimization"] }
  ],

  kpis: [
    "Audience reach & engagement",
    "Ticket sales conversion rate",
    "Campaign ROI",
    "Fan retention rate",
    "Social media growth"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small Productions",
      priceINR: 100000,
      timeline: "2–4 weeks",
      includes: [
        "Promotional microsite",
        "Basic social media campaign",
        "Ticket booking integration",
        "Analytics setup"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-size Companies",
      priceINR: 300000,
      timeline: "6–8 weeks",
      includes: [
        "Full promotional website",
        "Multi-platform digital campaigns",
        "Custom ticketing engine",
        "Engagement dashboards"
      ]
    },
    {
      tier: "Enterprise",
      audience: "Large Entertainment Brands",
      priceINR: 600000,
      timeline: "8–12 weeks",
      includes: [
        "Complete campaign ecosystem",
        "Event ticketing + streaming integration",
        "Influencer & PR campaigns",
        "Fan loyalty programs"
      ]
    }
  ],

  caseStudies: [
    {
      name: "CineStar Media",
      location: "Mumbai",
      goals: ["Increase ticket sales", "Expand digital reach", "Engage fans online"],
      outcomes: [
        "Ticket sales grew by 65% pre-release",
        "3x increase in social media followers",
        "Built loyalty portal with 50k+ active members"
      ],
      stack: ["React", "Node.js", "Razorpay", "Google Analytics", "Meta Ads"]
    }
  ],

  testimonials: [
    {
      author: "Rohan Kapoor",
      role: "CEO, CineStar Media",
      quote:
        "Mern Digital transformed how we launch movies. Their ticketing platform and digital marketing campaigns drove record-breaking sales."
    }
  ],

  faqs: [
    {
      q: "Can you handle high-traffic movie launches?",
      a: "Yes, our platforms are optimized for scalability and can handle millions of visitors."
    },
    {
      q: "Do you provide influencer marketing?",
      a: "Yes, we connect with influencers to build hype and engagement for your campaigns."
    },
    {
      q: "Can you integrate live streaming?",
      a: "Absolutely, we integrate with YouTube, Vimeo, and other streaming platforms."
    },
    {
      q: "Do you offer multi-language support?",
      a: "Yes, we build multilingual websites for global audiences."
    }
  ],

  cta: {
    title: "Ready to launch your entertainment campaign?",
    text:
      "Let’s build digital platforms and marketing campaigns that drive audiences, sales, and fan engagement.",
    primaryButton: { label: "Start Your Campaign", href: "/contact?plan=entertainment" },
    secondaryButton: { label: "Download Entertainment Marketing Guide", href: "/resources/entertainment-guide.pdf" }
  },

  seo: {
    metaTitle: "Entertainment Company Solutions | Digital Campaigns & Ticketing",
    metaDescription:
      "We build websites, ticketing systems, and marketing campaigns for entertainment companies—boost audience engagement, drive sales, and grow fanbases.",
    keywords: [
      "entertainment marketing",
      "movie promotion website",
      "event ticketing platform",
      "digital marketing for entertainment",
      "fan engagement solutions"
    ],
    canonical: "https://merndigital.com/industries/entertainment-companies",
    og: {
      title: "Entertainment Company Solutions",
      description: "Digital platforms & campaigns for movies, shows, and events.",
      // image:"https://images.unsplash.com/photo-1511671782779-c97d3d27a1d4?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Entertainment Solutions",
      url: "https://merndigital.com/industries/entertainment-companies",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you build promotional websites for movies?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we specialize in movie, show, and event websites with trailers, galleries, and ticket booking."
          }
        },
        {
          "@type": "Question",
          name: "Can you manage digital marketing campaigns?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely, we run multi-channel campaigns across social media, ads, and influencer collaborations."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/entertainment-companies",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Entertainment Companies",
        "item":"https://merndigital.com/industries/entertainment-companies"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 20,
  title: "Dental Practice Solutions",
  slug: "dental-practices",
  segment: "Websites & Local SEO for Dentists",
  summary:
    "We help dental practices attract new patients with optimized websites, appointment booking systems, and local SEO strategies.",
  icon: {
    reactIcons: FaTooth, // dental icon
    lucide: "Tooth"
  },
  brand: {
    color: "#1976D2",
    accent: "#BBDEFB",
    gradient: "linear-gradient(135deg, #1976D2 0%, #BBDEFB 100%)",
    
  },

  hero: {
    headline: "Grow Your Dental Practice with More Patients",
    subheadline:
      "From local SEO to patient-friendly websites, we build digital solutions that increase visibility, trust, and appointment bookings.",
    highlights: [
      { label: "Patient Appointments Growth", value: "70%" },
      { label: "Local Search Visibility", value: "3x" },
      { label: "Website Conversions", value: "50%" }
    ],
    primaryButton: { label: "Book a Free Consultation", href: "/contact?src=dental-practices" },
    secondaryButton: { label: "See Dental Case Studies", href: "/case-studies?industry=dental" },
    badge: "For Clinics, Dental Practices, and Orthodontists"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1588776814546-382f06f2a3f2?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Dental clinic website design",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1606813902919-f6cc6a0f7e2b?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Dentist appointment booking platform"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1598256989800-fe5f95da8dc5?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Local SEO for dental practices"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1611690132477-56e889f2bb18?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Patient portal and reviews management"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty attracting new patients in a competitive local market.",
    "Outdated websites that don’t inspire trust.",
    "Low visibility on Google Maps and local search.",
    "No online appointment booking system.",
    "Poor reputation management with online reviews.",
    "Limited digital marketing strategies."
  ],

  solutions: {
    operations: [
      "Custom clinic websites with booking features.",
      "Local SEO optimization for Google Maps.",
      "Reputation & reviews management system.",
      "Secure patient portals."
    ],
    integrations: [
      "Calendar & appointment integrations.",
      "Payment gateways for online deposits.",
      "CRM for patient follow-ups.",
      "Marketing automation tools."
    ],
    analytics: [
      "Website traffic & lead tracking.",
      "Appointment booking analytics.",
      "Local search performance reports.",
      "Campaign ROI dashboards."
    ],
    customerExperience: [
      "One-click appointment booking.",
      "Mobile-first, responsive websites.",
      "Easy-to-find clinic information.",
      "Automated appointment reminders."
    ]
  },

  services: [
    {
      title: "Dental Website Development",
      description:
        "Build a modern, mobile-friendly website with booking forms, treatment pages, and patient testimonials.",
      deliverables: [
        "Custom clinic branding",
        "Online booking form",
        "Treatment showcase pages",
        "SEO-friendly design"
      ],
      icon: "FaGlobe",
      duration: "2–4 weeks",
      startingPriceINR: 80000
    },
    {
      title: "Local SEO & Maps Optimization",
      description:
        "Increase your visibility on Google Maps and local search results to attract nearby patients.",
      deliverables: [
        "Google Business Profile optimization",
        "Local keyword targeting",
        "Citation building",
        "Review management"
      ],
      icon: "FaMapMarkerAlt",
      duration: "4–6 weeks",
      startingPriceINR: 60000
    },
    {
      title: "Appointment Booking Systems",
      description:
        "Integrate smart scheduling tools so patients can book, reschedule, and receive reminders automatically.",
      deliverables: [
        "Calendar integration",
        "Patient email/SMS reminders",
        "Payment deposit option",
        "Admin dashboard"
      ],
      icon: "FaCalendarCheck",
      duration: "2–3 weeks",
      startingPriceINR: 50000
    },
    {
      title: "Digital Marketing for Dentists",
      description:
        "Attract patients with Google Ads, Facebook campaigns, and reputation-building content marketing.",
      deliverables: [
        "Google Ads setup & management",
        "Facebook & Instagram campaigns",
        "Content marketing strategy",
        "Performance reporting"
      ],
      icon: "FaBullhorn",
      duration: "4–8 weeks",
      startingPriceINR: 100000
    }
  ],

  features: {
    mustHave: [
      "Clinic website with booking system",
      "Google Maps optimization",
      "Local SEO strategy",
      "Online reviews management",
      "Mobile-first design"
    ],
    niceToHave: [
      "Patient portal integration",
      "Tele-dentistry consultation system",
      "WhatsApp appointment reminders",
      "Automated feedback surveys",
      "Video content marketing"
    ]
  },

  integrations: [
    { name: "Google Calendar / Outlook", category: "Scheduling" },
    { name: "Razorpay / Stripe / PayPal", category: "Payments" },
    { name: "HubSpot / Zoho CRM", category: "CRM" },
    { name: "Mailchimp / ActiveCampaign", category: "Marketing" },
    { name: "Google Analytics / Search Console", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MySQL", "MongoDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Hotjar", "Search Console"],
    security: ["SSL", "HIPAA-compliant hosting", "Secure Payment APIs"]
  },

  process: [
    { step: 1, title: "Discovery & Strategy", duration: "1 week", outputs: ["Clinic goals", "SEO plan", "Booking requirements"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Website design", "Booking system", "SEO setup"] },
    { step: 3, title: "Local SEO Optimization", duration: "2–3 weeks", outputs: ["Google Business optimization", "Local listings", "Citations"] },
    { step: 4, title: "Digital Marketing Campaigns", duration: "Ongoing", outputs: ["Google Ads", "Facebook campaigns", "Content strategy"] },
    { step: 5, title: "Testing & Launch", duration: "1 week", outputs: ["Mobile testing", "Booking flow QA", "SEO audit"] },
    { step: 6, title: "Support & Growth", duration: "Continuous", outputs: ["Maintenance", "SEO reports", "Campaign optimization"] }
  ],

  kpis: [
    "Increase in patient appointments",
    "Google Maps ranking improvement",
    "Cost per patient acquisition",
    "Website traffic growth",
    "Online review ratings"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small Clinics",
      priceINR: 60000,
      timeline: "2–3 weeks",
      includes: [
        "Basic website",
        "Google Maps setup",
        "Appointment form",
        "Basic SEO"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-size Dental Practices",
      priceINR: 120000,
      timeline: "4–6 weeks",
      includes: [
        "Full-featured website",
        "Advanced local SEO",
        "Online booking system",
        "Reputation management"
      ]
    },
    {
      tier: "Premium",
      audience: "Multi-branch Clinics",
      priceINR: 250000,
      timeline: "6–10 weeks",
      includes: [
        "Comprehensive digital ecosystem",
        "Multi-location SEO",
        "CRM + patient portal",
        "Digital marketing campaigns"
      ]
    }
  ],

  caseStudies: [
    {
      name: "SmileCare Dental",
      location: "Delhi",
      goals: ["Increase local patients", "Improve Google Maps ranking", "Streamline bookings"],
      outcomes: [
        "Google Maps ranking improved to top 3 results",
        "70% increase in new patient bookings",
        "Automated appointment system reduced admin work by 40%"
      ],
      stack: ["React", "Node.js", "Razorpay", "Google Business Profile", "Google Ads"]
    }
  ],

  testimonials: [
    {
      author: "Dr. Meera Singh",
      role: "Founder, SmileCare Dental",
      quote:
        "Mern Digital gave us a modern website and made us visible on Google Maps. Our patient bookings have doubled within 3 months."
    }
  ],

  faqs: [
    {
      q: "Can you help us rank higher on Google Maps?",
      a: "Yes, we specialize in local SEO and optimize your clinic to appear in the top results for dental searches in your area."
    },
    {
      q: "Do you provide online appointment systems?",
      a: "Absolutely, we integrate easy-to-use booking forms with calendars and reminders."
    },
    {
      q: "Can you manage online reviews?",
      a: "Yes, we provide tools and strategies to request, monitor, and respond to reviews across platforms."
    },
    {
      q: "Do you work with multi-location clinics?",
      a: "Yes, we provide multi-branch SEO and booking solutions for larger practices."
    }
  ],

  cta: {
    title: "Ready to Attract More Patients?",
    text:
      "Let’s build a modern dental website and marketing strategy that grows your practice and brings in more patients.",
    primaryButton: { label: "Get a Free Demo", href: "/contact?plan=dental" },
    secondaryButton: { label: "Download Dental Marketing Guide", href: "/resources/dental-guide.pdf" }
  },

  seo: {
    metaTitle: "Dental Practice Solutions | Websites, SEO & Marketing for Dentists",
    metaDescription:
      "We build websites, booking systems, and local SEO strategies to help dental practices attract more patients and grow their brand.",
    keywords: [
      "dental marketing",
      "dentist website design",
      "local SEO for dentists",
      "dental clinic booking system",
      "dental digital marketing"
    ],
    canonical: "https://merndigital.com/industries/dental-practices",
    og: {
      title: "Dental Practice Solutions",
      description: "Websites & marketing strategies to help dentists attract more patients.",
      // image:"https://images.unsplash.com/photo-1588776814546-382f06f2a3f2?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Dental Solutions",
      url: "https://merndigital.com/industries/dental-practices",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you build websites for dental clinics?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we specialize in modern, patient-friendly websites with booking features and SEO optimization."
          }
        },
        {
          "@type": "Question",
          name: "Can you improve our local search rankings?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Absolutely, we implement local SEO strategies to boost visibility on Google Maps and search results."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/dental-practices",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Dental Practices",
        "item":"https://merndigital.com/industries/dental-practices"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 21,
  title: "Wellness & Fitness Solutions",
  slug: "wellness-fitness",
  segment: "Websites, Bookings & Marketing for Fitness Businesses",
  summary:
    "We help gyms, yoga studios, and fitness brands attract new members with modern websites, class booking platforms, and digital marketing strategies.",
  icon: {
    reactIcons: FaDumbbell, // fitness icon
    lucide: "Dumbbell"
  },
  brand: {
    color: "#E53935",
    accent: "#FFCDD2",
    gradient: "linear-gradient(135deg, #E53935 0%, #FFCDD2 100%)",
    
  },

  hero: {
    headline: "Grow Your Wellness & Fitness Brand",
    subheadline:
      "From online class bookings to digital marketing campaigns, we build solutions that help you engage members and grow revenue.",
    highlights: [
      { label: "New Membership Growth", value: "65%" },
      { label: "Class Bookings Online", value: "80%" },
      { label: "Social Engagement Boost", value: "3x" }
    ],
    primaryButton: { label: "Book a Free Strategy Call", href: "/contact?src=wellness-fitness" },
    secondaryButton: { label: "See Fitness Case Studies", href: "/case-studies?industry=fitness" },
    badge: "For Gyms, Yoga Studios, Trainers & Fitness Brands"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1579758629939-037fdd6ac3a3?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Fitness website design",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Gym membership booking platform"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Yoga class schedule website"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1605296867304-46d5465a13f1?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Fitness e-commerce integration"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty attracting new members in a competitive market.",
    "No online booking or class management system.",
    "Outdated websites that don’t reflect brand energy.",
    "Low engagement on social media.",
    "Limited tools to sell merchandise or digital programs.",
    "Manual handling of schedules, payments, and memberships."
  ],

  solutions: {
    operations: [
      "Custom websites with booking & memberships.",
      "Class scheduling & trainer management.",
      "E-commerce for fitness products & plans.",
      "Mobile-first design for easy access."
    ],
    integrations: [
      "Payment gateways for subscriptions.",
      "Calendar & booking tools.",
      "CRM for member management.",
      "Social media marketing integrations."
    ],
    analytics: [
      "Membership growth tracking.",
      "Class attendance reports.",
      "Campaign ROI dashboards.",
      "Sales & revenue analytics."
    ],
    customerExperience: [
      "One-click class booking.",
      "Mobile-friendly interfaces.",
      "Flexible membership options.",
      "Automated reminders & notifications."
    ]
  },

  services: [
    {
      title: "Fitness Website Development",
      description:
        "Build a modern website with membership signups, class schedules, and trainer profiles.",
      deliverables: [
        "Custom branding",
        "Class schedules",
        "Membership plans",
        "SEO-friendly design"
      ],
      icon: "FaGlobe",
      duration: "2–4 weeks",
      startingPriceINR: 70000
    },
    {
      title: "Online Booking & Membership Systems",
      description:
        "Automate bookings, manage classes, and handle payments online.",
      deliverables: [
        "Class booking system",
        "Trainer management",
        "Payment integration",
        "Member dashboard"
      ],
      icon: "FaCalendarCheck",
      duration: "3–5 weeks",
      startingPriceINR: 60000
    },
    {
      title: "Digital Marketing for Fitness",
      description:
        "Grow your community with targeted social ads, influencer collaborations, and content marketing.",
      deliverables: [
        "Facebook & Instagram campaigns",
        "Influencer partnerships",
        "Content strategy",
        "Performance tracking"
      ],
      icon: "FaBullhorn",
      duration: "4–8 weeks",
      startingPriceINR: 90000
    },
    {
      title: "Fitness E-commerce Solutions",
      description:
        "Sell fitness gear, supplements, or online training programs with a secure store.",
      deliverables: [
        "Product catalog",
        "Shopping cart & checkout",
        "Payment gateways",
        "Order tracking"
      ],
      icon: "FaShoppingCart",
      duration: "4–6 weeks",
      startingPriceINR: 80000
    }
  ],

  features: {
    mustHave: [
      "Class booking system",
      "Mobile-first fitness website",
      "Membership management",
      "Payment integrations",
      "SEO & social media setup"
    ],
    niceToHave: [
      "Live streaming & virtual classes",
      "Nutrition & meal plan portals",
      "Loyalty & referral programs",
      "WhatsApp/SMS reminders",
      "Wearable device integrations"
    ]
  },

  integrations: [
    { name: "Mindbody / Zen Planner", category: "Booking & Management" },
    { name: "Stripe / Razorpay / PayPal", category: "Payments" },
    { name: "HubSpot / Zoho CRM", category: "CRM" },
    { name: "Mailchimp / ActiveCampaign", category: "Marketing" },
    { name: "Google Analytics / Meta Ads", category: "Analytics" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MySQL", "MongoDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Hotjar", "Meta Ads Manager"],
    security: ["SSL", "Secure Payment APIs", "User Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Strategy", duration: "1 week", outputs: ["Business goals", "Target audience", "Booking needs"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Website design", "Booking system", "SEO setup"] },
    { step: 3, title: "Marketing & Growth Setup", duration: "3–4 weeks", outputs: ["Social campaigns", "Content plan", "E-commerce store"] },
    { step: 4, title: "Testing & Launch", duration: "1 week", outputs: ["Mobile testing", "Booking flow QA", "SEO audit"] },
    { step: 5, title: "Support & Growth", duration: "Continuous", outputs: ["Maintenance", "Reports", "Campaign optimization"] }
  ],

  kpis: [
    "New membership signups",
    "Class booking volume",
    "Website traffic growth",
    "Engagement rate on social media",
    "Revenue from memberships & products"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Small Studios & Trainers",
      priceINR: 60000,
      timeline: "2–3 weeks",
      includes: [
        "Basic website",
        "Class schedule integration",
        "Membership plans",
        "Basic SEO"
      ]
    },
    {
      tier: "Growth",
      audience: "Mid-size Gyms & Studios",
      priceINR: 120000,
      timeline: "4–6 weeks",
      includes: [
        "Full-featured website",
        "Booking & membership system",
        "E-commerce setup",
        "Digital marketing starter pack"
      ]
    },
    {
      tier: "Premium",
      audience: "Large Fitness Brands",
      priceINR: 250000,
      timeline: "6–10 weeks",
      includes: [
        "Comprehensive fitness ecosystem",
        "Multi-location booking",
        "Advanced CRM & analytics",
        "Full-scale marketing campaigns"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Flex Gym Studio",
      location: "Mumbai",
      goals: ["Increase memberships", "Enable online bookings", "Boost brand on Instagram"],
      outcomes: [
        "65% growth in memberships in 6 months",
        "80% of class bookings moved online",
        "3x engagement boost on social media"
      ],
      stack: ["React", "Node.js", "Stripe", "Instagram Ads", "Mailchimp"]
    }
  ],

  testimonials: [
    {
      author: "Rohit Malhotra",
      role: "Founder, Flex Gym Studio",
      quote:
        "Mern Digital helped us transform our fitness business online. Our bookings are now seamless, and our online presence has never been stronger."
    }
  ],

  faqs: [
    {
      q: "Can you set up online class bookings?",
      a: "Yes, we integrate easy-to-use booking systems for classes, trainers, and memberships."
    },
    {
      q: "Do you provide e-commerce for fitness products?",
      a: "Absolutely, we can set up a secure online store for supplements, gear, and training programs."
    },
    {
      q: "Can you help with social media marketing?",
      a: "Yes, we specialize in fitness campaigns across Instagram, Facebook, and YouTube to grow your community."
    },
    {
      q: "Do you support virtual classes?",
      a: "Yes, we can integrate live streaming and recorded sessions into your platform."
    }
  ],

  cta: {
    title: "Ready to Grow Your Fitness Business?",
    text:
      "Let’s build a modern website and marketing strategy that gets you more members and stronger online presence.",
    primaryButton: { label: "Get a Free Demo", href: "/contact?plan=fitness" },
    secondaryButton: { label: "Download Fitness Marketing Guide", href: "/resources/fitness-guide.pdf" }
  },

  seo: {
    metaTitle: "Wellness & Fitness Solutions | Websites, SEO & Marketing for Fitness Brands",
    metaDescription:
      "We build websites, booking systems, and digital marketing campaigns to help gyms, trainers, and studios grow memberships and revenue.",
    keywords: [
      "fitness marketing",
      "gym website design",
      "yoga studio booking system",
      "fitness e-commerce",
      "digital marketing for gyms"
    ],
    canonical: "https://merndigital.com/industries/wellness-fitness",
    og: {
      title: "Wellness & Fitness Solutions",
      description: "Websites & marketing strategies to help fitness brands grow memberships.",
      // image:"https://images.unsplash.com/photo-1579758629939-037fdd6ac3a3?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Wellness & Fitness Solutions",
      url: "https://merndigital.com/industries/wellness-fitness",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you build booking systems for gyms?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we specialize in class and membership booking integrations for gyms and studios."
          }
        },
        {
          "@type": "Question",
          name: "Can you run social media campaigns?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we create Instagram, Facebook, and YouTube campaigns to engage and grow your audience."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/wellness-fitness",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Wellness & Fitness",
        "item":"https://merndigital.com/industries/wellness-fitness"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 22,
  title: "Construction & Home Services Solutions",
  slug: "construction-home-services",
  segment: "Websites, SEO & Marketing for Contractors and Home Service Providers",
  summary:
    "We help construction companies, contractors, and home service businesses attract more clients with modern websites, local SEO, and digital marketing campaigns.",
  icon: {
    reactIcons: FaTools, // construction icon
    lucide: "Hammer"
  },
  brand: {
    color: "#FF9800",
    accent: "#FFE0B2",
    gradient: "linear-gradient(135deg, #FF9800 0%, #FFE0B2 100%)",
    
  },

  hero: {
    headline: "Build Your Construction & Home Services Brand",
    subheadline:
      "From contractor websites to local SEO campaigns, we create solutions that attract new clients and grow your business.",
    highlights: [
      { label: "Leads Growth", value: "70%" },
      { label: "Local SEO Visibility", value: "85%" },
      { label: "Customer Retention", value: "40%" }
    ],
    primaryButton: { label: "Book a Free Consultation", href: "/contact?src=construction-home-services" },
    secondaryButton: { label: "See Case Studies", href: "/case-studies?industry=construction" },
    badge: "For Contractors, Builders, Renovators & Home Services"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1581093588401-22b6a7e5feca?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Construction and home services website design",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1621905251918-5696b6c74a6e?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Contractor website with project showcase"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1581093588401-22b6a7e5feca?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Home services booking platform"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Renovation business website"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty generating local leads and referrals.",
    "Outdated websites that don’t inspire trust.",
    "No system for online booking or inquiries.",
    "Low visibility in Google Maps & local search.",
    "Manual project tracking and client communication.",
    "High dependency on word-of-mouth referrals."
  ],

  solutions: {
    operations: [
      "Modern contractor websites with service showcases.",
      "Online booking & inquiry systems.",
      "Project portfolio galleries.",
      "Mobile-friendly design for homeowners."
    ],
    integrations: [
      "Payment gateways for service deposits.",
      "CRM for lead management.",
      "Scheduling & calendar tools.",
      "WhatsApp & email notifications."
    ],
    analytics: [
      "Leads & conversions dashboard.",
      "Local SEO performance tracking.",
      "Campaign ROI reports.",
      "Customer review & satisfaction tracking."
    ],
    customerExperience: [
      "Easy service booking online.",
      "Mobile-first user experience.",
      "Transparent pricing pages.",
      "Automated updates & reminders."
    ]
  },

  services: [
    {
      title: "Contractor Website Development",
      description:
        "We design professional websites that showcase your services, past projects, and help you win more clients.",
      deliverables: [
        "Custom branding",
        "Service pages",
        "Project portfolio",
        "SEO optimization"
      ],
      icon: "FaGlobe",
      duration: "2–4 weeks",
      startingPriceINR: 65000
    },
    {
      title: "Local SEO & PPC Campaigns",
      description:
        "Dominate Google Maps and local search results with targeted SEO and ad campaigns.",
      deliverables: [
        "Google My Business optimization",
        "Local keywords targeting",
        "PPC campaigns",
        "Monthly reports"
      ],
      icon: "FaBullhorn",
      duration: "3–6 months",
      startingPriceINR: 50000
    },
    {
      title: "Booking & Inquiry Systems",
      description:
        "Allow customers to request quotes, book services, and schedule appointments online.",
      deliverables: [
        "Inquiry forms",
        "Online booking calendar",
        "Payment integration",
        "CRM sync"
      ],
      icon: "FaCalendarCheck",
      duration: "3–5 weeks",
      startingPriceINR: 60000
    },
    {
      title: "Digital Marketing for Home Services",
      description:
        "Attract new clients with content marketing, paid ads, and social media campaigns.",
      deliverables: [
        "Facebook & Instagram ads",
        "Content strategy",
        "Lead funnels",
        "Performance tracking"
      ],
      icon: "FaBullhorn",
      duration: "4–8 weeks",
      startingPriceINR: 80000
    }
  ],

  features: {
    mustHave: [
      "SEO-friendly contractor website",
      "Service inquiry & booking forms",
      "Google My Business setup",
      "Portfolio/project showcase",
      "Mobile-first design"
    ],
    niceToHave: [
      "Online service payments",
      "Chatbot for inquiries",
      "Loyalty & referral programs",
      "WhatsApp/SMS notifications",
      "Virtual consultations"
    ]
  },

  integrations: [
    { name: "Zoho CRM / HubSpot", category: "CRM" },
    { name: "Google My Business", category: "SEO & Local" },
    { name: "Stripe / Razorpay", category: "Payments" },
    { name: "Calendly / Booksy", category: "Booking" },
    { name: "Meta Ads / Google Ads", category: "Marketing" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MySQL", "MongoDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Hotjar", "Meta Ads Manager"],
    security: ["SSL", "Secure Payment APIs", "User Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Strategy", duration: "1 week", outputs: ["Target service areas", "SEO audit", "Business goals"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Website design", "Booking system", "SEO setup"] },
    { step: 3, title: "Marketing Setup", duration: "3–4 weeks", outputs: ["Local SEO", "Ad campaigns", "Content plan"] },
    { step: 4, title: "Testing & Launch", duration: "1 week", outputs: ["Mobile testing", "Booking flow QA", "SEO audit"] },
    { step: 5, title: "Ongoing Growth", duration: "Continuous", outputs: ["Lead reports", "Campaign optimization", "Support"] }
  ],

  kpis: [
    "Local search visibility",
    "New leads generated",
    "Website conversion rate",
    "Project inquiries",
    "ROI from digital ads"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Individual Contractors",
      priceINR: 50000,
      timeline: "2–3 weeks",
      includes: [
        "Basic contractor website",
        "Local SEO setup",
        "Google My Business profile",
        "Contact/inquiry form"
      ]
    },
    {
      tier: "Growth",
      audience: "Small Construction Firms",
      priceINR: 120000,
      timeline: "4–6 weeks",
      includes: [
        "Advanced website with portfolio",
        "SEO & PPC campaigns",
        "Booking & inquiry system",
        "Monthly performance reports"
      ]
    },
    {
      tier: "Premium",
      audience: "Large Contractors & Multi-city Firms",
      priceINR: 250000,
      timeline: "6–10 weeks",
      includes: [
        "Comprehensive online presence",
        "Multi-location SEO",
        "Advanced CRM integration",
        "Full-scale marketing campaigns"
      ]
    }
  ],

  caseStudies: [
    {
      name: "BuildRight Contractors",
      location: "Delhi",
      goals: ["Generate more project inquiries", "Rank higher in local search", "Showcase past projects"],
      outcomes: [
        "70% increase in local leads in 4 months",
        "Top 3 ranking on Google Maps for 10+ keywords",
        "Professional website with 50+ project showcases"
      ],
      stack: ["Next.js", "Node.js", "Google My Business", "Meta Ads", "Zoho CRM"]
    }
  ],

  testimonials: [
    {
      author: "Arjun Singh",
      role: "Owner, BuildRight Contractors",
      quote:
        "Mern Digital transformed our online presence. We now get consistent inquiries from Google, and our portfolio site impresses clients."
    }
  ],

  faqs: [
    {
      q: "Can you help us rank higher in local search?",
      a: "Yes, we specialize in local SEO strategies to get you into Google’s top results and Maps listings."
    },
    {
      q: "Do you build websites for small contractors?",
      a: "Absolutely, we design scalable websites for solo contractors as well as large firms."
    },
    {
      q: "Can you set up online booking?",
      a: "Yes, we integrate booking and inquiry systems to make it easy for clients to request services online."
    },
    {
      q: "Do you provide digital marketing services?",
      a: "Yes, we run PPC, SEO, and social media campaigns tailored to home services and construction businesses."
    }
  ],

  cta: {
    title: "Ready to Get More Construction Leads?",
    text:
      "Let’s build a powerful online presence with a website, SEO, and marketing strategy designed to grow your construction or home service business.",
    primaryButton: { label: "Get a Free Demo", href: "/contact?plan=construction-home-services" },
    secondaryButton: { label: "Download Construction Marketing Guide", href: "/resources/construction-guide.pdf" }
  },

  seo: {
    metaTitle: "Construction & Home Services | Websites, SEO & Marketing",
    metaDescription:
      "We build websites, booking systems, and local SEO campaigns to help contractors and home service providers attract more clients.",
    keywords: [
      "construction marketing",
      "contractor website design",
      "local SEO for builders",
      "home services marketing",
      "digital marketing for contractors"
    ],
    canonical: "https://merndigital.com/industries/construction-home-services",
    og: {
      title: "Construction & Home Services Solutions",
      description: "Websites, booking & marketing to grow your construction and home service business.",
      // image:"https://images.unsplash.com/photo-1581093588401-22b6a7e5feca?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Construction & Home Services Solutions",
      url: "https://merndigital.com/industries/construction-home-services",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you help with local SEO for contractors?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we specialize in Google Maps optimization and local SEO to increase leads."
          }
        },
        {
          "@type": "Question",
          name: "Can you build booking systems for home services?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we integrate booking and inquiry tools so clients can easily schedule services."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/construction-home-services",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Construction & Home Services",
        "item":"https://merndigital.com/industries/construction-home-services"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 22,
  title: "Food Industry Solutions",
  slug: "food-companies",
  segment: "Websites, Ordering Platforms & Digital Marketing for Food Businesses",
  summary:
    "We help restaurants, food delivery services, and cloud kitchens thrive with engaging websites, online ordering systems, and digital marketing campaigns that attract and retain hungry customers.",
  icon: {
    reactIcons: FaUtensils, // food icon
    lucide: "Utensils"
  },
  brand: {
    color: "#E53935",
    accent: "#FFCDD2",
    gradient: "linear-gradient(135deg, #E53935 0%, #FFCDD2 100%)",
    
  },

  hero: {
    headline: "Delicious Digital Experiences for Food Businesses",
    subheadline:
      "From restaurant websites to food delivery platforms, we craft digital solutions that attract more customers and increase online orders.",
    highlights: [
      { label: "Online Orders Boost", value: "80%" },
      { label: "Customer Retention", value: "65%" },
      { label: "Revenue Growth", value: "75%" }
    ],
    primaryButton: { label: "Book a Free Demo", href: "/contact?src=food-industry" },
    secondaryButton: { label: "See Food Case Studies", href: "/case-studies?industry=food" },
    badge: "For Restaurants, Cloud Kitchens, & Food Delivery Brands"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1551218808-94e220e084d2?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Food website and online ordering platform",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1555992336-cbfeddc56b66?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Restaurant online ordering system"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1556745753-b2904692b3cd?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Food delivery app interface"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1540189549336-e6e99c3679fe?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Restaurant website with menu and booking"
  //     }
  //   ]
  // },

  painPoints: [
    "Difficulty attracting new customers online.",
    "No streamlined system for online orders & deliveries.",
    "Low visibility on Google and food apps.",
    "Outdated websites that don’t reflect brand quality.",
    "Manual reservation & table management.",
    "High dependency on third-party delivery apps with heavy commissions."
  ],

  solutions: {
    operations: [
      "Modern restaurant websites with menu showcases.",
      "Online ordering & delivery platforms.",
      "Reservation & table booking systems.",
      "Mobile-friendly design optimized for food lovers."
    ],
    integrations: [
      "POS & billing systems.",
      "Payment gateways for online orders.",
      "Food delivery app integrations.",
      "WhatsApp & email notifications for orders."
    ],
    analytics: [
      "Orders & revenue dashboard.",
      "Customer loyalty tracking.",
      "Campaign ROI reports.",
      "Food sales & menu item performance."
    ],
    customerExperience: [
      "Easy online ordering system.",
      "Mobile-first design for food lovers.",
      "Loyalty & rewards programs.",
      "Personalized offers via email/SMS."
    ]
  },

  services: [
    {
      title: "Restaurant Website Development",
      description:
        "We design visually engaging restaurant websites with menu showcases, booking, and ordering systems.",
      deliverables: [
        "Custom branding",
        "Menu pages",
        "Online ordering setup",
        "SEO optimization"
      ],
      icon: "FaUtensils",
      duration: "2–4 weeks",
      startingPriceINR: 55000
    },
    {
      title: "Food Delivery Platform Development",
      description:
        "Launch your own food delivery or cloud kitchen platform with payment and delivery tracking.",
      deliverables: [
        "Custom ordering system",
        "Delivery tracking",
        "Secure payments",
        "CRM integration"
      ],
      icon: "FaTruck",
      duration: "4–6 weeks",
      startingPriceINR: 120000
    },
    {
      title: "Digital Marketing for Food Businesses",
      description:
        "We help you attract more customers with social media marketing, SEO, and paid ads.",
      deliverables: [
        "Facebook & Instagram campaigns",
        "Local SEO optimization",
        "Influencer partnerships",
        "Monthly reports"
      ],
      icon: "FaBullhorn",
      duration: "4–8 weeks",
      startingPriceINR: 60000
    },
    {
      title: "Reservation & Loyalty Systems",
      description:
        "Implement online reservations and customer loyalty programs to retain and delight customers.",
      deliverables: [
        "Reservation system",
        "Loyalty rewards",
        "Email/SMS reminders",
        "CRM sync"
      ],
      icon: "FaCalendarCheck",
      duration: "3–5 weeks",
      startingPriceINR: 70000
    }
  ],

  features: {
    mustHave: [
      "SEO-friendly restaurant website",
      "Online menu & ordering",
      "Reservation & booking system",
      "Mobile-first design",
      "Payment integration"
    ],
    niceToHave: [
      "Loyalty & rewards program",
      "Chatbot for food orders",
      "Push notifications for offers",
      "Influencer marketing campaigns",
      "Virtual food tours"
    ]
  },

  integrations: [
    { name: "Zomato / Swiggy APIs", category: "Food Delivery" },
    { name: "Stripe / Razorpay / Paytm", category: "Payments" },
    { name: "Square POS / Toast POS", category: "POS Systems" },
    { name: "Zoho CRM / HubSpot", category: "CRM" },
    { name: "Meta Ads / Google Ads", category: "Marketing" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MySQL", "MongoDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Hotjar", "Meta Ads Manager"],
    security: ["SSL", "Secure Payment APIs", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Strategy", duration: "1 week", outputs: ["Target audience", "Menu & service structure", "SEO audit"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Restaurant website", "Menu integration", "Ordering system"] },
    { step: 3, title: "Marketing Setup", duration: "3–4 weeks", outputs: ["Local SEO", "Social media ads", "Influencer outreach"] },
    { step: 4, title: "Testing & Launch", duration: "1 week", outputs: ["Order flow QA", "Payment testing", "Mobile testing"] },
    { step: 5, title: "Ongoing Growth", duration: "Continuous", outputs: ["Customer loyalty tracking", "Sales reports", "Marketing optimization"] }
  ],

  kpis: [
    "Online orders received",
    "Revenue growth",
    "Repeat customers",
    "Reservation bookings",
    "ROI from ads"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Local Restaurants & Cafes",
      priceINR: 45000,
      timeline: "2–3 weeks",
      includes: [
        "Restaurant website",
        "Menu integration",
        "Basic SEO",
        "Contact form"
      ]
    },
    {
      tier: "Growth",
      audience: "Food Chains & Cloud Kitchens",
      priceINR: 120000,
      timeline: "4–6 weeks",
      includes: [
        "Advanced ordering system",
        "Payment gateway",
        "Digital marketing setup",
        "Monthly reports"
      ]
    },
    {
      tier: "Premium",
      audience: "Food Delivery Platforms",
      priceINR: 250000,
      timeline: "6–10 weeks",
      includes: [
        "Full delivery app/website",
        "Multi-location SEO",
        "Loyalty system",
        "Full-scale digital campaigns"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Tandoor Tales",
      location: "Bangalore",
      goals: ["Increase online orders", "Boost brand visibility", "Retain customers with loyalty programs"],
      outcomes: [
        "85% growth in online orders in 6 months",
        "Top rankings for 'best Indian restaurant Bangalore'",
        "2000+ loyalty members added in 3 months"
      ],
      stack: ["Next.js", "Node.js", "Razorpay", "Zoho CRM", "Meta Ads"]
    }
  ],

  testimonials: [
    {
      author: "Priya Sharma",
      role: "Owner, Tandoor Tales",
      quote:
        "Mern Digital helped us move beyond third-party apps. Our website now drives direct orders and saves us huge commissions."
    }
  ],

  faqs: [
    {
      q: "Can you integrate with Swiggy or Zomato?",
      a: "Yes, we can integrate your restaurant systems with food delivery apps while also enabling direct online orders."
    },
    {
      q: "Do you build websites for small cafes?",
      a: "Absolutely, we create scalable websites for cafes, local restaurants, and large food chains."
    },
    {
      q: "Can you set up loyalty programs?",
      a: "Yes, we build custom loyalty and rewards systems to retain your best customers."
    },
    {
      q: "Do you handle social media marketing?",
      a: "Yes, we run campaigns on Instagram, Facebook, and Google to attract more food lovers."
    }
  ],

  cta: {
    title: "Hungry for More Customers?",
    text:
      "Let’s build your food brand online with stunning websites, online ordering, and marketing campaigns that bring in loyal customers.",
    primaryButton: { label: "Get a Free Demo", href: "/contact?plan=food-industry" },
    secondaryButton: { label: "Download Food Marketing Guide", href: "/resources/food-guide.pdf" }
  },

  seo: {
    metaTitle: "Food Industry Solutions | Websites, Ordering & Marketing",
    metaDescription:
      "We build restaurant websites, online ordering systems, and digital marketing campaigns to help food businesses attract and retain customers.",
    keywords: [
      "restaurant website design",
      "food delivery platform development",
      "digital marketing for restaurants",
      "online ordering system",
      "cloud kitchen branding"
    ],
    canonical: "https://merndigital.com/industries/food-companies",
    og: {
      title: "Food Industry Solutions",
      description: "Websites, ordering platforms & digital marketing for restaurants and food businesses.",
      // image:"https://images.unsplash.com/photo-1551218808-94e220e084d2?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Food Industry Solutions",
      url: "https://merndigital.com/industries/food-companies",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Can you build online ordering systems?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we specialize in creating ordering and delivery platforms for restaurants and food brands."
          }
        },
        {
          "@type": "Question",
          name: "Do you offer marketing for food businesses?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we create SEO, PPC, and social media campaigns that attract hungry customers."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/food-companies",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Food Companies",
        "item":"https://merndigital.com/industries/food-companies"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
},
{
  id: 24,
  title: "Arts & Entertainment Solutions",
  slug: "arts-entertainment",
  segment: "Websites, Portfolios & Digital Marketing for Artists & Entertainers",
  summary:
    "We empower artists, performers, and creative businesses with visually stunning websites, portfolio platforms, and digital marketing strategies to grow audiences and monetize talent.",
  icon: {
    reactIcons: FaPalette, // arts icon
    lucide: "Palette"
  },
  brand: {
    color: "#8E44AD",
    accent: "#D7BDE2",
    gradient: "linear-gradient(135deg, #8E44AD 0%, #D7BDE2 100%)",
    
  },

  hero: {
    headline: "Showcase Your Talent with Stunning Digital Platforms",
    subheadline:
      "From portfolio websites to ticket booking platforms, we help artists, performers, and creative brands attract fans, sell tickets, and grow online.",
    highlights: [
      { label: "Audience Growth", value: "90%" },
      { label: "Bookings Increase", value: "75%" },
      { label: "Brand Visibility", value: "85%" }
    ],
    primaryButton: { label: "Book a Free Strategy Call", href: "/contact?src=arts-entertainment" },
    secondaryButton: { label: "See Artist Case Studies", href: "/case-studies?industry=arts" },
    badge: "For Artists, Performers, & Entertainment Brands"
  },

  // imagery: {
  //   cover:
  //     "https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?q=80&w=1600&auto=format&fit=crop",
  //   alt: "Artist performing with spotlight",
  //   gallery: [
  //     {
  //       url: "https://images.unsplash.com/photo-1515165562835-c4c1b1d61d9a?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Music band performing on stage"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1526470608268-f674ce90ebd4?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Artist painting with audience watching"
  //     },
  //     {
  //       url: "https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?q=80&w=1600&auto=format&fit=crop",
  //       alt: "Dance performance event"
  //     }
  //   ]
  // },

  painPoints: [
    "Struggling to showcase work online in a professional way.",
    "Difficulty attracting new fans and audiences.",
    "No centralized system to sell tickets or merchandise.",
    "Low engagement on social media platforms.",
    "Outdated or DIY websites that hurt credibility.",
    "Dependence on third-party event platforms with high fees."
  ],

  solutions: {
    operations: [
      "Portfolio & showcase websites for artists.",
      "Ticket booking and event management platforms.",
      "Merchandise stores for artists and performers.",
      "Mobile-friendly digital experiences for fans."
    ],
    integrations: [
      "Payment gateways for ticket & merch sales.",
      "Event platforms like Eventbrite.",
      "CRM tools for fan engagement.",
      "Email & SMS marketing platforms."
    ],
    analytics: [
      "Audience growth dashboard.",
      "Ticket sales tracking.",
      "Merchandise performance analytics.",
      "Campaign ROI reporting."
    ],
    customerExperience: [
      "Seamless online booking for shows.",
      "Interactive artist portfolios.",
      "Merchandise stores with secure checkout.",
      "Personalized fan updates via email/SMS."
    ]
  },

  services: [
    {
      title: "Artist Portfolio Websites",
      description:
        "Custom websites for artists, musicians, and performers to showcase their talent and attract fans.",
      deliverables: [
        "Portfolio galleries",
        "Custom branding",
        "Contact/booking forms",
        "SEO optimization"
      ],
      icon: "FaPalette",
      duration: "2–4 weeks",
      startingPriceINR: 50000
    },
    {
      title: "Event & Ticketing Platforms",
      description:
        "Sell tickets directly from your website with real-time booking and secure payments.",
      deliverables: [
        "Ticket booking system",
        "Event calendar",
        "Payment integration",
        "CRM sync"
      ],
      icon: "FaTicketAlt",
      duration: "4–6 weeks",
      startingPriceINR: 110000
    },
    {
      title: "Digital Marketing for Artists",
      description:
        "Grow your fanbase with SEO, social media campaigns, and YouTube/Spotify promotions.",
      deliverables: [
        "Social media ads",
        "Content marketing",
        "Influencer campaigns",
        "Monthly analytics reports"
      ],
      icon: "FaBullhorn",
      duration: "4–8 weeks",
      startingPriceINR: 60000
    },
    {
      title: "E-commerce for Merchandise",
      description:
        "Launch an online store to sell your merch directly to fans with secure checkout.",
      deliverables: [
        "Merchandise storefront",
        "Payment gateway integration",
        "Inventory management",
        "CRM sync"
      ],
      icon: "FaShoppingBag",
      duration: "3–5 weeks",
      startingPriceINR: 75000
    }
  ],

  features: {
    mustHave: [
      "Portfolio & showcase website",
      "Online booking or ticketing system",
      "Mobile-first design",
      "Payment gateway integration",
      "SEO & social media optimization"
    ],
    niceToHave: [
      "Merchandise store",
      "Fan loyalty/rewards program",
      "Interactive live streams",
      "Video galleries",
      "Influencer collaborations"
    ]
  },

  integrations: [
    { name: "Spotify / YouTube APIs", category: "Music Platforms" },
    { name: "Stripe / Razorpay / PayPal", category: "Payments" },
    { name: "Eventbrite / Ticketmaster", category: "Events" },
    { name: "Zoho CRM / HubSpot", category: "CRM" },
    { name: "Meta Ads / Google Ads", category: "Marketing" }
  ],

  techStack: {
    frontend: ["React", "Next.js", "Vue.js"],
    backend: ["Node.js", "Laravel", "Django"],
    database: ["PostgreSQL", "MySQL", "MongoDB"],
    hosting: ["AWS", "Azure", "Google Cloud"],
    analytics: ["Google Analytics", "Mixpanel", "Hotjar"],
    security: ["SSL", "OAuth login", "Data Encryption"]
  },

  process: [
    { step: 1, title: "Discovery & Strategy", duration: "1 week", outputs: ["Target audience", "Platform goals", "SEO research"] },
    { step: 2, title: "Design & Development", duration: "2–4 weeks", outputs: ["Portfolio website", "Ticketing/merch features"] },
    { step: 3, title: "Marketing Setup", duration: "3–4 weeks", outputs: ["Social campaigns", "Influencer outreach", "Ad setup"] },
    { step: 4, title: "Testing & Launch", duration: "1 week", outputs: ["Booking/payment testing", "Mobile optimization"] },
    { step: 5, title: "Ongoing Growth", duration: "Continuous", outputs: ["Fan engagement tracking", "Marketing optimization"] }
  ],

  kpis: [
    "Audience growth",
    "Ticket sales",
    "Merchandise sales",
    "Event bookings",
    "Social media reach"
  ],

  pricing: [
    {
      tier: "Starter",
      audience: "Individual Artists & Performers",
      priceINR: 45000,
      timeline: "2–3 weeks",
      includes: [
        "Portfolio website",
        "Basic SEO",
        "Booking/contact form",
        "Social media links"
      ]
    },
    {
      tier: "Growth",
      audience: "Bands, Performers & Small Agencies",
      priceINR: 120000,
      timeline: "4–6 weeks",
      includes: [
        "Advanced portfolio website",
        "Ticketing system",
        "E-commerce for merch",
        "Digital marketing setup"
      ]
    },
    {
      tier: "Premium",
      audience: "Entertainment Companies & Agencies",
      priceINR: 250000,
      timeline: "6–10 weeks",
      includes: [
        "Full artist/event platform",
        "Multi-event booking system",
        "Merchandise store",
        "Full-scale digital campaigns"
      ]
    }
  ],

  caseStudies: [
    {
      name: "Rhythm & Colors",
      location: "Mumbai",
      goals: ["Sell tickets online", "Expand audience reach", "Monetize merchandise"],
      outcomes: [
        "200% increase in ticket sales in 6 months",
        "50,000+ monthly website visitors",
        "Launched merch store with 10K+ orders"
      ],
      stack: ["Next.js", "Node.js", "Razorpay", "Zoho CRM", "Meta Ads"]
    }
  ],

  testimonials: [
    {
      author: "Arjun Mehta",
      role: "Lead Vocalist, Rhythm & Colors",
      quote:
        "Mern Digital gave us a professional website and ticketing system. Now our fans can book directly without paying huge commissions."
    }
  ],

  faqs: [
    {
      q: "Do you build websites for individual artists?",
      a: "Yes, we create portfolio websites for musicians, painters, dancers, and other artists."
    },
    {
      q: "Can I sell tickets directly from my website?",
      a: "Absolutely. We integrate ticketing platforms and secure payments so you can sell tickets commission-free."
    },
    {
      q: "Do you set up merchandise stores?",
      a: "Yes, we help artists launch merchandise stores with payment gateways and inventory tracking."
    },
    {
      q: "Do you handle social media promotions?",
      a: "Yes, we run campaigns on Instagram, YouTube, and Facebook to expand your audience."
    }
  ],

  cta: {
    title: "Ready to Showcase Your Talent?",
    text:
      "Let’s build your portfolio website, ticketing system, or merchandise store to grow your audience and monetize your art.",
    primaryButton: { label: "Get a Free Consultation", href: "/contact?plan=arts" },
    secondaryButton: { label: "Download Artist Growth Guide", href: "/resources/arts-guide.pdf" }
  },

  seo: {
    metaTitle: "Arts & Entertainment Solutions | Websites, Ticketing & Marketing",
    metaDescription:
      "We build portfolio websites, ticketing systems, and digital marketing strategies for artists, performers, and entertainment brands.",
    keywords: [
      "artist portfolio website",
      "ticket booking platform",
      "digital marketing for musicians",
      "entertainment website design",
      "sell merchandise online"
    ],
    canonical: "https://merndigital.com/industries/arts-entertainment",
    og: {
      title: "Arts & Entertainment Solutions",
      description: "Websites, ticketing platforms & digital marketing for artists and entertainers.",
      // image:"https://images.unsplash.com/photo-1497032628192-86f99bcd76bc?q=80&w=1200&auto=format&fit=crop"
    },
    twitter: {
      card: "summary_large_image",
      handle: "@merndigital"
    }
  },

  schema: {
    organization: {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "Mern Digital — Arts & Entertainment Solutions",
      url: "https://merndigital.com/industries/arts-entertainment",
      sameAs: ["https://www.linkedin.com/company/merndigital"],
      logo: "https://merndigital.com/logo.png"
    },
    faq: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: [
        {
          "@type": "Question",
          name: "Do you build portfolio websites for artists?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we design professional portfolio websites for individual artists and performers."
          }
        },
        {
          "@type": "Question",
          name: "Can you build event ticketing platforms?",
          acceptedAnswer: {
            "@type": "Answer",
            text: "Yes, we develop integrated ticketing and booking systems for performers and entertainment companies."
          }
        }
      ]
    }
  },

  routing: {
    path: "/industries/arts-entertainment",
    breadcrumbs: {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Industries",
        "item": "https://merndigital.com/industries"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Arts & Entertainment",
        "item":"https://merndigital.com/industries/arts-entertainment"
      }]
    }
  },

  localization: {
    languages: ["en", "hi"],
    default: "en"
  }
}
];
export default industries;